/* eslint-disable no-unused-vars */
/* 费用页签*/
import lodash from 'lodash'
import moment from 'moment'
import { getGridSelected } from '@/utils/agGrid'
import {
  groupChargesForBilling,
  buildDirectInternalBillingPayload,
  buildDirectOverseaBillingPayload,
  resolveOverseaSettlementAgentId
} from './createBillingFromCharges'
import { resolveSpecialChargeBranchId } from './specialChargeDefaults'
import { mergeChargesForProfitTotal } from './chargeProfitTotal'
import { isBusinessSpecialChargeVisible } from './businessSpecialChargeVisibility'
import { loadChargeByUuids, saveBilling, saveOverseaBilling } from '@/api/clearing/billingNative'
import * as ReconciliationUtils from '@/class/cargo/model/utils/ReconciliationUtils'
import { Billing } from '@/class/model/act/Billing'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import AbstractViewManage from '@/class/view/AbstractViewManage'
import LocalStorageUtils from '@/utils/localStorageUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import StrUtils from '@/utils/StrUtils'
import DateUtils from '@/utils/dateUtils'
import {
  getCacheListByKey,
  getObjectByCache,
  getSpecificBasicData,
  getFilterCacheList
} from '@/utils/basicDataCache'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import * as ChargeUtilsForConstant from '@/class/cargo/model/utils/ChargeUtils'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { Charge } from '@/class/model/act/Charge'
import { sortByMultiField, getUuid, deepClone } from '@/utils'
import { User } from '@/class/model/sys/User'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import { Company } from '@/class/model/mdm/Company'
import lang from '@/lang'
import ColumnUtils from '@/utils/ColumnUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { formatNumberToThousands } from '@/utils'
import { ChargeServiceTypeItem } from '@/class/cargo/model/parameters/ChargeServiceTypeItem'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { getContacts, queryContactsByCmpIdx, getContactList } from '@/api/partner/contact'
import { getBankAccountList } from '@/api/bankAccount'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { getTitleByCmpIdxList } from '@/api/partner/title'
import {
  saveAdjustJob,
  batchDeleteCharge,
  modifyChargeLockStatus,
  saveChargeSchemeByJob,
  getJobByUuid,
  syncCrossTenantCharge,
  cancelSyncCrossTenantCharge,
  updateChargeSyncConfirmStatus,
  checkChargeByAdjust,
  getCustomerByRole,
  loadJobAncillaryInformation,
  batchCheckChargeByAdjust,
  businessQuotationFunc,
  syncPayableCharge
} from '@/api/booking/job'
import { TabError } from '@/utils/class/TabError'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { createChangeCharge } from '@/api/clearing/changeCharge'
import { getChangeChargeBpm } from '@/api/clearing/changeChargeBpm'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import {
  chargeSubmit,
  putAuditCharges,
  getActualAmountNoBykeys,
  rejectCharges,
  sendSapMessageByCharge,
  sendHecMessageByCharge,
  updateChargeControlled,
  inviteToConfirmCharge,
  generateChargeByContractNo,
  updateChargeRatesByJob,
  syncChargeToEas,
  syncChargeToLhEas, batchPushLtsFunc, updateDueDate, updateAppendRemark, loadCharges, reconciliationDiffConfirm
} from '@/api/clearing/charge'
import { resolveSpecificField2Value } from '@/utils/basicDataCache'
import { queryEffectiveSurchargeFCL } from '@/api/price/surchargeFcl'
import { PriceFcl2JobChargeUtil } from '@/class/cargo/model/utils/PriceFcl2JobChargeUtil'
import { queryEffectivePodCharge } from '@/api/price/podCharge'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import { PriceLcl2JobChargeUtil } from '@/class/cargo/model/utils/PriceLcl2JobChargeUtil'
import ArchiveEffectUtils from '@/class/cargo/model/utils/ArchiveEffectUtils'
import { queryTitleByCpmIdx, queryTitlesByCmpIdx } from '@/api/partner/title'
import handleClipboard from '@/utils/clipboard'
import BigNumber from 'bignumber.js'
import { syncJobCharge, asyncChargesToImportJob, getChargeList } from '@/api/seaExport/seaExportJob'
import { syncChargeToImportConfirm, syncChargeToExportConfirm, syncImportChargeToExport, pendingChargeSyncRecordCount, syncChargeConfirm, pendingChargeOutSyncRecordCount } from '@/api/booking/job'
import { basicCacheKeys } from '@/utils/cacheConfig'
import CustomLabelUtils from '@/utils/CustomLabelUtils'
import { getUserPrivileges } from '@/api/auth'
import { chargeItemCompatibleLanguage, multiply, sleep, stringToBool } from '@/utils/commonUtil'
import { getManifestGoods } from '@/api/seaExport/manifestInfo'
import { Job } from '@/class/model/booking/Job'
import { getSettlementAgentsByCmpIdx, getSettlementAgentsByCmpIdxList } from '@/api/company'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import { jobChargeVerifySyncYXK } from '@/api/clearing/financeManage'
import * as ChangeChargeConstant from '@/class/cargo/model/parameters/ChangeChargeConstant'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { getApprovingChangeChargeUuid } from '@/api/clearing/changeChargeBpm'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import { isExcludedOffice } from '@/api/sysManage/baseConfig/ExclusionOffice'
import { OFFSET_STATE_BE_HEDGE, OFFSET_STATE_HEDGE } from '@/class/cargo/model/parameters/ChargeConstants'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'

export default class TabChargesHP extends AbstractViewManage {
  _sapSelectChargeList = []

  _submitSapStatus = ''

  _checkAccountId = true

  _inited = false
  /**
   * 提单ID
   */
  _cargoDocUUID = ''

  pf = null
  pl = null

  cacheConfig = null

  chooseSellingRows = []

  chooseCostRows = []

  copyCount = 0

  localCacheData4CompanyMap = new Map() // 公司缓存map-客户-抬头

  constructor(view) {
    super(view)
  }

  get inited() {
    return this._inited
  }

  set inited(value) {
    this._inited = value
  }

  get checkAccountId() {
    return this._checkAccountId
  }

  set checkAccountId(value) {
    this._checkAccountId = value
  }

  get sapSelectChargeList() {
    return this._sapSelectChargeList
  }

  set sapSelectChargeList(value) {
    this._sapSelectChargeList = value
  }

  get submitSapStatus() {
    return this._submitSapStatus
  }

  set submitSapStatus(value) {
    this._submitSapStatus = value
  }

  get cargoDocUUID() {
    return this._cargoDocUUID
  }

  set cargoDocUUID(value) {
    this._cargoDocUUID = value
  }

  get cachePrefix() {
    return this._view.cachePrefix
  }

  /**
   * check enable print
   */
  getPrintEnabled() {
    // return overseaCostDetails && overseaCostDetails.length > 0;
  }
  arStaticOptions() {
    return this._view.config.arSettlementUnitOptional ? this._view.companyFactorySigns : this._view.customerSalesCmpList
  }
  async onCellChange(params) {
    if (params.colDef.field === 'exchangeRate') {
      const exchangeRate = CurrencyUtil.truncateRateByCurrency(params.data.currency, params.data.exchangeRate)
      if (exchangeRate !== params.data.exchangeRate) {
        params.node.setDataValue('exchangeRate', exchangeRate)
        return
      }
    }
    let firstAccountId = false
    if (!params.oldValue) {
      firstAccountId = true
    }
    const newParams = {
      rowIndex: params.node.rowIndex,
      colId: params.column.colId,
      data: params.data,
      field: params.colDef.field,
      value: params.newValue,
      firstAccountId: firstAccountId,
      originalValue: params.oldValue
    }
    await this.chargeGridItemEditEndHandler(newParams)
  }

  initCompanyCmpIdxForCustomerMap(cmpIdx) {
    ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Company, (item) => {
      if (item.active) {
        this._view.currentViewCacheData.companyCmpIdxForCustomerMap.set(item.cmpIdx, item)
        return true
      }
      return false
    })
    // console.log('value()', [...this._view.currentViewCacheData.companyCmpIdxForCustomerMap.values()])
    // console.log(' this._view.currentViewCacheData.companyCmpIdxForCustomerMap', this._view.currentViewCacheData.companyCmpIdxForCustomerMap)
    // return this._view.currentViewCacheData.companyCmpIdxForCustomerMap.get(cmpIdx) || {}
  }

  async created() {
    await cache.load(cacheName.CONFIG)
    this.cacheConfig = cache.config

    // dgOverseaCost.addEventListener(KeyboardEvent.KEY_DOWN, keyCapture, true, -10000);
    // dgOverseaCost.addEventListener(DgEvent.HEADER_CHANGED, dgOverseaCostChangeHandler);

    // modyfied by Deep Lau 2016-04-12
    // dgOverseaCost.addEventListener(DgEvent.ITEM_CHANGED, selectedCostChangeHandler);
    // dgOverseaSelling.addEventListener(DgEvent.ITEM_CHANGED, selectedSellingChangeHandler);

    // dgOverseaSelling.addEventListener(KeyboardEvent.KEY_DOWN, keyCapture, true, -10000);
    // dgOverseaSelling.addEventListener(DgEvent.HEADER_CHANGED, dgOverseaSellingChangeHandler);
    //
    // headConst.addEventListener(MouseEvent.DOUBLE_CLICK, headConstDoubleClickHandler);
    // headOverea.addEventListener(MouseEvent.DOUBLE_CLICK, headOvereaDoubleClickHandler);
    this._view.config.isInputZeroFee = parseInt(cache.config.get('InputZeroFee')) === 1
    this._view.config.isMergeChargeItemSalesView = parseInt(cache.config.get('MergeChargeItemSalesView')) === 1
    // 手动修改费用到期日
    this._view.config.modificationFeeDueDate = parseInt(cache.config.get('ModificationFeeDueDate')) === 1
    this._view.config.isCommittedAllowAddCost = parseInt(cache.config.get('IsCommittedAllowAddCost')) === 1
    // 初始一次，后期留意 相关未知bug
    this._view.tabCost.visible = this.$checkPermission(['tab_Charge_chargeReceivable'])
    this._view.tabSelling.visible = this.$checkPermission(['tab_Charge_chargePayable'])
    this._view.tabTotal.visible = this._view.tabCost.visible && this._view.tabSelling.visible

    this._view.config.showGrossProfit = parseInt(cache.config.get('ShowGrossProfit')) === 1 // 是否显示毛利率,默认显示【1:显示，0:不显示】
    this._view.config.toExoSystemEAS = String(cache.config.get('ToExoSystem')) === 'EAS' // 中床国际EAS
    this._view.config.toExoSystemLHEAS = String(cache.config.get('ToExoSystem')) === 'LHEAS' // 隆和金蝶EAS
    this._view.config.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
    this._view.config.toExoSystemZY = String(cache.config.get('ToExoSystem')) === 'zy' // 中邮
    this._view.config.toExoSystemHC = String(cache.config.get('ToExoSystem')) === 'HC' // 海创
    this._view.config.requireEstimate = parseInt(cache.config.get('saveCharge')) === 1
    this._view.config.isBookingFeeMandatoryAppliedGlobally = parseInt(cache.config.get('isBookingFeeMandatoryAppliedGlobally')) === 1
    this._view.config.isInputChargeBaseOnService = parseInt(cache.config.get('InputChargeBaseOnService')) === 1
    this._view.config.isVerifyChargeServiceType = parseInt(cache.config.get('BookingInputChargeVerifyServiceType')) === 1
    this._view.config._isCalculateExcludingAmount = parseInt(cache.config.get('chargeCalculateAmount')) === 1
    this._view.config._getHBLcWeight = parseInt(cache.config.get('GetHBLcWeight')) === 1
    this._view.config.isChargeSubmitDirect = parseInt(cache.config.get('ChargeSubmitDirect')) === 1
    this._view.config.canUpdateExchangeRate = parseInt(cache.config.get('CanUpdateExchangeRate')) === 1
    this._view.config.chargeModifyType = parseInt(cache.config.get('CheckedJobChargeModifyType'))
    this._view.config.copySlaveCostToMasterCharge = parseInt(cache.config.get('CopySlaveCostToMasterCharge')) === 1
    this._view.config.chargeCommitAll = parseInt(cache.config.get('chargeCommitAll')) === 1
    this._view.config.openSapConfig = parseInt(cache.config.get('openSapConfig')) === 1
    this._view.config.openHecConfig = parseInt(cache.config.get('openHecConfig')) === 1
    this._view.config.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
    // 是否开启费用交叉委托
    this._view.config.openMutualTrustConfig = parseInt(cache.config.get('openMutualTrustConfig'))
    // 是否海出委托转海进演示
    this._view.config.enableEntrustmentSI = parseInt(cache.config.get('enableEntrustmentSI')) === 1
    // 是否空运出口转进口
    this._view.config.consignationImportByAE = parseInt(cache.config.get('consignationImportByAE')) === 1
    // 是否允许编辑通过费用推送接口新增的费用
    this._view.config.isReceivedChargeApiAllowedEdit = parseInt(cache.config.get('isReceivedChargeApiAllowedEdit')) === 1
    // CARGO-34770 销售人员在业务中选择其他公司时，新增的费用的结算公司要属于系统右上角当前分公司
    // 是否开启选择不同操作公司后费用结算公司为当前分公司
    this._view.config.currentOfficeCharge = parseInt(cache.config.get('CurrentOfficeCharge')) === 1
    this._view.privilege.userChargeRole = this.$checkPermission(['role_Charge_userCharge'])
    this._view.privilege.branchChargeRole = this.$checkPermission(['role_Charge_branchCharge'])
    this._view.privilege.departmentChargeRole = this.$checkPermission(['role_Charge_departmentCharge'])
    this._view.privilege.editArDeptCharge = this.$checkPermission(['role_Charge_editArDeptCharge'])
    this._view.privilege.editArAllCharge = this.$checkPermission(['role_Charge_editArAllCharge'])
    this._view.privilege.editApDeptCharge = this.$checkPermission(['role_Charge_editApDeptCharge'])
    this._view.privilege.editApAllCharge = this.$checkPermission(['role_Charge_editApAllCharge'])
    this._view.config.copyCharge = parseInt(cache.config.get('CopySlaveCostToMasterCharge')) === 1

    this._view.privilege.addChange = this.$checkPermission(['button_Charge_addChange'])

    // 显示销售单价hc权限：有此权限时隐藏核销金额、未销金额
    // 独立判断：复数权限接口对管理员也返回真实配置，配置了该权限才隐藏
    const salePriceHcRes = await getUserPrivileges()
    const salePriceHcList = (salePriceHcRes && salePriceHcRes.data) || []
    this._view.privilege.showSalePriceHc = salePriceHcList.some(p => p.category === 'role' && p.shape === 'show_filed' && p.point === 'price')
    // 权限赋值后，延迟刷新表格列定义以确保 gridApi 就绪
    this._view.$nextTick(() => {
      this.refreshSalePriceHcColumnVisibility()
    })

    // 费用审批流程
    this._view.privilege.chargeAuditFlow = parseInt(cache.config.get('chargeAuditFlow')) === 1
    // 受控费用
    this._view.privilege.showControlledProfit = parseInt(cache.config.get('ShowControlledProfit')) === 1

    // 是否显示 邀请确认费用
    this._view.showInviteChargeConfirm = parseInt(cache.config.get('showInviteChargeConfirm')) === 1
    // CARGO-42847 业务菜单费用页签是否批量申请修改操作
    this._view.batchAmendmentFee = parseInt(cache.config.get('Batch_amendment_fee')) === 1
    this._view.config.chargeSchemeIsApproved = Number(this.cacheConfig.get('ChargeSchemeIsApproved')) === 1
    // 专项费用录入功能配置
    this._view.config.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1

    // CARGO-2238，业务详情-费用：特殊费用维护
    this._view.privilege.enableCommission = parseInt(cache.config.get('enableCommission')) === 1

    // CARGO-4980 单价是否含税
    this._view.config.inputIncludingTaxUnitPrice = parseInt(cache.config.get('InputIncludingTaxUnitPrice'))
    // CARGO-28790 提成金额
    this._view.config.showCommissionAmount = parseInt(cache.config.get('ShowCommissionAmount'))
    // CARGO-16706，锦昶定制的费用流程不应直接显示给全平台租户
    this._view.config.applyChangeChargeButton = parseInt(cache.config.get('applyChangeChargeButton')) === 1
    this._view.config.contractBinding = parseInt(cache.config.get('ContractBinding')) === 1
    // this._view.config.shareCharge = parseInt(cache.config.get('ShareCharge')) === 1
    this._view.config.automaticAllocation = parseInt(cache.config.get('AutomaticFeeToSubJob')) === 1
    // CARGO-52436 更改结算对象时，不应该联动修改币种
    this._view.config.currencyChangeBySettlementAccount = parseInt(cache.config.get('currencyChangeBySettlementAccount'))
    if (this._view.privilege.enableCommission) {
      //					showCommonCharge =this.$checkPermission(['button_Charge_showCommonCharge']);
      this._view.privilege.showSpecialCharge = this.$checkPermission(['button_Charge_showSpecialCharge'])
      // CARGO-2619，只有[显示特殊费用]，才显示两个勾选；否则默认[显示普通费用]，不展示勾选
      this._view.privilege.showCommonCharge = this._view.privilege.showSpecialCharge
      this._view.privilege.addSpecialCharge = this.$checkPermission(['button_Charge_addSpecialCharge'])
      this._view.privilege.editSpecialCharge = this.$checkPermission(['button_Charge_editSpecialCharge'])
      this._view.privilege.addSpecialUpdate = this.$checkPermission(['button_Charge_addSpecialUpdate'])
      // 默认是否勾选
      if (this._view.privilege.showCommonCharge) {
        if (LocalStorageUtils.hasConfiguration(this.cachePrefix + 'showCommonCharge')) {
          this._view.config.chkShowCommonChargeSelected = Boolean(LocalStorageUtils.getConfiguration(this.cachePrefix + 'showCommonCharge'))
        } else {
          this._view.config.chkShowCommonChargeSelected = true
        }
      }
      if (this._view.privilege.showSpecialCharge) {
        if (LocalStorageUtils.hasConfiguration(this.cachePrefix + 'showSpecialCharge')) {
          this._view.config.chkShowSpecialChargeSelected = Boolean(LocalStorageUtils.getConfiguration(this.cachePrefix + 'showSpecialCharge'))
        } else {
          this._view.config.chkShowSpecialChargeSelected = true
        }
      }
    }
    // 海创使用特殊费用 新增和修改按钮
    if (this._view.config.isSpecialExpenseEntryFunction) {
      this._view.privilege.addSpecialCharge = this.$checkPermission(['button_Charge_addSpecialCharge'])
      this._view.privilege.editSpecialCharge = this.$checkPermission(['button_Charge_editSpecialCharge'])
      // 商务特殊费用：按钮权限 + 数据范围权限（查看 个人/同组/所有 任一即可见勾选框）
      this._view.privilege.addBusinessSpecialCharge = this.$checkPermission(['button_Charge_addBusinessSpecialCharge'])
      this._view.privilege.editBusinessSpecialCharge = this.$checkPermission(['button_Charge_editBusinessSpecialCharge'])
      this._view.privilege.showBusinessSpecialCharge = this.$checkPermission(['role_businessSpecialCharge_viewUser', 'role_businessSpecialCharge_viewDept', 'role_businessSpecialCharge_viewAll'])
      this._view.privilege.businessSpecialViewUser = this.$checkPermission(['role_businessSpecialCharge_viewUser'])
      this._view.privilege.businessSpecialViewDept = this.$checkPermission(['role_businessSpecialCharge_viewDept'])
      this._view.privilege.businessSpecialViewAll = this.$checkPermission(['role_businessSpecialCharge_viewAll'])
      this._view.privilege.businessSpecialDeleteUser = this.$checkPermission(['role_businessSpecialCharge_deleteUser'])
      this._view.privilege.businessSpecialDeleteDept = this.$checkPermission(['role_businessSpecialCharge_deleteDept'])
      this._view.privilege.businessSpecialDeleteAll = this.$checkPermission(['role_businessSpecialCharge_deleteAll'])
      // 默认勾选显示商务特殊费用（可记忆）
      if (this._view.privilege.showBusinessSpecialCharge) {
        if (LocalStorageUtils.hasConfiguration(this.cachePrefix + 'showBusinessSpecialCharge')) {
          this._view.config.chkShowBusinessSpecialChargeSelected = Boolean(LocalStorageUtils.getConfiguration(this.cachePrefix + 'showBusinessSpecialCharge'))
        } else {
          this._view.config.chkShowBusinessSpecialChargeSelected = true
        }
      }
    }
    if (this._view.config.toExoSystemHC) {
      // 是否有特殊费用
      this._view.privilege.showSpecialCharge = this.$checkPermission(['button_Charge_showSpecialCharge'])
      // 默认勾选特殊费用勾选框
      if (this._view.privilege.showSpecialCharge) {
        if (LocalStorageUtils.hasConfiguration(this.cachePrefix + 'showSpecialCharge')) {
          this._view.config.chkShowSpecialChargeSelected = Boolean(LocalStorageUtils.getConfiguration(this.cachePrefix + 'showSpecialCharge'))
        } else {
          this._view.config.chkShowSpecialChargeSelected = true
        }
      }
    }
    this._view.privilege.queryArAllRole = this.$checkPermission(['role_Charge_queryArAll'])
    this._view.privilege.queryArDeptChargeRole = this.$checkPermission(['role_Charge_queryArDeptCharge'])
    this._view.privilege.queryArUserChargeRole = this.$checkPermission(['role_Charge_queryArUserCharge'])
    this._view.privilege.queryApAllRole = this.$checkPermission(['role_Charge_queryApAll'])
    this._view.privilege.queryApDeptChargeRole = this.$checkPermission(['role_Charge_queryApDeptCharge'])
    this._view.privilege.queryApUserChargeRole = this.$checkPermission(['role_Charge_queryApUserCharge'])
    if (LocalStorageUtilsNew.hasConfiguration(this.cachePrefix + 'showRedCharges')) {
      this._view.checkbox.chkOffset.selected = Boolean(LocalStorageUtilsNew.getConfiguration(this.cachePrefix + 'showRedCharges'))
    } else {
      this._view.checkbox.chkOffset.selected = this._view.isNotAmended
    }
    if (LocalStorageUtilsNew.hasConfiguration(this.cachePrefix + 'showLCLCharges')) {
      this._view.checkbox.chkLcLCharge.selected = Boolean(LocalStorageUtilsNew.getConfiguration(this.cachePrefix + 'showLCLCharges'))
    } else {
      this._view.checkbox.chkLcLCharge.selected = this._view.config.showLCLCharges
    }
    this._view.checkbox.chkInternal.visible = RateUtil.useOrderCenterMode()
    if (this._view.config.toExoSystemZY) {
      // CARGO-44102 中邮：财务审核-增加/修改/删除调整按钮，进行费用录入时，需按“新一代费用组”过滤
      isExcludedOffice({ officeId: this.$store.getters.currentOfficeId }).then(res => {
        this._view.isExcludedOffice = res.data
      })
    }
  }

  // 应收显示列
  getDynamicColumnDefsForCost() {
    // console.log('getDynamicColumnDefsForCost 动态列 执行')
    return [
      {
        headerName: this._view.$t('SeaExport.SequenceNumber'),
        initialWidth: 130,
        checkboxSelection: params => !!params.data,
        rowDrag: this._view.editing,
        colId: 'serialNumber',
        field: 'serialNumber',
        sortable: true,
        suppressMenu: true,
        suppressSizeToFit: true,
        // resizable: false,
        headerCheckboxSelection: true,
        lockVisible: true,
        initialHide: false
      },
      { headerName: this._view.$t('CargoMsg.Cargo_SettleBranchId'), colId: 'branchId', field: 'branchId', initialWidth: 120,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
        },
        initialHide: !RateUtil.useOrderCenterMode(),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_sp13'), colId: 'serviceType', field: 'serviceType', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          const options = ChargeServiceTypeItem.CHARGE_SERVICE_ITEMS
          const curOption = options.find(option => option.code === Number(params.value))
          if (curOption) {
            return curOption.chineseName
          }
          return ''
        },
        initialHide: !this._view.config.isInputChargeBaseOnService,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_chargeItem'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'chargeItemId',
        field: 'chargeItemId',
        initialWidth: 180,
        lockVisible: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        onCellClicked: () => {
          if (this._view.config.toExoSystemZY && !(this._view.job.saleProductCode && this._view.job.fullOrInside) && this._view.editing) {
            this.$message.warning(this._view.$t('Message.NotNullForMapping'))
          }
        },
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            staticOptions: [...this._view.currentViewCacheData.chargeItemSet],
            dataFilterFunction: (item) => {
              return this._view.config.toExoSystemZY && !this._view.isExcludedOffice ? this.getChargeItemFromMappingForZY(item) : true
            },
            tagValue: 'itemId',
            tagName: this._view.language ? 'zhName' : 'enName',
            filterable: true,
            filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
            filterType: 'global',
            customLabel: (item) => this.chargeItemLanguageName(item, this._view.language),
            showCustomLabelInOption: true
          },
          isZero: true
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('Payment.settlementType'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'settlementType',
        field: 'settlementType',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return params.data.normalRuleContactExist ? '' : (params.value ? this._view.$t('CargoMsg.Cargo_Monthly') : this._view.$t('Partners.settlementByBill'))
        },
        initialHide: false
      },
      {
        headerName: this._view.$t('FinanceManage.charge_settleAccountsTo'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'accountId',
        field: 'accountId',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (this.fsSalesPersonalizedControl(params.data)) {
            return '*'
          }
          return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId', true)
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) &&
            !this._view.lockAr && params.data.externalChargeState !== ChargeConstants.EAS_STATE_NO_APPROVE.code && !this.fsSalesPersonalizedControl(params.data),
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            selectType: TYPE_NAMES.basic_data_Company,
            tagValue: 'cmpIdx',
            tagName: 'chineseName',
            methodParams: { active: true },
            autoKey: 'auto_accountId',
            receivable: true,
            dataFilterFunction: (item, inputVal) => {
              if (item.cmpIdx === inputVal) {
                return true
              }
              if (item.ifCustomer) {
                return true
              }
              return false
              // return this._view.config.isInputChargeBaseOnService
            },
            filterable: true,
            staticOptions: this.arStaticOptions()
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      // <!-- 结算部门-->
      {
        headerName: this._view.$t('FinanceManage.charge_settleDepartmentPrefix'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'settleDepartmentPrefix',
        field: 'settleDepartmentPrefix',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          const options = this.getDepartmentsByOfficeUuid(params.data.branchId)
          const curOption = options.find(option => option.jobNoPrefix === params.value)
          if (curOption) {
            return curOption.chineseName
          }
          return ''
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => ({
          selectProps: {
            tagValue: 'jobNoPrefix',
            tagName: 'chineseName',
            staticOptions: this.getClearDepartmentsByOfficeUuid(params.data.branchId),
            filterable: true
          }
        }),
        onCellValueChanged: p => this.onCellChange(p),
        initialHide: true,
        filter: false,
        filterParams: {}
      },
      /* { headerName: this._view.$t('FinanceManage.charge_invoiceHeader'), colId: 'invoiceTitle', field: 'invoiceTitle', initialWidth: 180, initialHide: true },*/
      {
        headerName: this._view.$t('FinanceManage.charge_invoiceHeader'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'invoiceTitle',
        field: 'invoiceTitle',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (this.fsSalesPersonalizedControl(params.data)) {
            return '*'
          }
          return params.value
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) &&
            this.checkEditPersonalArCharge(params.data) && !this._view.lockAr && !this.fsSalesPersonalizedControl(params.data),
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => ({
          selectProps: {
            tagValue: 'invoiceTitle',
            tagName: 'invoiceTitle',
            allowCreate: !this._view.config.arSettlementUnitOptional,
            staticOptions: this._view.getInvoiceTitleList(params.data.accountId),
            filterable: true,
            filterTagNames: ['invoiceTitle'],
            filterType: 'global'
          }
        }),
        onCellValueChanged: p => this.onCellChange(p),
        initialHide: false
      },
      {
        headerName: this._view.$t('FinanceManage.charge_somesticOrInternational'),
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'oversea',
        field: 'oversea',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return stringToBool(params.value) ? this._view.$t('SeaExport.overseas') : this._view.$t('SeaExport.internal')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'code',
            tagName: 'value',
            staticOptions: [{ code: false, value: this._view.$t('SeaExport.internal') }, { code: true, value: this._view.$t('SeaExport.overseas') }]
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },

      {
        headerName: this._view.$t('FinanceManage.charge_SapStatus'), colId: 'sapStatus', field: 'sapStatus', initialWidth: 180,
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ChargeUtils.sapChargeChineseNameFunc(params.data)
        },
        initialHide: true,
        filter: false,
        filterParams: {}
      },
      {
        headerName: this._view.$t('FinanceManage.charge_drawABillOrNot'),
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'needInvoice',
        field: 'needInvoice',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return stringToBool(params.value) ? this._view.$t('SeaExport.Yes') : this._view.$t('SeaExport.No')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'code',
            tagName: 'value',
            staticOptions: [{ code: false, value: this._view.$t('SeaExport.No') }, { code: true, value: this._view.$t('SeaExport.Yes') }]
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        initialHide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_currency'), colId: 'currency', field: 'currency', initialWidth: 180,
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'code',
            tagName: 'code',
            staticOptions: [...this._view.currentViewCacheData.currencySet],
            filterable: true,
            filterTagNames: ['code']
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_exchangeRate'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'exchangeRate',
        field: 'exchangeRate',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00000000')
        },
        editable: (params) => params.data && this._view.editing && this._view.config.canUpdateExchangeRate && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_unit'), colId: 'measure', field: 'measure', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            clearable: false,
            selectType: TYPE_NAMES.basic_data_ChargeUnit,
            tagValue: 'code',
            tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
            methodParams: this.getChargeMeasureFilter(),
            filterable: true
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.adChargeInfo_quantity'), colId: 'quantity', field: 'quantity', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.000')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 3
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_unitPriceIncludeTax'),
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'unitPriceIncludeTax',
        field: 'unitPriceIncludeTax',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return stringToBool(params.value) ? this._view.$t('SeaExport.Yes') : this._view.$t('SeaExport.No')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr && !!this._view.config.inputIncludingTaxUnitPrice,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'code',
            tagName: 'value',
            staticOptions: [{ code: false, value: this._view.$t('SeaExport.No') }, { code: true, value: this._view.$t('SeaExport.Yes') }]
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        initialHide: !this._view.config.inputIncludingTaxUnitPrice,
        suppressColumnsToolPanel: !this._view.config.inputIncludingTaxUnitPrice,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_unitPrice'), colId: 'unitRate', field: 'unitRate', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.000')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 3
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_taxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_taxExcludedPrice'),
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        colId: 'excludingTaxAmount1',
        field: 'excludingTaxAmount',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_taxRate'), colId: 'taxRate', field: 'taxRate', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_taxAmount'), colId: 'taxAmount', field: 'taxAmount', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        // editable: (params) => this.checkEditPersonalArCharge(params.data),
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.apportionedTax'), colId: 'invoiceTax', field: 'invoiceTax', initialWidth: 180, initialHide: true,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return NumberUtils.formatNumber(params.value, 2, true)
        },
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.localAmountLabel,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        field: 'excludingTaxAmountEquivalent',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data) {
            return ''
          }
          return this.conversionRMBLabel(params.data)
        },
        filter: false,
        filterParams: {},
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_localCurrency'), colId: 'localCurrency', field: 'localCurrency', initialWidth: 140,
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        filter: false,
        filterParams: {},
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_auditor'), colId: 'auditor', field: 'auditor', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'userId',
            tagName: 'chineseName',
            staticOptions: [...this._view.currentViewCacheData.user4AuditorSet],
            filterable: true
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_remarks'), colId: 'remarks', field: 'remarks', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        editable: (params) => params.data && this._view.editing && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr ||
            (this._view.editing && this.isRemarkEdit(params) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr),
        cellEditor: 'CargoAgGridCommonTextareaEditor',
        cellEditorParams: {
          onCellLastNodeEnterKeydown: (params) => {
            const { api, rowIndex } = params
            this.addCost().then(() => {
              api.ensureColumnVisible('chargeItemId')
              api.startEditingCell({ rowIndex: rowIndex + 1, colKey: 'chargeItemId' })
            })
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_contactPerson'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'contactPerson',
        field: 'contactPerson',
        initialWidth: 180,
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => {
          const staticOptions = this._view.currentViewCacheData.companyContactPersonMap.get(params.data.accountId)
          return {
            selectProps: {
              tagValue: 'contactPerson',
              tagName: 'contactPerson',
              staticOptions,
              filterable: true,
              filterTagNames: ['contactPerson']
            }
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_relatedBLNo'), colId: 'relatedMbl', field: 'relatedMbl', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridSelectEditor',
        cellEditorParams: (params) => {
          const staticOptionsMbl = [...this._view.currentViewCacheData.mblCargoDocSet]
          const staticOptionsHbl = [...this._view.currentViewCacheData.hblCargoDocSet]
          const optionsMBLValue = {}
          const optionsHBLValue = {}
          if (staticOptionsMbl.length > 0) {
            optionsMBLValue.label = 'MBL No.'
            optionsMBLValue.options = staticOptionsMbl
            optionsMBLValue.filterable = true
          }
          if (staticOptionsHbl.length > 0) {
            optionsHBLValue.label = 'HBL No.'
            optionsHBLValue.options = staticOptionsHbl
            optionsHBLValue.filterable = true
          }
          return {
            isGroup: true,
            selectProps: { clearable: true },
            tagValue: 'chargeRelatedBLNo',
            tagName: 'chargeRelatedBLNo',
            options: [optionsMBLValue, optionsHBLValue]
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this.$t('FinanceManage.charge_relatedContainerNo'), field: 'relationContainerNo', colId: 'relationContainerNo', width: 200, hide: true,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
        cellEditorParams: {
          selectProps: {
            multiple: true,
            tagValue: 'containerNo',
            tagName: 'containerNo',
            staticOptions: [...this._view.currentViewCacheData.containerNoAllSet],
            filterable: true,
            filterType: 'global',
            filterTagNames: ['containerNo']
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_freightCollectOrPrepaid'), colId: 'ppcc', field: 'ppcc', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          const options = [...this._view.currentViewCacheData.paymentTermSet]
          const curOption = options.find(option => option.code === params.value)
          if (curOption) {
            return curOption.name
          }
          return ''
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => {
          const staticOptions = [...this._view.currentViewCacheData.paymentTermSet]
          return {
            selectProps: {
              tagValue: 'code',
              tagName: 'name',
              staticOptions,
              filterable: true,
              filterTagNames: ['name']
            }
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_status'), colId: 'chargeState', field: 'chargeState', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.chargeStateLabFun(Number(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_confirmOrNot'),
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'confirmState',
        field: 'confirmState',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        initialHide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_agent_billNo'), colId: 'agentBillingNo', field: 'agentBillingNo', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_billNo'), colId: 'billNo', field: 'billNo', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_ProvisionedDate'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'provisionedDate',
        field: 'provisionedDate',
        initialWidth: 180,
        valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        initialHide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_invoiceNo'), colId: 'invoiceNo', field: 'invoiceNo', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_invoiceDate'), colId: 'invoiceDate', field: 'invoiceDate', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_agentBillNo'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'counterPartyBillingNo',
        field: 'counterPartyBillingNo',
        initialWidth: 180,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_paymentApplicationNo'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'paymentNo',
        field: 'paymentNo',
        initialWidth: 180,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.arChargeInfo_theAmountOfWriteOffs'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'verifiedAmount',
        field: 'verifiedAmount',
        initialWidth: 180,
        hide: this._view.privilege.showSalePriceHc,
        suppressColumnsToolPanel: this._view.privilege.showSalePriceHc,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        // editable: (params) => this.checkEditPersonalArCharge(params.data),
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('Payment.amountNotWrittenOff'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'chargeUnverifiedAmount',
        field: 'chargeUnverifiedAmount',
        initialWidth: 180,
        hide: this._view.privilege.showSalePriceHc,
        suppressColumnsToolPanel: this._view.privilege.showSalePriceHc,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          // return params.data.amount > 0 ? this._view.$numeral(params.data.amount - params.data.verifiedAmount).format('0.00') : '0.00'
          return this._view.$numeral(params.data.amount - params.data.verifiedAmount).format('0.00')
        },
        filterParams: {},
        filterValueGetter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.data.amount - params.data.verifiedAmount).format('0.00')
        },
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_writeOffDate_ar'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'clearingDate',
        field: 'clearingDate',
        initialWidth: 180,
        valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_payReceiveDate'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'payReceiveDate',
        field: 'payReceiveDate',
        initialWidth: 180,
        valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_financialDate'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'accountingDate',
        field: 'accountingDate',
        initialWidth: 180,
        valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_businessNumber'), colId: 'jobNo', field: 'jobNo', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this.jobNoLabelFunction(params.data)
        },
        filterParams: {},
        filterValueGetter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this.jobNoLabelFunction(params.data)
        }
      },
      {
        headerName: this._view.$t('FinanceManage.charge_creator'), colId: 'createdBy', field: 'createdBy', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        // editable: (params) => this.checkEditPersonalArCharge(params.data),
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'userId',
            tagName: 'chineseName',
            staticOptions: [...this._view.currentViewCacheData.userAllSet],
            filterable: true
          }
        },
        initialHide: !this._view.isAdjust,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_createTime'), colId: 'dateCreated', field: 'dateCreated', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        initialHide: !this._view.isAdjust,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_editor'), colId: 'modifiedBy', field: 'modifiedBy', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        // editable: (params) => this.checkEditPersonalArCharge(params.data),
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'userId',
            tagName: 'chineseName',
            staticOptions: [...this._view.currentViewCacheData.userAllSet],
            filterable: true
          }
        },
        initialHide: !this._view.isAdjust,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_editTime'), colId: 'dateModified', field: 'dateModified', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        initialHide: !this._view.isAdjust,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_actualAmountNo'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'actualAmountNo2',
        field: 'actualAmountNo2',
        initialWidth: 180,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.GenerateVoucher'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'generateVoucher',
        field: 'generateVoucher',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(this.hasGenerateVoucher(params.data))
        }
      },
      {
        headerName: this._view.$t('FinanceManage.charge_shared'), colId: 'shared', field: 'shared', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          const curValue = params.value || (params.data.shareScheme && parseInt(params.data.shareScheme) !== 0)
          return ColumnUtils.booleanLabelFunction(curValue)
        },
        filter: false,
        filterParams: {},
        initialHide: true
      },
      {
        headerName: this._view.$t('SeaExport.LockedStatus'), colId: '', field: 'receivableChargeLockedStatus', initialWidth: 100,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.chargeLockedStatusLabelFunc(this._view.job.receivableChargeLockedStatus)
        }
      },
      {
        headerName: this._view.$t('SeaExport.LockedDate'), colId: '', field: 'receivableChargeLockedDate', initialWidth: 100,
        valueFormatter: (params) => {
          return ColumnUtils.dateTimeLabelFunc(this._view.job.receivableChargeLockedDate)
        }
      },
      {
        headerName: this._view.$t('SeaExport.ChargeSource'), colId: '', field: 'chargeSource', initialWidth: 100,
        valueFormatter: (params) => {
          return ColumnUtils.chargeSourceLabel(params.value)
        },
        initialHide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_AdjustExpenseOrNot'), colId: 'adjustment', field: 'adjustment', initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        filter: false,
        filterParams: {},
        initialHide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ChargeChanger'),
        colId: 'changer',
        field: 'changer',
        initialWidth: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_SettlementAgent'),
        colId: 'settlementAgentId',
        field: 'settlementAgentId',
        initialWidth: 180,
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) &&
            this.checkEditPersonalArCharge(params.data) && !this._view.lockAr && !this.fsSalesPersonalizedControl(params.data),
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => ({
          selectProps: {
            selectType: TYPE_NAMES.basic_data_Company,
            tagValue: 'cmpIdx',
            tagName: 'chineseName',
            methodParams: { auto_accountId: true },
            receivable: true,
            staticOptions: this._view.getSettlementAgentList(params.data.accountId),
            filterable: true
          }
        }),
        initialHide: false,
        valueFormatter: (params) => {
          if (this.fsSalesPersonalizedControl(params.data)) {
            return '*'
          }
          return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId', true)
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ChargeSyncStatus'),
        colId: 'syncStatus',
        field: 'syncStatus',
        initialWidth: 180,
        hide: true,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ChargeSyncConfirmStatus'),
        colId: 'syncConfirmStatus',
        field: 'syncConfirmStatus',
        initialWidth: 180,
        hide: true,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: 'EAS' + this._view.$t('CargoMsg.Cargo_ChargeStatus'), colId: 'externalChargeState',
        field: 'externalChargeState', initialWidth: 180, hide: !this._view.config.toExoSystemEAS,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.easChargeStateLabFun(Number(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: 'EAS' + this._view.$t('FinanceManage.charge_paymentAmount'), colId: 'arPaymentAmount',
        field: 'arPaymentAmount', initialWidth: 180, hide: !this._view.config.toExoSystemEAS,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.000')
        },
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: 'EAS' + this._view.$t('SeaExport.ExternalSerialNumber'), colId: 'externalSerialNumber',
        field: 'externalSerialNumber', initialWidth: 180, hide: !this._view.config.toExoSystemEAS,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ChangeFeeApplicationProgress'), colId: 'changeChargeState',
        field: 'changeChargeState', initialWidth: 180, hide: true,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this.changeChargeStateLabelFormatter(params.data.uuid)
        }
      },
      {
        headerName: this._view.$t('FinanceManage.allocateRelatedBusinesses'),
        colId: 'shareJobNos',
        field: 'shareJobNos',
        initialWidth: 180,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.allocationType'),
        colId: 'shareScheme',
        field: 'shareScheme',
        initialWidth: 100,
        hide: true,
        valueFormatter: params => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this.shareSchemeConvert(params.data)
        }
      },
      {
        headerName: this._view.$t('Billing.DueDateDirty'),
        colId: 'dueDirtyDate',
        field: 'dueDirtyDate',
        initialWidth: 200,
        hide: true,
        valueFormatter: params => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          if (params.value && params.value >= moment().format('YYYY-MM-DD')) {
            return this.$t('Billing.InCalculation')
          } else {
            if (params.data.dueDate) {
              return this.$t('Billing.Calculated')
            } else {
              return this.$t('Billing.NotCalculated')
            }
          }
        }
      },
      {
        headerName: this._view.$t('Billing.DueDate'),
        colId: 'dueDate',
        field: 'dueDate',
        initialWidth: 150,
        hide: true,
        valueFormatter: params => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          let curTime = moment().format('YYYY-MM-DD')
          if (this._view.config.modificationFeeDueDate) {
            // dueDirtyDate 这个字段在手动修改费用到期日后会默认是当前时间，这里应该加上当前时间往后推3小时10分钟，这个时间点和 定时任务一致
            curTime = moment().add(3, 'hours').add(10, 'minutes').format('YYYY-MM-DD HH:mm:ss')
          }
          if (params.value && (!params.data.dueDirtyDate || params.data.dueDirtyDate < curTime)) {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
          return ''
        }
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_AssociatedExpenseID'),
        colId: 'relatedId',
        field: 'relatedId',
        initialWidth: 180,
        valueFormatter: params => {
          if (params.value && params.value > 0) {
            return params.value
          }
          return ''
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ChargeID'),
        colId: 'chargeId',
        field: 'chargeId',
        initialWidth: 180,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_CloudPlatformFeeStatus'),
        colId: 'ltsChargeState',
        field: 'ltsChargeState',
        initialWidth: 100,
        hide: true,
        valueFormatter: params => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.ltsChargeStateFunc(Number(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_CloudPlatformDocumentNumber'),
        colId: 'ltsOrderNo',
        field: 'ltsOrderNo',
        initialWidth: 100,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.commissionAmount'),
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'commissionAmount',
        field: 'commissionAmount',
        initialWidth: 100,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        initialHide: !this._view.config.showCommissionAmount,
        suppressColumnsToolPanel: !this._view.config.showCommissionAmount,
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_CloudPlatformSyncStatus'),
        colId: 'jdyxkSyncStatus',
        field: 'jdyxkSyncStatus',
        initialWidth: 100,
        initialHide: !this._view.config.jinRongExchangeMode,
        valueFormatter: (params) => {
          return ColumnUtils.jdyxkSyncStatusLabelFunc(params.value)
        }
      },
      {
        headerName: this._view.$t('FinanceManage.SyncExceptionReason'),
        colId: 'jdyxkSyncFailReason',
        field: 'jdyxkSyncFailReason',
        initialWidth: 200,
        initialHide: !this._view.config.jinRongExchangeMode
      },
      {
        headerName: this._view.$t('FinanceManage.ChargeHqCurrency'), colId: 'hqCurrency', field: 'hqCurrency', initialWidth: 140, minWidth: 140, initialHide: true,
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        filter: false,
        filterParams: {},
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.ChargeHqRate'), colId: 'hqRate', field: 'hqRate', initialWidth: 150, minWidth: 150, initialHide: true,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00000000')
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ReconciliationStatus'), colId: 'reconciliationState', field: 'reconciliationState', initialWidth: 120,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.reconciliationStateLabelFunc(Number(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_FinancialRemarks'),
        field: 'financialRemarks',
        initialWidth: 200,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this.$t('Billing.InquiryLetterRemark'),
        field: 'confirmationLetterRemarks',
        initialWidth: 200,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_CostPushStatus'),
        colId: 'wkExternalChargeState',
        field: 'wkExternalChargeState',
        width: 100,
        hide: true,
        cellRenderer: (params) => {
          if (params.data) {
            return ColumnUtils.chargePushStatusLabelFunc(Number(params.data.externalChargeState))
          }
          return ''
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_AutoGenerateEnabled'),
        colId: 'autoGenerated',
        field: 'autoGenerated',
        initialWidth: 180,
        hide: true,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        enableRowGroup: true
      }
    ]
  }

  // 应收合计显示列
  getSumColumnDefsCost() {
    const cols = [
      {
        field: 'quantity',
        getValue: data => data.quantity,
        format: value => this._view.$numeral(value).format('0.000')
      },
      {
        field: 'amount',
        getValue: data => data.amount,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'excludingTaxAmount1',
        getValue: data => data.excludingTaxAmount,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'taxAmount',
        getValue: data => data.taxAmount,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'excludingTaxAmount',
        getValue: data => Number(this.conversionRMBLabel(data).replace(/,/g, '')) || 0,
        format: value => formatNumberToThousands(NumberUtils.formatNumber(value, 2, true), 2).toString()
      },
      {
        field: 'verifiedAmount',
        getValue: data => data.verifiedAmount,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'chargeUnverifiedAmount',
        getValue: data => data.amount - data.verifiedAmount,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'invoiceTax',
        getValue: data => data.invoiceTax,
        format: value => NumberUtils.formatNumber(value, 2, true)
      },
      {
        field: 'arPaymentAmount',
        getValue: data => data.arPaymentAmount,
        format: value => this._view.$numeral(value).format('0.000')
      },
      {
        field: 'commissionAmount',
        getValue: data => data,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'whtTaxAmount',
        getValue: data => Number(this.whtTaxAmountConversionRMBLabel(data).replace(/,/g, '')) || 0,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'notWhtAmount',
        getValue: data => ColumnUtils.notWhtAmountLabel(data),
        format: value => this._view.$numeral(value).format('0.00')
      }
    ]
    if (this._view.privilege.showSalePriceHc) {
      return cols.filter(c => c.field !== 'verifiedAmount' && c.field !== 'chargeUnverifiedAmount')
    }
    return cols
  }

  refreshSalePriceHcColumnVisibility() {
    const showSalePriceHc = this._view.privilege.showSalePriceHc
    const grids = [
      this._view.tabCost && this._view.tabCost.grid,
      this._view.tabSelling && this._view.tabSelling.grid,
      this._view.tabSellingMerge && this._view.tabSellingMerge.grid
    ].filter(Boolean)

    grids.forEach(grid => {
      if (grid.gridApi) {
        const columnApi = grid.gridApi.columnApi || grid.gridOptions.columnApi
        if (columnApi) {
          columnApi.setColumnVisible('verifiedAmount', !showSalePriceHc)
          columnApi.setColumnVisible('chargeUnverifiedAmount', !showSalePriceHc)
        }
      }
    })
  }

  chargeItemLanguageName(item, viewLanguage) {
    let languageName = item.zhName
    if (!viewLanguage) {
      // 费用项uuuid
      const uuid = item.uuid
      // 根据费用项uuid获取对应的语言配置列表
      const chargeItemLanguages = getFilterCacheList(TYPE_NAMES.basic_data_ChargeItemLanguage, (item) => {
        return item.chargeItemUuid === uuid
      })
      const office = this.$store.getters.currentOffice
      chargeItemLanguages.forEach(chargeItemLanguage => {
        if (office.region && office.region === chargeItemLanguage.regionCode) {
          languageName = chargeItemLanguage.chargeLanguage
        }
      })
    }
    return viewLanguage ? `${item.zhName}[${item.enName}]` : `${item.enName}[${languageName}]`
  }

  // WHT应收显示列
  getWhtColumnDefsForCost() {
    return [
      {
        headerName: this._view.$t('FinanceManage.charge_whtTaxRate'), field: 'whtTaxRate', width: 100,
        headerClass: 'ag-header-cell-right',
        hide: !this._view.showWhtTax,
        suppressColumnsToolPanel: !this._view.showWhtTax,
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr &&
          params.data.chargeState !== ChargeConstants.STATE_COMMITED.code && params.data.chargeState !== ChargeConstants.STATE_VERIFIED.code,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: p => this.onCellChange(p)
      },
      {
        headerName: this._view.$t('FinanceManage.charge_whtTaxAmount'), field: 'whtTaxAmount', width: 100,
        headerClass: 'ag-header-cell-right',
        hide: !this._view.showWhtTax,
        suppressColumnsToolPanel: !this._view.showWhtTax,
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this.whtTaxAmountConversionRMBLabel(params.data)
        },
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_notWhtAmount'), field: 'notWhtAmount', width: 100,
        headerClass: 'ag-header-cell-right',
        hide: !this._view.showWhtTax,
        suppressColumnsToolPanel: !this._view.showWhtTax,
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          const notWhtAmount = ColumnUtils.notWhtAmountLabel(params.data)
          return this._view.$numeral(notWhtAmount).format('0.00')
        },
        summaryMode: 'sum'
      }
    ]
  }

  // 费用项目过滤
  getChargeItemFilter(cost) {
    let lob = this._view.job.lob
    if (this._view.job.fba) {
      lob = ('FBA_' + lob)
    }
    let filter = {}
    switch (lob) {
      case 'SE':
        filter = { seaExport: true, active: true }
        break
      case 'SI':
        filter = { seaImport: true, active: true }
        break
      case 'AE':
        filter = { airExport: true, active: true }
        break
      case 'AI':
        filter = { airImport: true, active: true }
        break
      case 'RE':
      case 'RI':
        filter = { railwayExport: true, active: true }
        break
      case 'FBA_SE':
        filter = { fbaSea: true, active: true }
        break
      case 'FBA_AE':
        filter = { fbaAir: true, active: true }
        break
      case 'FBA_RE':
        filter = { fbaRailway: true, active: true }
        break
      case 'IE':
        filter = { integratedJob: true, active: true }
        break
      default:
    }
    if (cost) {
      if (!this._view.privilege.isCostControlled) {
        filter.controlled = false
      }
    } else {
      if (!this._view.privilege.isControlled) {
        filter.controlled = false
      }
    }
    if (this._view.config.isSpecialExpenseEntryFunction) {
      filter.specialExpenseMarker = false
    }
    return filter
  }
  // 中邮费用项目根据费用映射过滤
  getChargeItemFromMappingForZY(chargeItem) {
    const saleProductCode = this._view.job.saleProductCode
    const fullOrInside = this._view.job.fullOrInside
    const chargeMappingResult = getFilterCacheList(TYPE_NAMES.basic_data_ChargeMapping, (mapping) => {
      return mapping.saleProductCode === saleProductCode && mapping.fullOrInside === fullOrInside
    })
    for (const mapping of chargeMappingResult) {
      if (chargeItem.itemId === mapping.chargeItemId) {
        return true
      }
    }
    return false
  }
  // 费用单位过滤
  getChargeMeasureFilter() {
    if (this._view.job.lob === 'AE' || this._view.job.lob === 'AI') {
      return { unit: true, airFreight: true }
    } else {
      return { unit: true, seaFreight: true }
    }
  }
  // 应付合并显示列
  getDynamicColumnDefsForSellingMerge() {
    return [
      {
        headerName: this._view.$t('SeaExport.SequenceNumber'),
        initialWidth: 130,
        checkboxSelection: params => !!params.data,
        rowDrag: false,
        colId: 'serialNumber',
        field: 'serialNumber',
        sortable: true,
        suppressMenu: true,
        suppressSizeToFit: true,
        headerCheckboxSelection: true,
        lockVisible: true,
        initialHide: false
      },
      {
        headerName: this._view.$t('FinanceManage.charge_chargeItem'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'chargeItemId',
        field: 'chargeItemId',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
        },
        editable: false,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            staticOptions: [...this._view.currentViewCacheData.chargeItemSet],
            tagValue: 'itemId',
            tagName: this._view.language ? 'zhName' : 'enName',
            filterable: true,
            filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
            filterType: 'global',
            customLabel: (item) => this.chargeItemLanguageName(item, this._view.language),
            showCustomLabelInOption: true
          }
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_currency'), colId: 'currency', field: 'currency', initialWidth: 180,
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        editable: false,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'code',
            tagName: 'code',
            staticOptions: [...this._view.currentViewCacheData.currencySet],
            filterable: true,
            filterTagNames: ['code']
          }
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.adChargeInfo_quantity'), colId: 'quantity', field: 'quantity', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.000')
        },
        editable: false,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 3
          }
        },
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_unitPrice'), colId: 'unitRate', field: 'unitRate', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.000')
        },
        editable: false,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 3
          }
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_taxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        editable: false,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        enableRowGroup: true,
        summaryMode: 'sum'
      }
    ]
  }

  // 应付显示列
  getDynamicColumnDefsForSelling() {
    // console.log('dynamicColumnDefsForSelling 动态列 执行')
    return [
      {
        headerName: this._view.$t('SeaExport.SequenceNumber'),
        initialWidth: 130,
        checkboxSelection: params => !!params.data,
        rowDrag: this._view.editing,
        colId: 'serialNumber',
        field: 'serialNumber',
        sortable: true,
        suppressMenu: true,
        suppressSizeToFit: true,
        // resizable: false,
        headerCheckboxSelection: true,
        lockVisible: true,
        initialHide: false
      },
      { headerName: this._view.$t('CargoMsg.Cargo_SettleBranchId'), colId: 'branchId', field: 'branchId', initialWidth: 120,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
        },
        initialHide: !RateUtil.useOrderCenterMode(),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_sp13'), colId: 'serviceType', field: 'serviceType', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          const options = ChargeServiceTypeItem.CHARGE_SERVICE_ITEMS
          const curOption = options.find(option => option.code === Number(params.value))
          if (curOption) {
            return curOption.chineseName
          }
          return ''
        },
        initialHide: !this._view.config.isInputChargeBaseOnService,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_chargeItem'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'chargeItemId',
        field: 'chargeItemId',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            staticOptions: [...this._view.currentViewCacheData.chargeItemSet],
            tagValue: 'itemId',
            tagName: this._view.language ? 'zhName' : 'enName',
            filterable: true,
            filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
            filterType: 'global',
            customLabel: (item) => this.chargeItemLanguageName(item, this._view.language),
            showCustomLabelInOption: true
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        // 商务特殊费用标识列（应付栏）
        headerName: this._view.$t('FinanceManage.charge_businessSpecialFlag'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'businessSpecial',
        field: 'businessSpecial',
        initialWidth: 100,
        valueFormatter: (params) => {
          if (!params.data) {
            return ''
          }
          return params.value ? this._view.$t('CargoMsg.Cargo_Yes') : ''
        },
        initialHide: false,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('Payment.settlementType'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'settlementType',
        field: 'settlementType',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return stringToBool(params.value) ? this._view.$t('CargoMsg.Cargo_Monthly') : this._view.$t('Partners.settlementByBill')
        },
        initialHide: false,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_settleAccountsTo'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'accountId',
        field: 'accountId',
        initialWidth: 180,
        valueFormatter: (params) => {
          return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId', false)
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp && params.data.externalChargeState !== ChargeConstants.EAS_STATE_NO_APPROVE.code,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            selectType: TYPE_NAMES.basic_data_Company,
            tagValue: 'cmpIdx',
            tagName: 'chineseName',
            methodParams: { active: true },
            autoKey: 'auto_accountId',
            receivable: false,
            dataFilterFunction: (item, inputVal) => {
              if (item.cmpIdx === inputVal) {
                return true
              }
              if (item.ifSupplier) {
                return true
              }
              return false
              // return this._view.config.isInputChargeBaseOnService
            },
            filterable: true
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      // <!-- 结算部门-->
      {
        headerName: this._view.$t('FinanceManage.charge_settleDepartmentPrefix'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'settleDepartmentPrefix',
        field: 'settleDepartmentPrefix',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          const options = this.getDepartmentsByOfficeUuid(params.data.branchId)
          const curOption = options.find(option => option.jobNoPrefix === params.value)
          if (curOption) {
            return curOption.chineseName
          }
          return ''
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => ({
          selectProps: {
            tagValue: 'jobNoPrefix',
            tagName: 'chineseName',
            staticOptions: this.getClearDepartmentsByOfficeUuid(params.data.branchId),
            filterable: true
          }
        }),
        onCellValueChanged: p => this.onCellChange(p),
        initialHide: true
      },
      // { headerName: this._view.$t('FinanceManage.charge_invoiceHeader'), colId: 'invoiceTitle', field: 'invoiceTitle', initialWidth: 180, initialHide: true },
      {
        headerName: this._view.$t('FinanceManage.charge_invoiceHeader'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'invoiceTitle',
        field: 'invoiceTitle',
        initialWidth: 180,
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => ({
          selectProps: {
            tagValue: 'invoiceTitle',
            tagName: 'invoiceTitle',
            allowCreate: true,
            staticOptions: this._view.getInvoiceTitleList(params.data.accountId),
            filterable: true,
            filterTagNames: ['invoiceTitle'],
            filterType: 'global'
          }
        }),
        onCellValueChanged: p => this.onCellChange(p),
        initialHide: false,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_somesticOrInternational'),
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'oversea',
        field: 'oversea',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return stringToBool(params.value) ? this._view.$t('SeaExport.overseas') : this._view.$t('SeaExport.internal')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'code',
            tagName: 'value',
            staticOptions: [{ code: false, value: this._view.$t('SeaExport.internal') }, { code: true, value: this._view.$t('SeaExport.overseas') }]
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },

      {
        headerName: this._view.$t('FinanceManage.charge_SapStatus'), colId: 'sapStatus', field: 'sapStatus', initialWidth: 180,
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ChargeUtils.sapChargeChineseNameFunc(params.data)
        },
        initialHide: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_drawABillOrNot'),
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'needInvoice',
        field: 'needInvoice',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return stringToBool(params.value) ? this._view.$t('SeaExport.Yes') : this._view.$t('SeaExport.No')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'code',
            tagName: 'value',
            staticOptions: [{ code: false, value: this._view.$t('SeaExport.No') }, { code: true, value: this._view.$t('SeaExport.Yes') }]
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        initialHide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_currency'), colId: 'currency', field: 'currency', initialWidth: 180,
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'code',
            tagName: 'code',
            staticOptions: [...this._view.currentViewCacheData.currencySet],
            filterable: true,
            filterTagNames: ['code']
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_exchangeRate'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'exchangeRate',
        field: 'exchangeRate',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00000000')
        },
        editable: (params) => params.data && this._view.editing && this._view.config.canUpdateExchangeRate && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_unit'), colId: 'measure', field: 'measure', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            clearable: false,
            selectType: TYPE_NAMES.basic_data_ChargeUnit,
            tagValue: 'code',
            tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
            methodParams: this.getChargeMeasureFilter(),
            filterable: true
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.adChargeInfo_quantity'), colId: 'quantity', field: 'quantity', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.000')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 3
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_unitPriceIncludeTax'),
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'unitPriceIncludeTax',
        field: 'unitPriceIncludeTax',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return stringToBool(params.value) ? this._view.$t('SeaExport.Yes') : this._view.$t('SeaExport.No')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp && !!this._view.config.inputIncludingTaxUnitPrice,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'code',
            tagName: 'value',
            staticOptions: [{ code: false, value: this._view.$t('SeaExport.No') }, { code: true, value: this._view.$t('SeaExport.Yes') }],
            filterable: true
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        initialHide: !this._view.config.inputIncludingTaxUnitPrice,
        suppressColumnsToolPanel: !this._view.config.inputIncludingTaxUnitPrice,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_unitPrice'), colId: 'unitRate', field: 'unitRate', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.000')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 3
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_taxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_taxExcludedPrice'),
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        colId: 'excludingTaxAmount1',
        field: 'excludingTaxAmount',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_taxRate'), colId: 'taxRate', field: 'taxRate', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_taxAmount'), colId: 'taxAmount', field: 'taxAmount', initialWidth: 180,
        headerClass: 'ag-header-cell-right',
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        // editable: (params) => this.checkEditPersonalApCharge(params.data),
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.apportionedTax'), colId: 'invoiceTax', field: 'invoiceTax', initialWidth: 180, initialHide: true,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return NumberUtils.formatNumber(params.value, 2, true)
        },
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.localAmountLabel,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        field: 'excludingTaxAmountEquivalent',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data) {
            return ''
          }
          return this.conversionRMBLabel(params.data)
        },
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_localCurrency'), colId: 'localCurrency', field: 'localCurrency', initialWidth: 140,
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        filter: false,
        filterParams: {},
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_auditor'), colId: 'auditor', field: 'auditor', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'userId',
            tagName: 'chineseName',
            staticOptions: [...this._view.currentViewCacheData.user4AuditorSet],
            filterable: true
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_remarks'), colId: 'remarks', field: 'remarks', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        editable: (params) => params.data && this._view.editing && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp ||
            (this._view.editing && this.isRemarkEdit(params) && this.checkEditPersonalArCharge(params.data) && !this._view.lockAr),
        cellEditor: 'CargoAgGridCommonTextareaEditor',
        cellEditorParams: {
          onCellLastNodeEnterKeydown: (params) => {
            const { api, rowIndex } = params
            this.addSelling().then(() => {
              api.ensureColumnVisible('chargeItemId')
              api.startEditingCell({ rowIndex: rowIndex + 1, colKey: 'chargeItemId' })
            })
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_contactPerson'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'contactPerson',
        field: 'contactPerson',
        initialWidth: 180,
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => {
          const staticOptions = this._view.currentViewCacheData.companyContactPersonMap.get(params.data.accountId)
          return {
            selectProps: {
              tagValue: 'contactPerson',
              tagName: 'contactPerson',
              staticOptions,
              filterable: true,
              filterTagNames: ['contactPerson']
            }
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_relatedBLNo'), colId: 'relatedMbl', field: 'relatedMbl', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridSelectEditor',
        cellEditorParams: (params) => {
          const staticOptionsMbl = [...this._view.currentViewCacheData.mblCargoDocSet]
          const staticOptionsHbl = [...this._view.currentViewCacheData.hblCargoDocSet]
          const optionsMBLValue = {}
          const optionsHBLValue = {}
          if (staticOptionsMbl.length > 0) {
            optionsMBLValue.label = 'MBL No.'
            optionsMBLValue.options = staticOptionsMbl
            optionsMBLValue.filterable = true
          }
          if (staticOptionsHbl.length > 0) {
            optionsHBLValue.label = 'HBL No.'
            optionsHBLValue.options = staticOptionsHbl
            optionsHBLValue.filterable = true
          }
          return {
            isGroup: true,
            selectProps: { clearable: true },
            tagValue: 'chargeRelatedBLNo',
            tagName: 'chargeRelatedBLNo',
            options: [optionsMBLValue, optionsHBLValue]
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this.$t('FinanceManage.charge_relatedContainerNo'), field: 'relationContainerNo', colId: 'relationContainerNo', width: 200, hide: true,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
        cellEditorParams: {
          selectProps: {
            multiple: true,
            tagValue: 'containerNo',
            tagName: 'containerNo',
            staticOptions: [...this._view.currentViewCacheData.containerNoAllSet],
            filterable: true,
            filterType: 'global',
            filterTagNames: ['containerNo']
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_freightCollectOrPrepaid'), colId: 'ppcc', field: 'ppcc', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          const options = [...this._view.currentViewCacheData.paymentTermSet]
          const curOption = options.find(option => option.code === params.value)
          if (curOption) {
            return curOption.name
          }
          return ''
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => {
          const staticOptions = [...this._view.currentViewCacheData.paymentTermSet]
          return {
            selectProps: {
              tagValue: 'code',
              tagName: 'name',
              staticOptions,
              filterable: true,
              filterTagNames: ['name']
            }
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_status'), colId: 'chargeState', field: 'chargeState', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.chargeStateLabFun(Number(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_confirmOrNot'),
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'confirmState',
        field: 'confirmState',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        initialHide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_agent_billNo'), colId: 'agentBillingNo', field: 'agentBillingNo', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_billNo'), colId: 'billNo', field: 'billNo', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_ProvisionedDate'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'provisionedDate',
        field: 'provisionedDate',
        initialWidth: 180,
        valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        initialHide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_invoiceNo'), colId: 'invoiceNo', field: 'invoiceNo', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_invoiceDate'), colId: 'invoiceDate', field: 'invoiceDate', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_agentBillNo'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'counterPartyBillingNo',
        field: 'counterPartyBillingNo',
        initialWidth: 180,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_paymentApplicationNo'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'paymentNo',
        field: 'paymentNo',
        initialWidth: 180,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.apChargeInfo_theAmountOfWriteOffs'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'verifiedAmount',
        field: 'verifiedAmount',
        initialWidth: 180,
        hide: this._view.privilege.showSalePriceHc,
        suppressColumnsToolPanel: this._view.privilege.showSalePriceHc,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        // editable: (params) => this.checkEditPersonalApCharge(params.data),
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('Payment.amountNotWrittenOff'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'chargeUnverifiedAmount',
        field: 'chargeUnverifiedAmount',
        initialWidth: 180,
        hide: this._view.privilege.showSalePriceHc,
        suppressColumnsToolPanel: this._view.privilege.showSalePriceHc,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          // return params.data.amount > 0 ? this._view.$numeral(params.data.amount - params.data.verifiedAmount).format('0.00') : '0.00'
          return this._view.$numeral(params.data.amount - params.data.verifiedAmount).format('0.00')
        },
        filterParams: {},
        filterValueGetter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.data.amount - params.data.verifiedAmount).format('0.00')
        },
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_writeOffDate_ap'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'clearingDate',
        field: 'clearingDate',
        initialWidth: 180,
        valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_payReceiveDate'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'payReceiveDate',
        field: 'payReceiveDate',
        initialWidth: 180,
        valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_financialDate'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'accountingDate',
        field: 'accountingDate',
        initialWidth: 180,
        valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_businessNumber'), colId: 'jobNo', field: 'jobNo', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this.jobNoLabelFunction(params.data)
        },
        filterParams: {},
        filterValueGetter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this.jobNoLabelFunction(params.data)
        }
      },
      {
        headerName: this._view.$t('FinanceManage.charge_creator'), colId: 'createdBy', field: 'createdBy', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        // editable: (params) => this.checkEditPersonalApCharge(params.data),
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'userId',
            tagName: 'chineseName',
            staticOptions: [...this._view.currentViewCacheData.userAllSet],
            filterable: true
          }
        },
        initialHide: !this._view.isAdjust,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_createTime'), colId: 'dateCreated', field: 'dateCreated', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        initialHide: !this._view.isAdjust,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_editor'), colId: 'modifiedBy', field: 'modifiedBy', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        // editable: (params) => this.checkEditPersonalApCharge(params.data),
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'userId',
            tagName: 'chineseName',
            staticOptions: [...this._view.currentViewCacheData.userAllSet],
            filterable: true
          }
        },
        initialHide: !this._view.isAdjust,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_editTime'), colId: 'dateModified', field: 'dateModified', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        initialHide: !this._view.isAdjust,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_actualAmountNo'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'actualAmountNo2',
        field: 'actualAmountNo2',
        initialWidth: 180,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.GenerateVoucher'),
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        colId: 'generateVoucher',
        field: 'generateVoucher',
        initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(this.hasGenerateVoucher(params.data))
        }
      },
      {
        headerName: this._view.$t('FinanceManage.charge_shared'), colId: 'shared', field: 'shared', initialWidth: 180,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          const curValue = params.value || (params.data.shareScheme && parseInt(params.data.shareScheme) !== 0)
          return ColumnUtils.booleanLabelFunction(curValue)
        },
        initialHide: true
      },
      {
        headerName: this._view.$t('SeaExport.LockedStatus'), colId: '', field: 'payableChargeLockedStatus', initialWidth: 100,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.chargeLockedStatusLabelFunc(this._view.job.payableChargeLockedStatus)
        }
      },
      {
        headerName: this._view.$t('SeaExport.LockedDate'), colId: '', field: 'payableChargeLockedDate', initialWidth: 100,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.dateTimeLabelFunc(this._view.job.payableChargeLockedDate)
        }
      },
      {
        headerName: this._view.$t('SeaExport.ChargeSource'), colId: '', field: 'chargeSource', initialWidth: 100,
        valueFormatter: (params) => {
          return ColumnUtils.chargeSourceLabel(Number(params.value))
        },
        initialHide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_AdjustExpenseOrNot'), colId: 'adjustment', field: 'adjustment', initialWidth: 180,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        filter: false,
        filterParams: {},
        initialHide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ChargeChanger'),
        colId: 'changer',
        field: 'changer',
        initialWidth: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_SettlementAgent'),
        colId: 'settlementAgentId',
        field: 'settlementAgentId',
        initialWidth: 180,
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: (params) => ({
          selectProps: {
            selectType: TYPE_NAMES.basic_data_Company,
            tagValue: 'cmpIdx',
            tagName: 'chineseName',
            methodParams: { auto_accountId: true },
            receivable: false,
            staticOptions: this._view.getSettlementAgentList(params.data.accountId),
            filterable: true
          }
        }),
        initialHide: false,
        valueFormatter: (params) => {
          return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId', false)
        },
        onCellValueChanged: p => this.onCellChange(p),
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ChargeSyncStatus'),
        colId: 'syncStatus',
        field: 'syncStatus',
        initialWidth: 180,
        hide: true,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ChargeSyncConfirmStatus'),
        colId: 'syncConfirmStatus',
        field: 'syncConfirmStatus',
        initialWidth: 180,
        hide: true,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: 'EAS' + this._view.$t('CargoMsg.Cargo_ChargeStatus'), colId: 'externalChargeState',
        field: 'externalChargeState', initialWidth: 180, hide: !this._view.config.toExoSystemEAS,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.easChargeStateLabFun(Number(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: 'EAS' + this._view.$t('FinanceManage.charge_paymentAmount'), colId: 'arPaymentAmount',
        field: 'arPaymentAmount', initialWidth: 180, hide: !this._view.config.toExoSystemEAS,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.000')
        },
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: 'EAS' + this._view.$t('SeaExport.ExternalSerialNumber'), colId: 'externalSerialNumber',
        field: 'externalSerialNumber', initialWidth: 180, hide: !this._view.config.toExoSystemEAS,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ChangeFeeApplicationProgress'), colId: 'changeChargeState',
        field: 'changeChargeState', initialWidth: 180, hide: true,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this.changeChargeStateLabelFormatter(params.data.uuid)
        }
      },
      {
        headerName: this._view.$t('FinanceManage.allocateRelatedBusinesses'),
        colId: 'shareJobNos',
        field: 'shareJobNos',
        initialWidth: 180,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.allocationType'),
        colId: 'shareScheme',
        field: 'shareScheme',
        initialWidth: 100,
        hide: true,
        valueFormatter: params => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this.shareSchemeConvert(params.data)
        }
      },
      {
        headerName: this._view.$t('Billing.DueDateDirty'),
        colId: 'dueDirtyDate',
        field: 'dueDirtyDate',
        initialWidth: 200,
        hide: true,
        valueFormatter: params => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          if (params.value && params.value >= moment().format('YYYY-MM-DD')) {
            return this.$t('Billing.InCalculation')
          } else {
            if (params.data.dueDate) {
              return this.$t('Billing.Calculated')
            } else {
              return this.$t('Billing.NotCalculated')
            }
          }
        }
      },
      {
        headerName: this._view.$t('Billing.DueDate'),
        colId: 'dueDate',
        field: 'dueDate',
        initialWidth: 150,
        hide: true,
        valueFormatter: params => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          let curTime = moment().format('YYYY-MM-DD')
          if (this._view.config.modificationFeeDueDate) {
            // dueDirtyDate 这个字段在手动修改费用到期日后会默认是当前时间，这里应该加上当前时间往后推3小时10分钟，这个时间点和 定时任务一致
            curTime = moment().add(3, 'hours').add(10, 'minutes').format('YYYY-MM-DD HH:mm:ss')
          }
          if (params.value && (!params.data.dueDirtyDate || params.data.dueDirtyDate < curTime)) {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
          return ''
        }
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_AssociatedExpenseID'),
        colId: 'relatedId',
        field: 'relatedId',
        initialWidth: 180,
        valueFormatter: params => {
          if (params.value && params.value > 0) {
            return params.value
          }
          return ''
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ChargeID'),
        colId: 'chargeId',
        field: 'chargeId',
        initialWidth: 180,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_CloudPlatformFeeStatus'),
        colId: 'ltsChargeState',
        field: 'ltsChargeState',
        initialWidth: 100,
        hide: true,
        valueFormatter: params => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.ltsChargeStateFunc(Number(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_CloudPlatformDocumentNumber'),
        colId: 'ltsOrderNo',
        field: 'ltsOrderNo',
        initialWidth: 100,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.commissionAmount'),
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'commissionAmount',
        field: 'commissionAmount',
        initialWidth: 100,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        initialHide: !this._view.config.showCommissionAmount,
        suppressColumnsToolPanel: !this._view.config.showCommissionAmount,
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_CloudPlatformSyncStatus'),
        colId: 'jdyxkSyncStatus',
        field: 'jdyxkSyncStatus',
        initialWidth: 100,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.jdyxkSyncStatusLabelFunc(params.value)
        }
      },
      {
        headerName: this._view.$t('FinanceManage.SyncExceptionReason'),
        colId: 'jdyxkSyncFailReason',
        field: 'jdyxkSyncFailReason',
        initialWidth: 200,
        hide: true
      },
      {
        headerName: this._view.$t('FinanceManage.ChargeHqCurrency'), colId: 'hqCurrency', field: 'hqCurrency', initialWidth: 140, minWidth: 140, initialHide: true,
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        filter: false,
        filterParams: {},
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.ChargeHqRate'), colId: 'hqRate', field: 'hqRate', initialWidth: 150, minWidth: 150, initialHide: true,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00000000')
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.CostType'),
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        colId: 'costControlType',
        field: 'costControlType',
        initialWidth: 180,
        valueFormatter: (params) => {
          return ColumnUtils.resolveCostType(params.value, this._view.language ? 'chineseName' : 'englishName')
        },
        editable: (params) => params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: {
          selectProps: {
            tagValue: 'code',
            tagName: this._view.language ? 'chineseName' : 'englishName',
            staticOptions: ChargeConstants.CHARGE_DROP_COST_TYPES,
            filterable: true
          }
        },
        onCellValueChanged: p => this.onCellChange(p),
        initialHide: false,
        suppressColumnsToolPanel: false,
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('CargoMsg.Cargo_ReconciliationStatus'), colId: 'reconciliationState', field: 'reconciliationState', initialWidth: 120,
        headerClass: 'ag-header-cell-left',
        cellStyle: {
          textAlign: 'left'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.reconciliationStateLabelFunc(Number(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_FinancialRemarks'),
        field: 'financialRemarks',
        initialWidth: 200,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this.$t('Billing.InquiryLetterRemark'),
        field: 'confirmationLetterRemarks',
        initialWidth: 200,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_CostPushStatus'),
        colId: 'wkExternalChargeState',
        field: 'wkExternalChargeState',
        width: 100,
        hide: true,
        cellRenderer: (params) => {
          if (params.data) {
            return ColumnUtils.chargePushStatusLabelFunc(Number(params.data.externalChargeState))
          }
          return ''
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_AutoGenerateEnabled'),
        colId: 'autoGenerated',
        field: 'autoGenerated',
        initialWidth: 180,
        hide: true,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_BusinessQuotationAmount'),
        colId: 'businessQuotationAmount',
        field: 'businessQuotationAmount',
        initialWidth: 180,
        hide: true,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      {
        headerName: this.$t('CargoMsg.Cargo_BusinessQuotationConfirmed'),
        colId: 'businessQuotationConfirmd',
        field: 'businessQuotationConfirmd',
        initialWidth: 180,
        hide: true,
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this._view.$t('FinanceManage.charge_isSync'),
        colId: 'isSync',
        field: 'isSync',
        initialWidth: 120,
        headerClass: 'ag-header-cell-center',
        cellStyle: {
          textAlign: 'center'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return params.value === '1' ? this._view.$t('SeaExport.Yes') : this._view.$t('SeaExport.No')
        },
        enableRowGroup: true
      }
    ]
  }

  // 应付合计显示列
  getSumColumnDefsSelling() {
    const cols = [
      {
        field: 'quantity',
        getValue: data => data.quantity,
        format: value => this._view.$numeral(value).format('0.000')
      },
      {
        field: 'amount',
        getValue: data => data.amount,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'excludingTaxAmount1',
        getValue: data => data.excludingTaxAmount,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'taxAmount',
        getValue: data => data.taxAmount,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'excludingTaxAmount',
        getValue: data => Number(this.conversionRMBLabel(data).replace(/,/g, '')) || 0,
        format: value => formatNumberToThousands(NumberUtils.formatNumber(value, 2, true), 2).toString()
      },
      {
        field: 'verifiedAmount',
        getValue: data => data.verifiedAmount,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'chargeUnverifiedAmount',
        getValue: data => data.amount - data.verifiedAmount,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'invoiceTax',
        getValue: data => data.invoiceTax,
        format: value => NumberUtils.formatNumber(value, 2, true)
      },
      {
        field: 'arPaymentAmount',
        getValue: data => data.arPaymentAmount,
        format: value => this._view.$numeral(value).format('0.000')
      },
      {
        field: 'commissionAmount',
        getValue: data => data,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'whtTaxAmount',
        getValue: data => Number(this.whtTaxAmountConversionRMBLabel(data).replace(/,/g, '')) || 0,
        format: value => this._view.$numeral(value).format('0.00')
      },
      {
        field: 'notWhtAmount',
        getValue: data => ColumnUtils.notWhtAmountLabel(data),
        format: value => this._view.$numeral(value).format('0.00')
      }
    ]
    if (this._view.privilege.showSalePriceHc) {
      return cols.filter(c => c.field !== 'verifiedAmount' && c.field !== 'chargeUnverifiedAmount')
    }
    return cols
  }

  // WHT应付显示列
  getWhtColumnDefsForSelling() {
    return [
      {
        headerName: this._view.$t('FinanceManage.charge_whtTaxRate'), field: 'whtTaxRate', width: 100,
        headerClass: 'ag-header-cell-right',
        hide: !this._view.showWhtTax,
        suppressColumnsToolPanel: !this._view.showWhtTax,
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this._view.$numeral(params.value).format('0.00')
        },
        editable: (params) => params.data && params.data && this._view.editing && this.isEditColumn(params) && this.isRowEdit(params.data) && this.checkEditPersonalApCharge(params.data) && !this._view.lockAp &&
          params.data.chargeState !== ChargeConstants.STATE_COMMITED.code && params.data.chargeState !== ChargeConstants.STATE_VERIFIED.code,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        onCellValueChanged: p => this.onCellChange(p)
      },
      {
        headerName: this._view.$t('FinanceManage.charge_whtTaxAmount'), field: 'whtTaxAmount', width: 100,
        headerClass: 'ag-header-cell-right',
        hide: !this._view.showWhtTax,
        suppressColumnsToolPanel: !this._view.showWhtTax,
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          return this.whtTaxAmountConversionRMBLabel(params.data)
        },
        summaryMode: 'sum'
      },
      {
        headerName: this._view.$t('FinanceManage.charge_notWhtAmount'), field: 'notWhtAmount', width: 100,
        headerClass: 'ag-header-cell-right',
        hide: !this._view.showWhtTax,
        suppressColumnsToolPanel: !this._view.showWhtTax,
        cellStyle: {
          textAlign: 'right'
        },
        valueFormatter: (params) => {
          if (!params.data && params.value === undefined) {
            return ''
          }
          const notWhtAmount = ColumnUtils.notWhtAmountLabel(params.data)
          return this._view.$numeral(notWhtAmount).format('0.00')
        },
        summaryMode: 'sum'
      }
    ]
  }

  async init() {
    // columnDefs 可以在 列数据准备好后，展示 computed

  }

  async beforeMount() {
    // // todo-shengsheng  Desc: 放置onShow,主动调用
    // await this.creationCompleteHandler()
    // await this.init()
  }

  /**
   * initialize
   */
  async creationCompleteHandler(chargeDetails) {
    // bpm进去时查看全部费用，只查看主票费用（不需要权限）
    if (this._view.isBpm) {
      for (const charge of this._view.job.charges || []) {
        if (charge.receivable) {
          this._view.tabCost.grid.overseaCostDetails.push(charge)
        } else {
          this._view.tabSelling.grid.overseaSellingDetails.push(charge)
        }
      }
      if (this._view.tabCost.grid.overseaCostDetails.length > 1) {
        this._view.tabCost.grid.overseaCostDetails = sortByMultiField(this._view.tabCost.grid.overseaCostDetails, ['serialNumber'], false)
      }
      if (this._view.tabSelling.grid.overseaSellingDetails > 1) {
        this._view.tabSelling.grid.overseaSellingDetails = sortByMultiField(this._view.tabSelling.grid.overseaSellingDetails, ['serialNumber'], false)
      }
      return
    }
    this.initCheckboxState()

    // if (!this.inited) { 是否初始化，交由相关页签的onShow方法控制
    // this._view.arTotalGroup.visible=true
    // this._view.apTotalGroup.visible=true
    // this._view.revenueTotalGroup.visible=true
    await this.loadData(chargeDetails)
    // }
    // this.inited = true
    // this.initGridColumns()
    this.showChangeChargeHandler()
    this.chkOffsetChargeHandler()
    this._view.config.chargeSyncNeedConfirm = Number(cache.config.get('ChargeSyncNeedConfirm')) === 1
    this._view.config.accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode')) === 1
    this._view.config.jinRongExchangeMode = cache.config.get('ToExoSystem') === 'JinRongExchangeMode' // 锦荣交单模式
    const chargeSyncCheckJobStateTxt = cache.config.get('ChargeSyncCheckJobState')
    const checkJobStates = []
    if (chargeSyncCheckJobStateTxt) {
      const jobStateStrs = chargeSyncCheckJobStateTxt.split(',')
      for (const jobStateStr of jobStateStrs) {
        switch (jobStateStr.trim()) {
          case '0': // 正操作
            checkJobStates.push(0)
            break
          case '1': // 已提交
            checkJobStates.push(1)
            break
          case '2': // 已审核
            checkJobStates.push(2)
            break
          case '11': // 预提交
            checkJobStates.push(11)
            break
        }
      }
    }
    this._view.config.chargeSyncCheckJobState = checkJobStates.length > 0 ? checkJobStates : null
    this.initChargeSyncBtn()

    this._view.customerCmpList = null
    if (!this._view.customerSalesDisplay && this._view.config.accountObjectControlMode && !this._view.$store.getters.isAdmin && (this._view.$checkPermission(['role_SalesQueryModule_salesCustomer']) || this._view.$checkPermission(['role_SalesQueryModule_departmentCustomer']))) {
      getCustomerByRole({ branch: this._view.$store.getters.currentOfficeId }).then(res => {
        this._view.customerSalesCmpList = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => res.data.includes(p.cmpIdx))
      })
    }
    if (this._view.job && this._view.job.uuid) {
      const params = {
        jobUuid: this._view.job.uuid,
        loadGpExplainRecord: true,
        queryPendingChargeSyncRecordNum: !!this._view.config.chargeSyncNeedConfirm,
        queryPendingChargeOutSyncRecountNum: true
      }
      loadJobAncillaryInformation(params).then(res => {
        // 初始化
        this._view.pendingChargeSyncRecordNum = 0
        this._view.pendingChargeOutSyncRecordNum = 0
        this._view.gpExplain.gpExplainContent = ''
        // 根据返回值赋值
        if (res.data) {
          if (res.data.pendingChargeSyncRecordNum) {
            this._view.pendingChargeSyncRecordNum = res.data.pendingChargeSyncRecordNum
          }
          if (res.data.pendingChargeOutSyncRecountNum) {
            this._view.pendingChargeOutSyncRecordNum = res.data.pendingChargeOutSyncRecountNum
          }
          if (res.data.gpExplainRecord && res.data.gpExplainRecord.length > 0) {
            let str = ''
            for (const item of res.data.gpExplainRecord) {
              // 获取GP说明标题
              const gpExplainTitle = getObjectByCache(TYPE_NAMES.basic_data_GpExplainTitle, 'code', item.code)
              if (!gpExplainTitle) {
                continue
              }
              const gpExplainTitleName = this.language ? gpExplainTitle.chineseName : gpExplainTitle.englishName
              // 获取用户信息
              const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', item.createdBy)
              let userName = ''
              if (user) {
                userName = this.language ? user.chineseName : user.englishName
              }
              str = str + gpExplainTitleName + ':  ' + item.remark + '(' + userName + '  ' + item.dateCreated + ')' + '\n'
            }
            if (str) {
              this._view.gpExplain.gpExplainContent = str
            }
          }
        }
      })
    }
    // 费用合并
    this.mergeSellingCharge()
  }

  initCheckboxState() {
    this._view.checkbox.chkShowSharedCharge.selected = !(LocalStorageUtils.getConfiguration(this.cachePrefix + 'showSharedCharges'))
    this._view.checkbox.chkShowCommonCharge.selected = this._view.config.chkShowCommonChargeSelected
    this._view.checkbox.chkShowSpecialCharge.selected = this._view.config.chkShowSpecialChargeSelected
    this._view.checkbox.chkShowBusinessSpecialCharge.selected = this._view.config.chkShowBusinessSpecialChargeSelected
    const showChangeCharge = LocalStorageUtils.getConfiguration(this.cachePrefix + 'showChangeCharge')
    this._view.checkbox.chkShowChangeCharge.selected = showChangeCharge === '' ? true : Boolean(showChangeCharge)
    this._view.checkbox.chkInternal.selected = true
  }

  // 初始化费用同步按钮
  initChargeSyncBtn() {
    const arChargeSyncBtns = []
    if (this._view.config.openMutualTrustConfig) {
      arChargeSyncBtns.push({
        name: this._view.$t('FinanceManage.charge_asyncCharges')
      })
    }
    if (this._view.config.enableEntrustmentSI) {
      if (this._view.job.lob === 'SE') {
        if (this._view.config.chargeSyncNeedConfirm) {
          arChargeSyncBtns.push({
            name: this._view.$t('CargoMsg.Cargo_Export') + this._view.$t('FinanceManage.charge_asyncCharges')
          })
        }
      } else if (this._view.job.lob === 'SI') {
        arChargeSyncBtns.push({
          name: this._view.$t('CargoMsg.Cargo_JobTypeImport') + this._view.$t('FinanceManage.charge_asyncCharges')
        })
      }
    }
    if (this._view.config.consignationImportByAE) {
      if (this._view.job.lob === 'AE') {
        if (this._view.config.chargeSyncNeedConfirm) {
          arChargeSyncBtns.push({
            name: this._view.$t('CargoMsg.Cargo_Export') + this._view.$t('FinanceManage.charge_asyncCharges')
          })
        }
      } else if (this._view.job.lob === 'AI') {
        arChargeSyncBtns.push({
          name: this._view.$t('CargoMsg.Cargo_JobTypeImport') + this._view.$t('FinanceManage.charge_asyncCharges')
        })
      }
    }
    this._view.arChargeSyncBtns = arChargeSyncBtns
    this._view.arChargeSyncCommand = arChargeSyncBtns.length > 0 ? arChargeSyncBtns[0].name : ''
    this._view.arChargeSyncEnabled = true
  }

  // 查询待处理的费用同步记录条数
  async queryPendingChargeSyncRecountNum() {
    let num = 0
    if (this._view.config.chargeSyncNeedConfirm) {
      await pendingChargeSyncRecordCount({ jobKey: this._view.job.uuid }).then(res => {
        num = res.data
      })
    }
    this._view.pendingChargeSyncRecordNum = num
  }

  // 查询待处理的外部推送费用同步记录条数
  async queryPendingChargeOutSyncRecountNum() {
    let num = 0
    await pendingChargeOutSyncRecordCount({ jobKey: this._view.job.uuid }).then(res => {
      num = res.data
    })
    this._view.pendingChargeOutSyncRecordNum = num
  }

  // 应收费用同步处理
  arChargeSyncHandler() {
    switch (this._view.arChargeSyncCommand) {
      case this._view.$t('FinanceManage.charge_asyncCharges'):
        this.syncEntrustChargers()
        break
      case this._view.$t('CargoMsg.Cargo_Export') + this._view.$t('FinanceManage.charge_asyncCharges'):
        this.syncChargesToImportJob(true)
        break
      case this._view.$t('CargoMsg.Cargo_JobTypeImport') + this._view.$t('FinanceManage.charge_asyncCharges'):
        this.syncChargesToExportJob(true)
        break
    }
  }

  async loadData(chargeDetails) {
    if (this._view.job) {
      if (this._view.job.masterFlag) {
        if (this._view.job.lclSlaves) {
          let ClazzForlob = ''
          switch (this._view.job.lob) {
            case 'SE':
              ClazzForlob = SeaExportJob
              break
            case 'SI':
              ClazzForlob = SeaImportJob
              break
            case 'AE':
              ClazzForlob = AirExportJob
              break
            case 'AI':
              ClazzForlob = AirImportJob
              break
            case 'RE':
            case 'RI':
              ClazzForlob = RailwayExportJob
              break
            case 'IE':
              ClazzForlob = IntegratedJob
              break
          }
          // 数据准备-加载小票的费用
          const chargeMap = await new ClazzForlob(this._view.job).getAllSlaveChargeList()
          if (chargeMap && this._view.job.lclSlaves && this._view.job.lclSlaves.length > 0) {
            for (const slave of this._view.job.lclSlaves) {
              if (!chargeMap[slave.uuid]) continue
              const charges = chargeMap[slave.uuid]
              slave.charges = []
              if (charges && charges.length > 0) slave.charges = charges
            }
          }
          // const loadLclSlaveCharges = this._view.job.lclSlaves.map(item => new ClazzForlob(item).getCharges())
          // await Promise.all(loadLclSlaveCharges)
          // 费用分摊小票
          for (const charge of chargeDetails.charges) {
            if (charge.apportioned) {
              const jobNos = []
              for (const slave of this._view.job.lclSlaves) {
                if (slave.charges) {
                  for (const slaveCharge of slave.charges) {
                    if (slaveCharge.shared && slaveCharge.shareRefNo && slaveCharge.shareRefNo === String(charge.chargeId)) {
                      jobNos.push(slave.jobNo)
                      break
                    }
                  }
                }
              }
              charge.shareJobNos = jobNos.length > 0 ? jobNos.join(',') : ''
            } else {
              charge.shareJobNos = ''
            }
          }
        }
      } else {
        const shareRefNos = []
        for (const charge of chargeDetails.charges) {
          charge.shareJobNos = '' //  设置费用分摊小票默认值
          if (charge.shared && charge.shareRefNo) {
            shareRefNos.push(charge.shareRefNo)
          }
        }
        // 从关联主票中获取小票分摊类型
        if (shareRefNos.length > 0) {
          let masterChargs = null
          if (this._view.job.lclMaster) {
            await getChargeList(this._view.job.lclMasterUuid).then(res => {
              masterChargs = res.data
            })
          } else {
            if (this._view.job.lclMasterUuid) {
              const masterJobModel = JobUtils.getJobByType({ uuid: this._view.job.lclMasterUuid, lob: this._view.job.lob })
              await masterJobModel.loadJobRelated({ job: true, charges: true })
              masterChargs = masterJobModel.charges
              masterJobModel.charges = '' // 费用置空（原本的lclMaster不包含费用）
              this._view.job.lclMaster = masterJobModel.getData()
            }
          }
          const shareSchemeMap = new Map()
          if (masterChargs) {
            for (const item of masterChargs) {
              if (item.apportioned) {
                shareSchemeMap.set(String(item.chargeId), item.shareScheme)
              }
            }
          }
          for (const charge of chargeDetails.charges) {
            if (charge.shared && charge.shareRefNo) {
              charge.masterShareScheme = shareSchemeMap.get(charge.shareRefNo) || 0
              charge.shareJobNos = this._view.job.lclMaster.jobNo
            }
          }
        }
      }
      // 重排序
      // this._view.job.charges = sortByMultiField(this._view.job.charges, ['serialNumber'], false)
      await this.initGridSpareData(this._view.job.charges)
      this.costSpecialButton()
      if (!this._view.departmentTeamUser || this._view.departmentTeamUser.length <= 0) {
        // 有应收全部，没有应付全部，但是有应付同组权限，此时也要查询同组人员；没有应收全部，有应付全部，但是有应收同组权限
        // 商务特殊费用「查看-同组」权限也依赖部门团队数据（不受普通应收/应付费组权限影响）
        if ((!this._view.privilege.queryArAllRole && this._view.privilege.queryArDeptChargeRole) ||
            (!this._view.privilege.queryApAllRole && this._view.privilege.queryApDeptChargeRole) ||
            this._view.privilege.businessSpecialViewDept) {
          const res = await User.getUserDepartmentTeam()
          if (res) {
            this._view.departmentTeamUser = res
          }
        }
      }
      this.loadForBookingResultHandler(chargeDetails)

      const accountIds = []
      if (this._view.job.charges && this._view.job.charges.length > 0) {
        for (const charge of this._view.job.charges) {
          accountIds.push({ accountId: charge.accountId })
        }
      }
      if (this._view.job.customerId) accountIds.push({ accountId: this._view.job.customerId })
      if (this._view.job.bookingAgent) accountIds.push({ accountId: this._view.job.bookingAgent })
      if (accountIds.length > 0) {
        if (chargeDetails && chargeDetails.companyContactPersons && chargeDetails.customerTitles) {
          // 初始化联系人
          await this.initCompanyContactPersonMap(accountIds, chargeDetails.companyContactPersons)
          // 初始化开票抬头
          await this.initTitlesMap(accountIds, chargeDetails.customerTitles)
          await this.initSettlementAgentsMap(accountIds, chargeDetails.customerSettlementAgents)
        } else {
          if (accountIds.length > 0) {
            // 初始化联系人
            await this.initCompanyContactPersonMap(accountIds)
            // 初始化开票抬头
            await this.initTitlesMap(accountIds)
            await this.initSettlementAgentsMap(accountIds)
          }
        }
      }
    }
  }

  costSpecialButton() {
    this._view.btn.addCostSpecialOSButton.enabled = !this._view.editing && this._view.job.jobState === 0
    this._view.btn.addCostSpecialOCButton.enabled = !this._view.editing && this._view.job.jobState === 0
    // 商务特殊费用新增按钮：启用条件与特殊费用一致（非编辑态 + 业务草稿）
    this._view.btn.addCostBusinessSpecialButton.enabled = !this._view.editing && this._view.job.jobState === 0
  }

  initGridColumns() {
    // columnsDefs

  }

  async initGridSpareData(charges) {
    this.initCompanyCmpIdxForCustomerMap()
    // basic_data_Department中没有officId 这个方法没用
    // this.initOfficeIdForDepartmentMap(charges)
    this.initCurrencySet()
    this.initPaymentTermSet()
    this.initUserSet()
    this.initChargeItemSet()
    await Promise.all([this.initCargoDocSet(), this.initAuditorUserSet()])
  }

  initOfficeIdForDepartmentMap(charges) {
    const branchIds = charges.map(charge => {
      return Number(charge.branchId)
    })
    const officeIdForDepartmentMap = this._view.currentViewCacheData.officeIdForDepartmentMap
    const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Department, (item) => {
      if (branchIds.includes(Number(item.officeId))) {
        if (officeIdForDepartmentMap.has(Number(item.officeId))) {
          officeIdForDepartmentMap.get(item.officeId).push(item)
        } else {
          officeIdForDepartmentMap.set(Number(item.officeId), [item])
        }
      }
    })
    // console.log('officeIdForDepartmentMap==========', officeIdForDepartmentMap)
  }

  getDepartmentsByOfficeUuid(branchId) {
    const officeIdForDepartmentMap = this._view.currentViewCacheData.officeIdForDepartmentMap
    if (!officeIdForDepartmentMap.has(branchId)) {
      const officeArr = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Office, (item) => item.officeId === branchId)
      const officeUuid = officeArr.length ? officeArr[0].uuid : ''
      let results = []
      if (officeUuid) {
        results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Department, (item) => {
          return item.officeUuid === officeUuid && item.jobNoPrefix
        })
      }
      officeIdForDepartmentMap.set(branchId, results)
    }
    // console.log('officeIdForDepartmentMap.get(branchId)', officeIdForDepartmentMap, officeIdForDepartmentMap.get(branchId), branchId)
    return officeIdForDepartmentMap.get(Number(branchId)) || []
  }

  getClearDepartmentsByOfficeUuid(branchId) {
    const officeIdForDepartmentMap = this._view.currentViewCacheData.officeIdForClearDepartmentMap
    if (!officeIdForDepartmentMap.has(branchId)) {
      const officeArr = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Office, (item) => item.officeId === branchId)
      const officeUuid = officeArr.length ? officeArr[0].uuid : ''
      let results = []
      if (officeUuid) {
        results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Department, (item) => {
          return item.officeUuid === officeUuid && item.jobNoPrefix && item.clearing
        })
      }
      officeIdForDepartmentMap.set(branchId, results)
    }
    // console.log('officeIdForDepartmentMap.get(branchId)', officeIdForDepartmentMap, officeIdForDepartmentMap.get(branchId), branchId)
    return officeIdForDepartmentMap.get(Number(branchId)) || []
  }

  initCurrencySet() {
    const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
    this._view.currentViewCacheData.currencySet = new Set(results)
    // console.log('this._view.currentViewCacheData.currencySet', this._view.currentViewCacheData.currencySet)
  }

  initPaymentTermSet() {
    const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_PaymentTerm)
    this._view.currentViewCacheData.paymentTermSet = new Set(results)
    // console.log('this._view.currentViewCacheData.paymentTermSet', this._view.currentViewCacheData.paymentTermSet)
  }

  async initAuditorUserSet() {
    const results = await User.getUsersByPrivilegeDetail('role', 'auditor', null, null, true)
    this._view.currentViewCacheData.user4AuditorSet = new Set(results)
  }

  initUserSet() {
    const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_User)
    this._view.currentViewCacheData.userAllSet = new Set(results)
    // console.log('this._view.currentViewCacheData.TYPE_NAMES.basic_data_User', this._view.currentViewCacheData.userAllSet)
  }

  initChargeItemSet() {
    const results = chargeItemCompatibleLanguage()
    this._view.currentViewCacheData.chargeItemSet = new Set(results)
    const filter = this.getChargeItemFilter(true)
    // 将 Set 转换为数组
    const chargeItemArray = Array.from(this._view.currentViewCacheData.chargeItemSet)
    // 过滤出符合 filter 条件的对象
    this._view.currentViewCacheData.chargeItemSet = chargeItemArray.filter(item => {
      // 使用 every 方法检查 item 是否包含 demo 中的所有属性，并且值相等
      return Object.keys(filter).every(key => item[key] === filter[key])
    })
  }

  async initCargoDocSet() {
    this._view.currentViewCacheData.mblCargoDocSet = new Set()
    this._view.currentViewCacheData.hblCargoDocSet = new Set()
    const j = this._view.job
    if ([SystemConstants.SE.code, SystemConstants.SI.code].includes(j.lob)) {
      if (SystemConstants.SE.code === j.lob) {
        const jobClass = new SeaExportJob(this._view.job)
        await jobClass.getCargoDoc()
      } else if (SystemConstants.SI.code === j.lob) {
        const jobClass = new SeaImportJob(this._view.job)
        await jobClass.getCargoDoc()
      }
      for (const seDoc of this._view.job.cargoDoc || []) {
        if (seDoc.docType === CargoDocConsts.MBL && j.signMBL) {
          if (!StrUtils.isEmpty(this._view.job.mbl)) {
            seDoc.chargeRelatedBLNo = this._view.job.mbl
            this._view.currentViewCacheData.mblCargoDocSet.add(seDoc)
          }
        } else if (seDoc.docType === CargoDocConsts.MBL2 && j.signMBL && j.typeMBL !== 1 && !seDoc.deleted) {
          if (!StrUtils.isEmpty(seDoc.mblNbr2)) {
            seDoc.chargeRelatedBLNo = seDoc.mblNbr2
            this._view.currentViewCacheData.mblCargoDocSet.add(seDoc)
          }
        } else if ((seDoc.docType === CargoDocConsts.HBL || (seDoc.docType === CargoDocConsts.HBL2 && j.typeHBL !== 1)) && !seDoc.deleted && j.signHBL && !j.masterFlag) {
          if (!StrUtils.isEmpty(seDoc.hblNbr2)) {
            seDoc.chargeRelatedBLNo = seDoc.hblNbr2
            this._view.currentViewCacheData.hblCargoDocSet.add(seDoc)
          }
        }
      }
    }
    this._view.getAllContainerNoHandler()
  }

  // 初始化开票抬头
  async initTitlesMap(charges, titleMap) {
    const accountIds = Array.from(new Set(Array.from(charges, p => p.accountId))).filter(id => !this._view.currentViewCacheData.customerTitlesMap.has(id))
    if (!accountIds || accountIds.length <= 0) return
    if (!titleMap) {
      const res = await queryTitlesByCmpIdx(accountIds)
      titleMap = res.data
      if (!titleMap) return
    }
    accountIds.forEach(id => {
      if (!this._view.currentViewCacheData.customerTitlesMap.has(id)) {
        if (titleMap[id]) this._view.currentViewCacheData.customerTitlesMap.set(id, titleMap[id])
      }
    })
  }

  async getTitlesByCompanyId(charge) {
    const accountId = charge.accountId
    if (!accountId || accountId <= 0) return
    if (this._view.currentViewCacheData.customerTitlesMap.has(accountId)) {
      return this._view.currentViewCacheData.customerTitlesMap.get(accountId)
    }
    // 获取数据库中维护的开票抬头
    const res = await queryTitleByCpmIdx(accountId)
    let dbTitles = res.data
    if (!dbTitles) dbTitles = []
    if (dbTitles.length > 0) {
      for (const title of dbTitles) {
        if (!title.title) continue
        title.invoiceTitle = title.title
      }
    }
    this._view.currentViewCacheData.customerTitlesMap.set(accountId, dbTitles)
    return this._view.currentViewCacheData.customerTitlesMap.get(accountId)
  }

  // 获取联系人
  async initCompanyContactPersonMap(charges, companyContactPersons) {
    const accountIds = Array.from(new Set(Array.from(charges, p => p.accountId))).filter(id => !this._view.currentViewCacheData.companyContactPersonMap.has(id))
    if (!accountIds || accountIds.length <= 0) return

    const callback = contactMap => {
      accountIds.forEach(id => {
        if (!this._view.currentViewCacheData.companyContactPersonMap.has(id)) {
          if (contactMap[id]) this._view.currentViewCacheData.companyContactPersonMap.set(id, contactMap[id])
        }
      })
    }
    if (companyContactPersons) {
      callback(companyContactPersons)
    } else {
      await queryContactsByCmpIdx(accountIds).then(res => {
        const contactMap = res.data
        if (!contactMap) return
        callback(contactMap)
      })
    }
  }

  /**
   * 费用权限调整为：个人、同组、全部
   * 优先级: 1.全部 2.同组 3.个人
   */
  loadForBookingResultHandler(chargeDetails) {
    if (chargeDetails && chargeDetails.actualAmountNos) {
      this.queryActualAmountHandler(chargeDetails.actualAmountNos)
      return
    }
    const chargeIds = []
    const job = this._view.job
    if (job && job.charges) {
      for (const charge of job.charges) {
        if (!StrUtils.isEmpty(charge.uuid) && !chargeIds.includes(charge.uuid)) {
          chargeIds.push(charge.uuid)
        }
      }
    }
    if (chargeIds.length > 0) {
      getActualAmountNoBykeys(chargeIds).then(res => {
        this.queryActualAmountHandler(res.data)
      })
    } else {
      this.queryActualAmountHandler()
    }
  }

  /**
   * 当前job费用是否是自己创建的
   */
  checkChargeCreatedBy() {
    for (const charge of this._view.job.charges) {
      // console.log('this.$store.getters.userId', typeof this.$store.getters.userId, this.$store.getters.userId)
      // console.log('charge.createdBy', charge.createdBy, charge)
      if (charge.createdBy === 0 || charge.createdBy !== this.$store.getters.userId) {
        return false
      }
    }

    return true
  }

  /**
   * @private 提取费用，应收应付列表数据赋值 - 3合1方法
   * isCheckDepartmentTeam 是否 同组和本人费用。和原来的 extractDepartmentTeamCharge/extractCurrentUserCharge 进行合并为一个方法处理
   */
  extractCharges(job, isCheckDepartmentTeam = false, isCheckCurrentUser = false) {
    // console.log('job==========', job, job.charges)
    let isShow = false
    /* const overseaCostDetails = []
    const overseaSellingDetails = []
    const jobControlledCharges = []*/
    for (const charge of job.charges || []) {
      if (RateUtil.useOrderCenterMode() && charge.branchId !== this._view.currentSettleBranchId && this._view.settleBranchId > 0 &&
          !(this._view.privilege.enableCommission && charge.special && !this._view.job.opOffice_original && this._view.job.opOffice === this.$store.getters.currentOfficeId && (this._view.settleBranchId === 0 || this._view.settleBranchId === this._view.job.opOffice))) {
        continue
      }
      if (RateUtil.useOrderCenterMode() && this._view.settleBranchId === 0 && this._view.privilege.enableCommission && charge.special && this._view.job.opOffice_original) {
        continue
      }
      // 非编辑状态下，勾选是否显示分摊费用
      if (this._view.checkbox.chkShowSharedCharge.visible && !job.masterFlag && !this._view.editing) {
        if (!this._view.checkbox.chkShowSharedCharge.selected && charge.shareRefNo && charge.shared) {
          continue
        }
      }
      // console.log('charge ===', charge, charge.uuid, charge.jobUuid)
      if (!this.checkChargeAdd(charge)) {
        continue
      }
      // CARGO-2992
      // 主票查看分票费用的时候，过滤掉小票因分摊生成的费用
      if (charge.shareRefNo && charge.shared && charge.jobUuid !== this._view.job.uuid) {
        continue
      }
      // 商务特殊费用：独立显隐（勾选框）+ 独立数据范围权限（查看 个人/同组/所有），
      // 必须先于下方普通费用的同组/本人闸门判断——同组商务特殊行不受普通费用权限模型拦截（见 businessSpecialChargeVisibility）
      if (charge.businessSpecial) {
        // 勾选「显示商务特殊费用」才显示该类行
        if (!this._view.checkbox.chkShowBusinessSpecialCharge.selected) {
          continue
        }
        if (!isBusinessSpecialChargeVisible(charge, {
          viewAll: this._view.privilege.businessSpecialViewAll,
          viewDept: this._view.privilege.businessSpecialViewDept,
          viewUser: this._view.privilege.businessSpecialViewUser,
          departmentTeamUser: this._view.departmentTeamUser,
          currentUserId: this.$store.getters.userId
        })) {
          continue
        }
        // 商务特殊费用仅存在于应付栏
        if (!charge.uuid || this._view.tabSelling.grid.overseaSellingDetails.findIndex(item => charge.uuid === item.uuid) === -1) {
          this._view.tabSelling.grid.overseaSellingDetails.push(charge)
        }
        continue
      }
      // 同组
      if (!charge.internalFrom && isCheckDepartmentTeam && !this.checkDepartmentTeam(charge)) {
        continue
      }
      // 本人
      if (!charge.internalFrom && isCheckCurrentUser && charge.createdBy !== this.$store.getters.userId && charge.createdBy > 0) {
        continue
      }
      // console.log('00000==========pass')
      //
      if (this._view.privilege.enableCommission) {
        if (this._view.isFromFinanceModule && charge.branchId !== this.$store.getters.currentOfficeId) {
          continue
        }
        isShow = false
        // CARGO-2750，财务审核模块【费用】页签（显示特殊费用、显示普通费用）隐藏
        if (this._view.isFromFinanceModule) {
          isShow = true
        } else if (((this._view.privilege.showCommonCharge && this._view.checkbox.chkShowCommonCharge.selected) && (this._view.privilege.showSpecialCharge && this._view.checkbox.chkShowSpecialCharge.selected)) ||
          ((this._view.privilege.showCommonCharge && !this._view.checkbox.chkShowCommonCharge.selected) && (this._view.privilege.showSpecialCharge && !this._view.checkbox.chkShowSpecialCharge.selected))) {
          // 勾选显示特殊费用：只显示维护的特殊费用（CF费用）；
          // 勾选显示普通费用：只显示维护的正常费用（非特殊费用即SH费用）；
          // 两个同时勾选/两个都不勾选：显示全部费用，默认全部勾选
          isShow = true
        } else {
          if (charge.special) {
            // 勾选显示特殊费用
            if (this._view.privilege.showSpecialCharge && this._view.checkbox.chkShowSpecialCharge.selected) {
              isShow = true
            }
          } else {
            // 勾选显示普通费用、或没有显示特殊费用
            if (!this._view.privilege.showSpecialCharge || (this._view.privilege.showCommonCharge && this._view.checkbox.chkShowCommonCharge.selected)) {
              isShow = true
            }
          }
        }
      }
      if (this._view.config.toExoSystemHC) {
        isShow = false
        if (charge.special) {
          // 特殊费用需要勾选显示特殊费用
          if (this._view.privilege.showSpecialCharge && this._view.checkbox.chkShowSpecialCharge.selected) {
            isShow = true
          }
        } else {
          // 普通费用
          isShow = true
        }
      }
      // 非佣金、佣金
      if ((!this._view.privilege.enableCommission && !this._view.config.toExoSystemHC) || (this._view.privilege.enableCommission && isShow) || (this._view.config.toExoSystemHC && isShow)) {
        // 1.判断当前登录人可以查看哪些费用（全部，同组，个人）
        if (!isCheckCurrentUser && !isCheckDepartmentTeam) { // 查看应收全部费用权限
          if (charge.receivable) {
            if (this._view.isOtherSettleBranchId || this._view.privilege.queryArAllRole) { // 查看应收全部费用权限
              if (!charge.uuid || this._view.tabCost.grid.overseaCostDetails.findIndex(item => charge.uuid === item.uuid) === -1) {
                this._view.tabCost.grid.overseaCostDetails.push(charge)
              }
            } else if (this._view.privilege.queryArDeptChargeRole && this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) { // 有查看同组权限，且有同组人员
              if (charge.internalFrom || this.checkDepartmentTeam(charge)) { // 自己创建的费用
                if (!charge.uuid || this._view.tabCost.grid.overseaCostDetails.findIndex(item => charge.uuid === item.uuid) === -1) {
                  this._view.tabCost.grid.overseaCostDetails.push(charge)
                }
              }
            } else if (this._view.privilege.queryArUserChargeRole) { // 有查看自己费用权限
              if (charge.internalFrom || charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId) { // 自己创建的费用
                if (!charge.uuid || this._view.tabCost.grid.overseaCostDetails.findIndex(item => charge.uuid === item.uuid) === -1) {
                  this._view.tabCost.grid.overseaCostDetails.push(charge)
                }
              }
            }
          } else {
            if (this._view.isOtherSettleBranchId || this._view.privilege.queryApAllRole) { // 查看应付全部费用权限
              if (!charge.uuid || this._view.tabSelling.grid.overseaSellingDetails.findIndex(item => charge.uuid === item.uuid) === -1) {
                this._view.tabSelling.grid.overseaSellingDetails.push(charge)
              }
            } else if (this._view.privilege.queryApDeptChargeRole && this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) { // 有查看同组费用权限，且有同组人员
              if (charge.internalFrom || this.checkDepartmentTeam(charge)) { // 自己创建的费用
                if (!charge.uuid || this._view.tabSelling.grid.overseaSellingDetails.findIndex(item => charge.uuid === item.uuid) === -1) {
                  this._view.tabSelling.grid.overseaSellingDetails.push(charge)
                }
              }
            } else if (this._view.privilege.queryApUserChargeRole) { // 有查看自己费用权限
              if (charge.internalFrom || charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId) { // 自己创建的费用
                if (!charge.uuid || this._view.tabSelling.grid.overseaSellingDetails.findIndex(item => charge.uuid === item.uuid) === -1) {
                  this._view.tabSelling.grid.overseaSellingDetails.push(charge)
                }
              }
            }
          }
        } else if (!isCheckCurrentUser && isCheckDepartmentTeam) { // 查看同组应收费用权限（可以查询同组人员费用以及自己创建的费用）
          if (charge.internalFrom || charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId) { // 自己创建的费用
            if (charge.receivable) {
              this._view.tabCost.grid.overseaCostDetails.push(charge)
            } else {
              this._view.tabSelling.grid.overseaSellingDetails.push(charge)
            }
          } else { // 同组人员的费用
            if (charge.receivable) {
              if (this._view.privilege.queryArDeptChargeRole) {
                this._view.tabCost.grid.overseaCostDetails.push(charge)
              }
            } else {
              if (this._view.privilege.queryApDeptChargeRole) {
                this._view.tabSelling.grid.overseaSellingDetails.push(charge)
              }
            }
          }
        } else { // 个人费用
          if (charge.receivable) {
            this._view.tabCost.grid.overseaCostDetails.push(charge)
          } else {
            this._view.tabSelling.grid.overseaSellingDetails.push(charge)
          }
        }
        this._view.jobControlledCharges.push(charge)
      }
    }
  }

  //
  //   /**
  //    * 打印
  //    */
  print() {
    //     if (null === overseaCostDetails || overseaCostDetails.length === 0) {
    //       MessageDialog.warning(resourceManager.getString('Message', 'OverseaCostChargeEmpty'));
    //       return;
    //     }
    //     if (overseaCostDetails.length === 1) {
    //       printChargeBilling(Charge(overseaCostDetails.getItemAt(0)).accountId);
    //     } else {
    //       const accounts = getChargeAccounts();
    //       if (accounts.length > 1) {
    //         if (selectItemWin === null) {
    //           selectItemWin = new SelectItem();
    //           selectItemWin.addEventListener(PopformEvent.SELECT, selectItemWinHandler);
    //         }
    //         selectItemWin.callLater(function () {
    //           selectItemWin._title = resourceManager.getString('Message', 'SelectTheBillingObject');
    //           selectItemWin.setData(accounts);
    //         });
    //         PopUpUtils.addPopUp(selectItemWin, this, true);
    //       } else {
    //         if (accounts.length === 0) {
    //           MessageDialog.warning(resourceManager.getString('Message', 'NoChargeForTheSettlementOfDomesticObjects'));
    //           return;
    //         }
    //         printChargeBilling(Company(accounts.getItemAt(0)).cmpIdx);
    //       }
    //     }
  }

  //
  selectItemWinHandler(e) {
    //     printChargeBilling(parseInt(e._str));
  }

  //
  printChargeBilling(accountId) {
    //     const params = {};
    //     params.accountId = accountId;
    //     params.ACCOUNT_ID = accountId;
    //     if (job) {
    //       params.jobuuid = job.uuid;
    //       params.JOB_UUID = job.uuid;
    //       if ("SE" === job.lob) {
    //         if (parentDocument is ScrollerSkin) {
    //           params.CARGODOC_UUID = StrUtils.isEmpty(cargoDocUUID) ? parentDocument.parentDocument.getCargoDocUUID() : cargoDocUUID;
    //         } else {
    //           params.CARGODOC_UUID = StrUtils.isEmpty(cargoDocUUID) ? parentDocument.getCargoDocUUID() : cargoDocUUID;
    //         }
    //       } else {
    //         params.CARGODOC_UUID = "";
    //       }
    //       cargoDocUUID = null;
    //       params.CHARGE_LIST = getSelectChargeList();
    //     }
    //     TemplateSelectorWin.getInstance().showThisWin(job, "JOB_CHARGE", params, this);
  }

  //
  //   /**
  //    * 获取选中的应收应付数据
  //    * @return
  //    */
  getSelectChargeList() {
    //     const list = new ArrayCollection();
    //     //应收
    //     for each(const charge in dgOverseaCost.dataProvider as ArrayCollection) {
    //       if (charge.isSelect) {
    //         list.addItem(charge.key);
    //       }
    //     }
    //     //应付
    //     for each(const charge in dgOverseaSelling.dataProvider as ArrayCollection) {
    //       if (charge.isSelect) {
    //         list.addItem(charge.key);
    //       }
    //     }
    //     return list;
  }
  /**
   * 获取费用结算对象
   */
  async getChargeAccounts(charges = []) {
    const accounts = []
    if (!charges || charges.length === 0) return accounts
    const accountMap = {}
    for (const charge of charges) {
      if (charge.controlled && charge.receivable && !this._view.privilege.isCostControlled) continue // 应收受控不处理
      if (charge.controlled && !charge.receivable && !this._view.privilege.isControlled) continue // 应付受控不处理
      if (!accountMap.hasOwnProperty(charge.accountId)) {
        accountMap[charge.accountId] = true
        const company = await Company.getCompanyById(charge.accountId)
        if (company) {
          accounts.push(company)
        }
      }
    }
    return accounts
  }

  //
  //   /**
  //    * 显示隐藏应收
  //    */
  headConstDoubleClickHandler(e) {
    //     if (e.target != e.currentTarget)
    //       return;
    //     tabSelling.visible = tabSelling.includeInLayout = !tabSelling.visible;
  }

  //
  //   /**
  //    * 显示隐藏应付
  //    */
  headOvereaDoubleClickHandler(e) {
    //     if (e.target != e.currentTarget)
    //       return;
    //     tabCost.visible = tabCost.includeInLayout = !tabCost.visible;
  }

  //
  BillingNoLabel(item, column) {
    //     const _charge = item as Charge;
    //     if (_charge.billing) {
    //       return _charge.billing.billingNo;
    //     }
    //     return _charge.billNo;
  }

  //
  CounterPartyBillingNoLabel(item, column) {
    //     const _charge = item as Charge;
    //     if (_charge.billing) {
    //       return _charge.billing.counterPartyBillingNo;
    //     }
    //     return "";
  }

  //
  conversionRMBLabel(charge) {
    if (charge) {
      const amount = new BigNumber(charge.amount)
      const exchangeRate = new BigNumber(charge.exchangeRate)
      // CARGO-26500，系统利用外币作为本位币进行结算
      // const num = amount.multipliedBy(exchangeRate)
      // const num = NumberUtils.ToFixed2(multiply(amount, exchangeRate), 2)
      const num = NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(multiply(amount, exchangeRate), charge.localCurrency), 2)
      charge.localAmount = num
      return formatNumberToThousands(NumberUtils.formatNumber(num, 2, true), 2).toString()
    }
    return '0.00'
  }

  whtTaxAmountConversionRMBLabel(charge) {
    if (charge) {
      const whtTaxAmount = new BigNumber(charge.whtTaxAmount)
      const exchangeRate = new BigNumber(charge.exchangeRate)
      const num = NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(multiply(whtTaxAmount, exchangeRate), charge.localCurrency), 2)
      charge.whtTaxLocalAmount = num
      return this._view.$numeral(num).format('0.00')
    }
    return '0.00'
  }

  //
  async refreshQuantity(item) {
    const job = this._view.job
    const measure = item.measure
    let quantity = item.quantity
    const quantityStr = item.quantityStr
    if (measure === ChargeMeasure.WGT_CHARGE_MEASURE.code) {
      const weight = ChargeUtils.getChargeWeightValueType(true) === 0 ? job.weightActual : job.weightContract
      if (job instanceof AirExportJob) {
        quantity = weight
      } else if (job instanceof AirImportJob) {
        quantity = job.weightContract
      } else {
        quantity = weight / 1000
        if (quantity < 1) quantity = 1
      }
    } else if (measure === ChargeMeasure.WGTT_CHARGE_MEASURE.code) {
      const weight = ChargeUtils.getChargeWeightValueType(true) === 0 ? job.weightActual : job.weightContract
      if (job === SeaExportJob && BillType.MERGE_BILL_TYPE.code === this.job.typeHBL) {
        const hbl2 = job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
        if (hbl2 && hbl2.weight) {
          quantity = hbl2.weight / 1000
        }
      } else if (job instanceof AirExportJob) {
        quantity = weight / 1000
      } else if (job instanceof AirImportJob) {
        quantity = job.weightContract / 1000
      } else {
        quantity = weight / 1000
        if (quantity < 1) quantity = 1
      }
    } else if (measure === 'WGTX') {
      if (job instanceof AirExportJob) {
        const air = (job)
        // 应收取分单的计费重量,应付取制单的计费重量
        if (this._view.config._getHBLcWeight) {
          quantity = await ChargeUtils.getMHLcWeight(item.receivable, job)
        } else {
          //							if (item.receivable)
          //							{
          quantity = air.cWeight
          // CARGO-7486 应付费用无法带入计费重量价, 和客户确认后应当取实际, 因此取消此处判断
          //							}
          //							else
          //							{
          //								const mawb:AirCargoDoc = AirExportJob(job).getCargoDoc(CargoDocConsts.MAWB, false);
          //								quantity = mawb === null ? 0 : mawb.cWeight;
          //							}
          //						quantity = ChargeUtils.getQuantityForPbProportion2(quantity, air, null, item.receivable);
        }
        //					quantity = JobUtils.safeWeight(quantity);
      } else {
        quantity = job.chargeWeight
      }
    } else if (measure === 'PIECE') {
      if (job instanceof AirExportJob) {
        quantity = (job).quantityActual
      } else if (job instanceof AirImportJob) {
        quantity = (job).quantityContract
      } else if (job instanceof SeaExportJob) {
        quantity = (job).quantityActual
      } else if (job instanceof SeaImportJob) {
        quantity = (job).quantityContract
      } else if (job instanceof RailwayExportJob) {
        quantity = (job).quantityActual
      }
    } else if (measure === 'VOL') {
      quantity = ChargeUtils.getVOLQuantity(job)
    } else if (measure === 'MIN') {
      quantity = 1
    } else if (measure === 'BOX') {
      quantity = 1
    } else if (measure === 'NML') {
      quantity = 1
    } else if (measure === 'CNTR') {
      quantity = 0
      for (const seq of job.seaEQ) {
        quantity += seq.eqQuantity
      }
    } else if (measure === 'BL') {
      quantity = 1
    } else if (measure === 'SHIPMENT') {
      quantity = 1
    } else {
      quantity = this.getEQQuantity(measure)
    }
    if (measure === 'vehicle' || measure === 'day') {
      quantity = 0
    } else if (quantity < 1) {
      quantity = 1
    }
    quantity = await ChargeUtils.getQuantityByChargeWeightValueType2(job, quantity, measure)
    item.measure = measure
    item.quantity = quantity.toFixed(3)
    item.quantityStr = quantityStr
  }

  //
  //   /**
  //    * 统计箱量
  //    */
  getEQQuantity(type) {
    let n = 0
    for (const eq of this._view.job.seaEQ) {
      if (type === 'C20' && eq.eqSize === '20') {
        n = n + eq.eqQuantity
      } else if (type === 'C40' && eq.eqSize === '40' && eq.eqType === 'GP') {
        n = n + eq.eqQuantity
      } else if (type === 'C40H' && eq.eqSize === '40' && eq.eqType === 'HC') {
        n = n + eq.eqQuantity
      } else if (type === 'C45' && eq.eqSize === '45') {
        n = n + eq.eqQuantity
      }
    }
    return n
  }

  //
  //
  onSelectionChange1(event) {
    //     const chargeSelCost = event.currentTarget.selectedItem;
    //     if (chargeSelCost) {
    //       btnDelete1.enabled = editing && isRowEdit(chargeSelCost);
    //       disPatchChargeItem(chargeSelCost as Charge);
    //     }
  }

  //
  onSelectionChange2(event) {
    //     const chargeSelSelling = event.currentTarget.selectedItem;
    //     if (chargeSelSelling) {
    //       btnDelete2.enabled = editing && isRowEdit(chargeSelSelling);
    //       disPatchChargeItem(chargeSelSelling as Charge);
    //     }
  }

  //
  disPatchChargeItem(charge) {
    //     const evt:DynamicEvent = new DynamicEvent("chargeItemEvent");
    //     evt.data = charge;
    //     dispatchEvent(evt);
  }

  //
  isRowEdit(item, isApply = false) {
    return this.shareEnable(item, isApply) && item.shareScheme <= 0 && this._view.settleBranchEnable && this.outChargeEnable(item)
  }

  // CARGO-38835 开启IsReceivedChargeApiAllowedEdit参数时，外部推送费用不允许编辑，但是【备注】要求可以编辑
  isRemarkEdit(params) {
    const dataField = params.colDef.field
    return this.shareEnable(params.data) && params.data.shareScheme <= 0 && this._view.settleBranchEnable && (dataField === 'remarks')
  }

  //
  shareEnable(item, isApply = false) {
    const job = this._view.job
    if (!item || !job || (job.uuid && !item.jobUuid) || item.jobUuid !== job.uuid || item.verifiedAmount !== 0 ||
      item.billingUuid || item.billingPaymentUuid || item.invoiceUuid ||
      item.shared || item.collection || ((item.chargeState !== 0 && item.chargeState !== 3) && !isApply) || (this._view.config.toExoSystemLHEAS && Number(item.externalChargeState) === Number(ChargeConstants.EAS_STATE_SYNC.code) && Number(item.chargeState) === 1) ||
      !this.checkRoleEdit(item) || item.confirmState === 1 || item.agentSharedBillingUuid ||
        (this._view.config.toExoSystemEAS && Number(item.externalChargeState) === Number(ChargeConstants.EAS_STATE_APPROVED.code)) ||
        (item.trustFromCharge && this._view.isCrossTenantSeToSi) || item.syncConfirmStatus === 1 ||
        (this._view.config.toExoSystemYGSH && Number(item.ltsChargeState) === Number(ChargeConstants.HAS_BEEN_SENT.code)) || !this.internalEnable(item) ||
        (this._view.config.chargeSyncNeedConfirm && item.trustFromCharge && item.chargeSource === Number(ChargeUtilsForConstant.CHARGE_SOURCE_EXPORT_SYNC_IMPORT.code)) ||
        item.profitShare || item.chargeSource === SystemConstants.CHARGE_SOURCE_PROFIT_SHARE.code || item.autoGenerated ||
        this.hasGenerateVoucher(item)) {
      return false
    } else {
      return true
    }
  }
  outChargeEnable(item) {
    if (!this._view.config.isReceivedChargeApiAllowedEdit && item.chargeSource === SystemConstants.CHARGE_SOURCE_OUT_PUSH.code) {
      return false
    }
    return true
  }
  // 是否生成凭证，CARGO-32427 ID：10539 宏真 费用生成凭证后做限制不能删除费用
  hasGenerateVoucher(item) {
    return item && (item.voucherDate || item.voucherJob || item.voucherBilling || item.voucherInvoice)
  }
  // 内结费用
  internalEnable(item) {
    if (RateUtil.useOrderCenterMode()) {
      if (item.internalFrom) {
        return false
      } else {
        if (item.internalTo) {
          const job = this._view.job
          if (job && job.charges) {
            for (const internal of job.charges) {
              if (internal.internal && internal.chargeId === item.internalTo) {
                return !(internal.billingUuid || internal.invoiceUuid || internal.billingPaymentUuid || internal.confirmBillUuid || internal.verifiedAmount !== 0)
              }
            }
          }
        }
      }
      return true
    } else {
      return true
    }
  }
  // CARGO-1016 费用做过开票，核销操作后可以做费用分摊操作
  // item.verifiedAmount != 0 || item.billing != null
  // CARGO-19543 业务审核后 财务审核模块里 主票上未分摊的费用允许进行分摊操作
  shareEnableNew(item, adjust = false) {
    const job = this._view.job
    if (!item || !job || !item.jobUuid || item.jobUuid !== job.uuid ||
        (!job.masterFlag && item.shared) || item.collection ||
      !this.checkRoleEdit(item)) {
      return false
    } else {
      return true
    }
  }

  /**
   * 是否同组和全部编辑权限
   */
  checkRoleEdit(item) {
    const charge = item // as Charge;
    if (charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId) {
      return true
    }
    const editArAllCharge = this._view.privilege.editArAllCharge
    const editArDeptCharge = this._view.privilege.editArDeptCharge
    const editApAllCharge = this._view.privilege.editApAllCharge
    const editApDeptCharge = this._view.privilege.editApDeptCharge
    if (charge.receivable) {
      if (editArAllCharge) {
        return true
      }

      if (editArDeptCharge && this.checkDepartmentTeam(charge)) {
        return true
      }
    } else {
      if (editApAllCharge) {
        return true
      }

      if (editApDeptCharge && this.checkDepartmentTeam(charge)) {
        return true
      }
    }
    return false
  }

  /**
   * 是否同组和全部删除权限
   */
  checkRoleDelete(charge) {
    // 商务特殊费用行：使用商务特殊费用删除权限（个人/同组/所有）
    if (charge.businessSpecial) {
      if (this._view.privilege.businessSpecialDeleteAll) {
        return true
      }
      const ownCharge = charge.createdBy === 0 || charge.createdBy === this.$store.getters.userId || charge.inputBy === this.$store.getters.userId
      if (ownCharge && this._view.privilege.businessSpecialDeleteUser) {
        return true
      }
      if (!ownCharge && this._view.privilege.businessSpecialDeleteDept && this.checkDepartmentTeam(charge)) {
        return true
      }
      return false
    }
    if (!charge.createdBy || charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId) {
      return true
    }
    if (charge.receivable) {
      if (this._view.privilege.deleteArAllCharge) {
        return true
      }

      if (this._view.privilege.deleteArDeptCharge && this.checkDepartmentTeam(charge)) {
        return true
      }
    } else {
      if (this._view.privilege.deleteApAllCharge) {
        return true
      }

      if (this._view.privilege.deleteApDeptCharge && this.checkDepartmentTeam(charge)) {
        return true
      }
    }
    return false
  }

  /**
   * 校验应收编辑个人费用权限
   */
  checkEditPersonalArCharge(charge) {
    if (!charge) {
      return false
    }
    if (this._view.job.lob === 'SE' && (charge.uuid && !charge.uuid.startsWith(this._view.tabCost.grid.uuidPrefixRule)) && (charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId)) {
      return this._view.privilege.editPersonalArCharge
    }
    return true
  }

  /**
   * 校验应付编辑个人费用权限
   */
  checkEditPersonalApCharge(charge) {
    if (!charge) {
      return false
    }
    if (this._view.job.lob === 'SE' && (charge.uuid && !charge.uuid.startsWith(this._view.tabSelling.grid.uuidPrefixRule)) && (charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId)) {
      return this._view.privilege.editPersonalApCharge
    }
    return true
  }

  /**
   * 校验应收删除个人费用权限
   */
  checkDeletePersonalArCharge(charge) {
    if (!charge) {
      return false
    }
    if (this._view.job.lob === 'SE' && (charge.uuid && !charge.uuid.startsWith(this._view.tabCost.grid.uuidPrefixRule)) && (charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId)) {
      return this._view.privilege.deletePersonalArCharge
    }
    return true
  }

  /**
   * 校验应付删除个人费用权限
   */
  checkDeletePersonalApCharge(charge) {
    if (!charge) {
      return false
    }
    // 商务特殊费用行走商务特殊费用删除权限（checkRoleDelete），不走该 SE 个人删除权限
    if (charge.businessSpecial) {
      return true
    }
    if (this._view.job.lob === 'SE' && (charge.uuid && !charge.uuid.startsWith(this._view.tabSelling.grid.uuidPrefixRule)) && (charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId)) {
      return this._view.privilege.deletePersonalApCharge
    }
    return true
  }

  rowColor(item) {
    //     if (isRowEdit(item))
    //       return 0;
    //     else
    //       return 0x999999;
  }

  /**
   * 删除费用
   */
  deleteSelling() {
    const overseaSellingDetails = this._view.tabSelling.grid.overseaSellingDetails
    const chooseRows = this._view.tabSelling.grid.gridApi.getSelectedRows()
    // CARGO-14167 业务在正操作的情况下，无法删除可操作费用
    if (!this.checkDeleteCharges(chooseRows, overseaSellingDetails)) return
    if (chooseRows && chooseRows.length > 0) {
      for (const charge of chooseRows) {
        if (!this.isRowEdit(charge) || !this.checkDeletePersonalApCharge(charge) || !this.checkRoleDelete(charge)) {
          // dgOverseaSelling.selectedIndex = i;
          this.$message.warning(this._view.$t('Message.ThereAreFeesCantBeDeletedPleaseRecheck'))
          return
        }
        // 同步的费用不可删除
        if (charge.syncStatus === 1) {
          this.$message.warning(this._view.$t('Message.TheSynchronizedExpensesCannotBeDeleted'))
          return
        }
      }
      for (const charge of chooseRows) {
        // 判断删除的是否是拖车费
        if (charge.chargeItemId === parseInt(this.cacheConfig.get('TruckingFeeCode'))) {
          // todo-shengsheng  Desc: 触发相关事件
          // dispatchEvent(new Event("removeTruckingChargeEvent"));
        }
        charge.deleted = true
        charge.jobUuid = this._view.job.uuid
        // overseaSellingDetails.removeItemAt(i)
        const index = overseaSellingDetails.indexOf(charge)
        overseaSellingDetails.splice(index, 1)
        const index2 = this._view.jobControlledCharges.indexOf(charge)
        this._view.jobControlledCharges.splice(index2, 1)
        this.removeChargeForJob(charge)
        if (charge.uuid && !charge.uuid.startsWith('addTabSelling__') && !charge.uuid.startsWith('addTabCost__')) {
          this._view.tabSelling.grid.deleteUuids.push(charge.uuid)
        }
        this.refreshSerialNumber(charge.receivable, charge.serialNumber) // 序号,递减
        this.removeChargeForModifiedData(charge)
      }

      this.refDgChargeInfo()
    }
  }

  //
  //   private const total1RMB = 0;
  //   private const total1USD = 0;
  //   private const total2RMB = 0;
  //   private const total2USD = 0;
  //   private const costArr = new ArrayCollection();
  //   private const oc:OverseaCostTotal = null;
  //

  // 预估利润计算
  async refreshEstimateProfit(isSyncEstimate = false) {
    const job = this._view.job
    if (job === null) {
      return
    }
    // 判断小票费用是否都是新创建的，如果是，进行预估计算
    let isNewCharge = false
    let index = 0
    if (!job.masterFlag && job.charges && job.charges.length > 0) {
      const chargeList = job.charges
      for (const c of chargeList) {
        if (!c.uuid || c.uuid.startsWith(this._view.tabCost.grid.uuidPrefixRule) || c.uuid.startsWith(this._view.tabSelling.grid.uuidPrefixRule)) {
          index++
        }
      }
      if (index === job.charges.length) {
        isNewCharge = true
      }
    }
    // CARGO-32766 1855：预估费用可在提交【订舱预审】-【待审核】时，进行同步【非正式业务的时候进行同步】
    // if (this._view.config.requireEstimate && StrUtils.isEmpty(job.situation) && (!job.uuid || isNewCharge)) {
    if (this._view.config.requireEstimate && ((StrUtils.isEmpty(job.situation) && (!job.uuid || isNewCharge) && !this._view.config.isBookingFeeMandatoryAppliedGlobally) || isSyncEstimate)) {
      const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(job.opOffice)
      // 应收
      const arTotalList = this._view.$refs.arTotalGroup.resultList
      if (arTotalList != null && arTotalList.length > 0) {
        if (arTotalList.length > 1) {
          for (let i = 0; i < arTotalList.length; i++) {
            const arCurrencyTotalItem = arTotalList[i]
            if (arCurrencyTotalItem.currency === ('折合' + localCurrency)) {
              if (typeof arCurrencyTotalItem.amount === 'object') {
                job.estimateAccountsReceivable = arCurrencyTotalItem.amount.toNumber()
              } else {
                job.estimateAccountsReceivable = arCurrencyTotalItem.amount
              }
              break
            }
          }
        }
        if (arTotalList.length === 1) {
          await this.$refs.arTotalGroup.chargeCurrencyTotalGroupHP.recalcCharge()
          const estimateAccountsReceivable = this.$refs.arTotalGroup.chargeCurrencyTotalGroupHP.getAmountByCurrency(localCurrency)
          if (typeof estimateAccountsReceivable === 'object') {
            job.estimateAccountsReceivable = estimateAccountsReceivable.toNumber()
          } else {
            job.estimateAccountsReceivable = estimateAccountsReceivable
          }
        }
      }
      if (arTotalList === null) {
        job.estimateAccountsReceivable = 0.00
      }
      // 应付
      const apTotalList = this._view.$refs.apTotalGroup.resultList
      if (apTotalList != null && apTotalList.length > 0) {
        if (apTotalList.length > 1) {
          for (let j = 0; j < apTotalList.length; j++) {
            const apCurrencyTotalItem = apTotalList[j]
            if (apCurrencyTotalItem.currency === '折合RMB') {
              if (typeof apCurrencyTotalItem.amount === 'object') {
                job.estimateAccountsPayable = apCurrencyTotalItem.amount.toNumber(2)
              } else {
                job.estimateAccountsPayable = apCurrencyTotalItem.amount
              }
              break
            }
          }
        }
        if (apTotalList.length === 1) {
          await this._view.$refs.apTotalGroup.chargeCurrencyTotalGroupHP.recalcCharge()
          const estimateAccountsPayable = this._view.$refs.apTotalGroup.chargeCurrencyTotalGroupHP.getAmountByCurrency(localCurrency)
          job.estimateAccountsPayable = typeof estimateAccountsPayable === 'object' ? estimateAccountsPayable.toNumber() : estimateAccountsPayable
        }
      }
      if (apTotalList === null) {
        job.estimateAccountsPayable = 0.00
      }
      // 总预估
      job.estimateGrossProfit = NumberUtils.roundHalfUp(job.estimateAccountsReceivable - job.estimateAccountsPayable, 2)
    }
  }

  //
  //   //获取当前费用的汇率
  getChargeRate(currency) {
    //     const rate = 0;
    //     for each (const ch in dgOverseaCost.dataProvider) {
    //       if (ch != null) {
    //         if (ch.currency === currency && ch.exchangeRate != 0) {
    //           rate = ch.exchangeRate;
    //           break;
    //         }
    //       }
    //     }
    //     if (rate === 0) {
    //       for each (const ch1 in dgOverseaSelling.dataProvider) {
    //         if (ch1 != null) {
    //           if (ch1.currency === currency && ch1.exchangeRate != 0) {
    //             rate = ch1.exchangeRate;
    //             break;
    //           }
    //         }
    //       }
    //     }
    //     return rate;
  }
  /**
   * 获取当前分组及上级分组的字段和值
   * @param {Object} node - 当前行节点
   * @returns {Array} 分组层级信息
   */
  getGroupHierarchy(node) {
    const groupInfo = []
    let currentNode = node
    while (currentNode) {
      if (currentNode.field && currentNode.group) {
        groupInfo.unshift({ field: currentNode.field, value: currentNode.key })
      }
      currentNode = currentNode.parent
    }
    return groupInfo
  }

  /**
   * 更新对象的分组字段和值
   * @param {Object} grid - 当前表格实例（Ag-Grid 的 grid 对象）
   * @param {Object} obj - 需要更新的对象，将填充分组字段和值
   */
  updateGroupFields(grid, obj) {
    const groupColumns = grid.groupColumns
    // 无字段分组
    if (!groupColumns || !groupColumns.columns || !groupColumns.columns.length) {
      return
    }

    // 当前点击选中节点
    const node = grid.groupRowNode
    // 如果存在分组节点，获取分组字段和值
    if (node && Object.keys(node).length) {
      const groupInfo = this.getGroupHierarchy(node)
      if (groupInfo?.length > 0) {
        groupInfo.forEach(({ field, value }) => {
          obj[field] = value // 设置分组字段和值
        })
      }
      return
    }

    // 没有选中，获取所有分组列的字段并赋空值
    groupColumns.columns.forEach(val => {
      const field = val.colDef.field
      field && (obj[field] = '')
    })
  }

  /**
   * 更新表格数据并恢复展开状态和滚动位置
   * @param {Object} grid - 当前的表格实例（Ag-Grid 的 grid 对象）
   * @param {Array} data - 当前的表格数据
   * @param {Object} newObj - 需要添加的新的数据项
   * @param {String} key - 用于存储数据的字段名称（如 overseaCostDetails）
   */
  updateGridDataAndRestoreState(grid, newObj, key) {
    if (grid.gridApi) {
      const expanded = new Map()

      // 记录当前的展开状态
      grid.gridApi.forEachNode((node, index) => {
        if (node.key !== null) {
          expanded.set(node.key, node.expanded)
        }
      })
      // 更新表格数据
      const updatedData = [...grid[key], newObj]
      grid.gridApi.setRowData(updatedData)
      grid[key] = updatedData
      this.$nextTick(() => {
        let newRowNode = null
        grid.gridApi.forEachNode((node, index) => {
          // 恢复展开状态
          expanded.forEach((value, key) => {
            if (node.key === key && value) {
              node.setExpanded(value)
            }
          })
          // 查找新增行节点
          if (node?.data?.uuid === newObj.uuid) {
            newRowNode = node
          }
        })

        if (newRowNode) {
          grid.gridApi.ensureIndexVisible(newRowNode.rowIndex, 'middle')
          grid.gridApi.setFocusedCell(newRowNode.rowIndex, 'serialNumber')
        }
      })
    }
  }
  //
  async addSelling() {
    if (!this.checkProvisionFeeLocked()) {
      return
    }
    //
    if (this._view.tabSelling.grid.overseaSellingDetails.length <= 0) {
      this._view.tabSelling.grid.overseaSellingDetails = []
    }
    const obj = new Charge().fillDefaultValue().getData()

    /* 先将费用加入到列表，在列表中显示出来 */
    this.addChargeForJob(obj)
    this._view.jobControlledCharges.push(obj)
    obj.receivable = false
    obj.branchId = this._view.currentSettleBranchId
    obj.serialNumber = this.getMaxSerialNumber(obj.receivable) + 1 // 序号，CARGO-5881，按照录入顺序排序
    // this.$nextTick(() => {
    //   if (this._view.tabSelling.grid.gridApi) {
    //     const len = this._view.tabSelling.grid.overseaSellingDetails.length
    //     this._view.tabSelling.grid.gridApi.forEachNode((node, index) => {
    //       const groupColumns = this._view.tabCost.grid.groupColumns
    //       // 无字段分组
    //       if (!groupColumns || !groupColumns.columns || !groupColumns.columns.length) {
    //         if (len - 1 === index) {
    //           this._view.tabSelling.grid.selectedRow = node.data
    //           this._view.tabSelling.grid.gridApi.setFocusedCell(node.rowIndex, 'serialNumber')
    //           // CARGO-8041 【海运出口-海运订舱极速版】费用页签，新增费用不要默认勾选
    //           // node.setSelected(true)
    //         }
    //       }
    //     })
    //   }
    // })

    const job = this._view.job
    obj.jobUuid = job.uuid
    obj.uuid = this._view.tabSelling.grid.uuidPrefixRule + getUuid()
    if (!this._view.config.isInputChargeBaseOnService) {
      // CARGO-46728 【海运进口】【空运进口】的费用模块【应付】的【结算对象】取值改为：换单代理、【铁路进口】的费用模块【应付】的【结算对象】改为：口岸代理
      if (['SiBooking', 'AiBooking'].includes(this._view.viewSource)) {
        obj.accountId = this._view.job.exChangeAgent
      } else if (this._view.viewSource === 'RailwayBooking' && this._view.job.lob === 'RI') {
        obj.accountId = this._view.job.portAgent
      } else {
        obj.accountId = this._view.job.bookingAgent
      }
      this.updateGroupFields(this._view.tabSelling.grid, obj)
      if (obj.accountId > 0) {
        // 设置开票抬头
        await ChargeUtils.updateDefaultInvoiceTitle([obj])
      }
      await ChargeUtils.getChargeisOverseaNotControlledByConfig(obj)
    }
    obj.measure = this.getMeasureData()
    const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(this._view.privilege.showOtherBranchCharge ? this._view.currentSettleBranchId : this.getBranchIdForCharge())
    if (this._view.config.currencyChangeBySettlementAccount === 2 || this._view.config.currencyChangeBySettlementAccount === 1) {
      obj.localCurrency = localCurrency
    }
    obj.currency = obj.oversea ? 'USD' : localCurrency
    obj.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, obj.currency, job, obj.branchId, function(rate) {
      obj.exchangeRate = rate
    })
    obj.inputBy = this.$store.getters.userId
    // New charge: use currently selected department (editing should keep original value).
    obj.inputByDep = Number(this.$store.getters.currentDeptId) || Number(this._view.job.opDepartment) || 0
    // HQ币种/汇率
    obj.hqCurrency = RateUtil.getHqCurrency(obj.branchId)
    obj.hqRate = await RateUtil.getForeignExchangeRateByJob(obj.hqCurrency, localCurrency, job, obj.branchId)
    obj.inputDate = DateUtils.formatStandardDateTime(new Date())
    obj.unitRate = 0
    obj.amount = 0
    obj.taxAmount = 0 //
    obj.excludingTaxAmount = 0
    obj.verifiedAmount = 0
    obj.taxRate = ChargeUtils.getTaxRateAtCreateCharge(obj)
    obj.accountingDate = null
    obj.counterPartyBillingNo = null
    obj.chargeSource = this._view.chargeSource
    obj.chargeState = 0
    obj.unitPriceIncludeTax = this._view.config.inputIncludingTaxUnitPrice === 2
    if (this._view.config.openHecConfig) {
      obj.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
    }
    obj.accountId = Number(obj.accountId) > 0 ? Number(obj.accountId) : 0
    if (obj.accountId && obj.accountId > 0) {
      // 加载结算代理
      await this.getSettlementByCompanyId(obj)
    }

    if (obj.accountId && obj.accountId > 0) {
      // 加载联系人
      await ChargeColumnUtil.getContactsByCompanyId(obj.accountId, this._view.currentViewCacheData)
      // 加载开票抬头
      await this.getTitlesByCompanyId(obj)
    }
    const canChangeOverseaOfCharge = parseInt(this.cacheConfig.get('canChangeOverseaOfCharge'))
    if (canChangeOverseaOfCharge !== 2 && canChangeOverseaOfCharge !== 3) {
      if (obj.invoiceTitle) {
        const flag = ChargeUtils.updateOverseaByInvoiceTitle(obj, this._view.getInvoiceTitleList(obj.accountId))
        if (!flag && obj.accountId > 0) {
          await ChargeUtils.updateOverseaByAccountId(obj)
        }
      } else if (obj.accountId > 0) {
        await ChargeUtils.updateOverseaByAccountId(obj)
      }
    }
    this.updateGridDataAndRestoreState(this._view.tabSelling.grid, obj, 'overseaSellingDetails')
  }

  // 财务审核 增加/修改/删除调整
  async addCostAdjust(editMode, isAr, adjust = true, isOffsetState = true) {
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this._view.job)
    if (warnflag) {
      this.$message.warning(this._view.$t('CargoMsg.NOT_OPERATIONAL'))
      return
    }
    if (this._view.viewSource === 'salesDetail') {
      if (!await this.checkChargeLocked(isAr)) {
        return
      }
      if (editMode === 'add') {
        await this.addChargeForSales(editMode, isAr)
        return
      }
      await this.addCostChange(editMode, isAr, adjust, isOffsetState)
      return
    }
    const list = this.readSelectedRows(isAr, false)
    if (list && list.length > 1 && editMode === 'del') {
      const editModeMsg = this._view.$t('FinanceManage.charge_deleteAdjustment')
      if (adjust && Number(this.cacheConfig.get('JobAndChargeSubmitterAndAuditorCanNotSame')) === 1 && this._view.job.commitUser === this.$store.getters.userId) {
        this.$message.warning(this._view.$t('FinanceManage.JobSubmitNotAllowCancelAdjustCosts'))
        return
      }
      const chargeKeys = []
      for (const charge of list) {
        if (charge.offsetState !== 0 && !isOffsetState) {
          this.$message.warning(this._view.$t('Message.RedChargeOrRedChargedCannotBeDeletedPleaseReselect'))
          return
        }
        if (adjust && this.hasGenerateVoucher(charge)) {
          this.$message.warning(this._view.$t('Message.ApplyChangeChargeNotThrough', [this._view.$t('CargoMsg.Cargo_CreateVoucher'), editModeMsg]))
          return
        }
        chargeKeys.push(charge.uuid)
      }
      await batchCheckChargeByAdjust(chargeKeys).then(res => {
        if (res.data) {
          this.openBatchDeleteAdjustWindow(list, isAr)
        } else {
          this.$message.warning(this._view.$t('Message.PleaseRefresh'))
        }
      }).catch((err) => {
      })
    } else {
      let obj
      if (isAr) {
        obj = this._view.tabCost.grid.selectedRow
      } else {
        obj = this._view.tabSelling.grid.selectedRow
      }
      if (editMode === 'edit' && !adjust && !this.checkAdjust(obj)) {
        this.$message.warning(this._view.$t('Message.TheChargesHaveBeenSettledByFinancialAccountAndCannotBeAmended'))
        return
      }
      if (editMode === 'edit' && !isOffsetState) {
        if (obj.offsetState !== 0) {
          this.$message.warning(this._view.$t('Message.RedChargeOrRedChargedCannotBeEditAdjustAgainPleaseSelectNewAdjustment'))
          return
        }
      }
      if (editMode === 'del' && !isOffsetState) {
        if (obj.offsetState !== 0) {
          this.$message.warning(this._view.$t('Message.RedChargeOrRedChargedCannotBeDeletedPleaseReselect'))
          return
        }
      }
      if (adjust && Number(this.cacheConfig.get('JobAndChargeSubmitterAndAuditorCanNotSame')) === 1 && this._view.job.commitUser === this.$store.getters.userId) {
        this.$message.warning(this._view.$t('FinanceManage.JobSubmitNotAllowCancelAdjustCosts'))
        return
      }
      if (editMode === 'edit' || editMode === 'del') {
        if (adjust && this.hasGenerateVoucher(obj)) {
          const editModeMsg = editMode !== 'del' ? this._view.$t('FinanceManage.charge_editAdjustment') : this._view.$t('FinanceManage.charge_deleteAdjustment')
          this.$message.warning(this._view.$t('Message.ApplyChangeChargeNotThrough', [this._view.$t('CargoMsg.Cargo_CreateVoucher'), editModeMsg]))
          return
        }
        await checkChargeByAdjust(obj.uuid).then(res => {
          if (res.data) {
            this.openAdjustWindow(editMode, adjust, isAr, obj)
          } else {
            this.$message.warning(this._view.$t('Message.PleaseRefresh'))
          }
        }).catch((err) => {
        })
      } else {
        if (editMode === 'add') {
          obj = new Charge().fillDefaultValue().getData()
          const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(this._view.privilege.showOtherBranchCharge ? this._view.currentSettleBranchId : this.getBranchIdForCharge())
          obj.localCurrency = localCurrency
          obj.currency = localCurrency
          obj.branchId = this._view.currentSettleBranchId
          obj.unitPriceIncludeTax = this._view.config.inputIncludingTaxUnitPrice === 2
        }
        this.openAdjustWindow(editMode, adjust, isAr, obj)
      }
    }
  }
  openAdjustWindow(editMode, adjust, isAr, obj) {
    this._view.adjustWindow.defaultProperties.editMode = editMode
    this._view.adjustWindow.defaultProperties.isAdjust = adjust
    this._view.adjustWindow.defaultProperties.isAr = isAr
    this._view.adjustWindow.defaultProperties.job = this._view.job
    this._view.adjustWindow.defaultProperties.charge = obj
    this._view.adjustWindow.defaultProperties.companyFactorySigns = []
    if (isAr && this._view.config.arSettlementUnitOptional) {
      this._view.adjustWindow.defaultProperties.companyFactorySigns = this._view.companyFactorySigns
    }
    this._view.adjustWindow.visible = true
  }
  async checkChargeLocked(isAr, isChargeScheme = false) {
    const job = await getJobByUuid(this._view.job.uuid).then(res => res.data)
    if (isChargeScheme) {
      if (job.receivableChargeLockedStatus || job.payableChargeLockedStatus) {
        this.$message.warning(this._view.$t('SeaExport.ChargeLocked'))
        return false
      }
    } else {
      if (isAr && job.receivableChargeLockedStatus) {
        this.$message.error(this._view.$t('SeaExport.ArChargeLocked'))
        return false
      } else if (!isAr && job.payableChargeLockedStatus) {
        this.$message.error(this._view.$t('SeaExport.ApChargeLocked'))
        return false
      }
    }
    return true
  }
  checkProvisionFeeLocked() {
    const lock = this._view.provisionLock || (this._view.job && this._view.job.provisionLock)
    if (lock && lock.feeLocked) {
      this.$message.error('已计提校准，不可新增应收应付费用')
      return false
    }
    return true
  }
  openBatchDeleteAdjustWindow(charges, isAr) {
    this._view.batchDeleteAdjustWindow.charges = charges
    this._view.batchDeleteAdjustWindow.isAr = isAr
    this._view.batchDeleteAdjustWindow.job = this._view.job
    this._view.batchDeleteAdjustWindow.visible = true
  }
  // 验证是否可删除
  checkAdjustDelete(item) {
    if (!item) {
      return false
    }

    if (Number(item.verifiedAmount) !== 0 || item.billingUuid || item.billingPaymentUuid ||
      item.invoiceUuid || item.confirmBillUuid) {
      return false
    }
    return true
  }

  // 验证是否可修改
  checkAdjust(item) {
    if (!item) {
      return false
    }

    if (Number(item.verifiedAmount) !== 0 || item.billingUuid || item.billingPaymentUuid ||
      item.invoiceUuid || item.shared || item.collection) {
      return false
    }
    return true
  }

  // 财务审核删除【删除改单费用】
  async deleteAdjust(isAr) {
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this._view.job)
    if (warnflag) {
      this.$message.warning(this._view.$t('CargoMsg.NOT_OPERATIONAL'))
      return
    }
    if (this._view.viewSource === 'salesDetail') {
      const list = this.readSelectedRows(isAr, false)
      if (!list || list.length === 0) {
        this.$message.warning(this._view.$t('Message.PleaseCheckAtLeastOnePieceOfData'))
        return
      }
      for (const charge of list) {
        if (!this.isRowEdit(charge)) {
          this.$message.warning(this._view.$t('Message.ThereAreFeesCantBeDeletedPleaseRecheck'))
          return
        }
      }
      if (!await this.checkChargeLocked(isAr)) {
        return
      }
      this.$confirm(this._view.$t('Message.AreYouSureYouWantToDeleteTheSelectedFee'), this._view.$t('common.tips.prompt'), {
        confirmButtonText: this._view.$t('common.btn.ok'),
        cancelButtonText: this._view.$t('common.btn.cancel'),
        type: 'info'
      }).then(() => {
        batchDeleteCharge(list).then(async res => {
          if (res.data) {
            this._view.context.reloadCharge = true
            await this.clickHandler1Handler()
          }
        }).catch((err) => {
          this.$message.error(err)
        })
      }).catch(() => {
      })
    } else {
      await this.doDeleteAdjust(isAr)
    }
  }

  async doDeleteAdjust(isAr) {
    const charges = this.readSelectedRows(isAr, false)
    if (!charges || charges.length === 0) {
      this.$message.warning(this._view.$t('Message.PleaseCheckAtLeastOnePieceOfData'))
      return
    }
    for (const charge of charges) {
      if (!this.checkAdjustDelete(charge)) {
        this.$message.warning(this._view.$t('Message.ThereAreFeesCantBeDeletedPleaseRecheck'))
        return
      }
      charge.needDeleted = true // 需要删除此数据
    }
    this.$confirm(this._view.$t('Message.AreYouSureYouWantToDeleteTheSelectedFee'), this._view.$t('common.tips.prompt'), {
      confirmButtonText: this._view.$t('common.btn.ok'),
      cancelButtonText: this._view.$t('common.btn.cancel'),
      type: 'info'
    }).then(() => {
      saveAdjustJob(charges, { editMode: 'del', location: this._view.location }).then(async res => {
        if (res.data) {
          await this.clickHandler1Handler()
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    }).catch(() => {
    })
  }

  // 费用调整回调函数 重新刷新费用
  async clickHandler1Handler() {
    if (this._view.job.uuid) {
      const curJob = await getJobByUuid(this._view.job.uuid).then(res => res.data)
      if (curJob) {
        this._view.job.version = curJob.version
      }
    }
    await this._view.onShow(this._view.job, true)
    this._view.tabCost.grid.selectedRow = null
    this._view.tabSelling.grid.selectedRow = null
    this.loadForBookingResultHandler()
  }

  //   /**
  //    * 获取费用项的显示列
  //    */
  getChargeItemColumn(grid) {
    //     const index = -1;
    //     if (grid && grid.columns) {
    //       const i = 0;
    //       const column;
    //       for (i = 0; i < grid.columns.length; i++) {
    //         column = grid.columns[i] as DataGridColumn;
    //         if (column && column.dataField === 'chargeItemId' && column.visible) {
    //           index = i;
    //           break;
    //         }
    //       }
    //       if (index === -1) {
    //         for (i = 0; i < grid.columns.length; i++) {
    //           column = grid.columns[i] as DataGridColumn;
    //           if (column && column.visible && column.editable) {
    //             index = i;
    //             break;
    //           }
    //         }
    //       }
    //     }
    //     return index;
  }

  /**
   * @private
   */
  queryActualAmountHandler(result = null) {
    const job = this._view.job
    if (result) {
      const resultMap = new Map()
      for (const obj of result) {
        resultMap.set(obj.uuid, obj)
      }
      if (result.length > 0 && job && job.charges) {
        for (const charge of job.charges) {
          if (resultMap.has(charge.uuid)) {
            charge.actualAmountNo2 = resultMap.get(charge.uuid)['actualAmountNo']
          } else {
            charge.actualAmountNo2 = ''
          }
        }
      }
    }
    if (!this._view.privilege.enableCommission) { // 非佣金
      this._view.needLoadDeptUser = false
      this._view.tabCost.grid.overseaCostDetails = []
      this._view.tabSelling.grid.overseaSellingDetails = []
      this._view.jobControlledCharges = []
      if (this._view.isOtherSettleBranchId || (this._view.privilege.queryArAllRole || this._view.privilege.queryApAllRole)) {
        this.extractCharges(job)
        this.showLclCharge()
        this.sortCharges()
        this.refDgChargeInfo()
      } else if (this._view.privilege.queryArDeptChargeRole || this._view.privilege.queryApDeptChargeRole) {
        this._view.needLoadDeptUser = true
        this.getUserDepartmentTeam()
      } else {
        this.extractCurrentUserCharge(job)
        this.extractCurrentUserLCLCharge()
        this.sortCharges()
        this.refDgChargeInfo()
      }
      if (!this._view.needLoadDeptUser) {
        this.getUserDepartmentTeam()
      }
    } else { // 佣金
      this.chkShowCommonChargeHandler(null)
    }
  }

  /**
   * 查询同部门的人
   */
  async getUserDepartmentTeam() {
    if (!this._view.departmentTeamUser || this._view.departmentTeamUser.length <= 0) {
      const res = await User.getUserDepartmentTeam()
      this.getUserDepartmentTeamHandler(res)
    } else {
      this.getUserDepartmentTeamHandler()
    }
  }

  /**
   * 排序
   */
  sortCharges() {
    ChargeUtils.sortCharges(this._view.tabCost.grid.overseaCostDetails)
    ChargeUtils.sortCharges(this._view.tabSelling.grid.overseaSellingDetails)
  }

  /**
   * 排序
   */
  sortCharges2(list, c) {
    if (!list) {
      return
    }
    const costCollation = {}
    for (const data of c) {
      if (data.sort) {
        costCollation[data.colId] = data.sort
      }
    }
    ChargeUtils.sortCharges2(list, costCollation)
  }
  /**
   * @private
   */
  getUserDepartmentTeamHandler(results = null) {
    if (results != null) {
      this._view.departmentTeamUser = results
    }
    if (this._view.needLoadDeptUser) {
      if (this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) {
        this.extractDepartmentTeamCharge(this._view.job)
        this.extractDepartmentTeamLCLCharge()
      } else {
        this.extractCurrentUserCharge(this._view.job)
        this.extractCurrentUserLCLCharge()
      }
      this.refDgChargeInfo()
    }
  }

  //
  /**
   * 同组和本人费用
   */
  extractDepartmentTeamCharge(job) {
    this.extractCharges(job, true)
  }

  /**
   * 同组小票费用
   */
  extractDepartmentTeamLCLCharge() {
    if (this._view.checkbox.chkLcLCharge.visible && this._view.checkbox.chkLcLCharge.selected) {
      for (const j of this._view.job.lclSlaves) {
        this.extractDepartmentTeamCharge(j)
      }
      this.refDgChargeInfo()
    }
  }

  /**
   * 本人费用
   */
  extractCurrentUserCharge(job) {
    this.extractCharges(job, false, true)
  }

  //
  /**
   * 同组小票费用
   */
  extractCurrentUserLCLCharge() {
    if (this._view.checkbox.chkLcLCharge.visible && this._view.checkbox.chkLcLCharge.selected) {
      for (const j of this._view.job.lclSlaves) {
        this.extractCurrentUserCharge(j)
      }
      this.refDgChargeInfo()
    }
  }

  //
  //   /**
  //    * 同组费用查看
  //    */
  checkDepartmentTeam(charge) {
    if (!charge.createdBy || charge.createdBy === 0 || charge.inputBy === this.$store.getters.userId || charge.createdBy === this.$store.getters.userId) {
      return true
    }
    // console.log('checkDepartmentTeam this._view.departmentTeamUser', this._view.departmentTeamUser)
    for (const userId of this._view.departmentTeamUser) {
      if (userId === charge.inputBy || userId === charge.createdBy) {
        return true
      }
    }

    return false
  }

  /**
   * 显示分票信息
   */
  async showLclCharge() {
    if (this._view.checkbox.chkLcLCharge.visible && this._view.checkbox.chkLcLCharge.selected) {
      if (!this._view.editing) {
        await JobUtils.getLclSlavesAndCharges(this._view.job)
      }
      for (const j of this._view.job.lclSlaves) {
        this.extractCharges(j)
      }
      this.refDgChargeInfo()
    }
  }

  /**
   * 更新表格费用(同步)
   */
  refDgChargeInfo() {
    if (this._view.checkbox.chkShowSharedCharge.visible) {
      for (const charge of this._view.job.charges) {
        if (RateUtil.useOrderCenterMode() && charge.branchId !== this._view.currentSettleBranchId && this._view.settleBranchId > 0 &&
            !(this._view.privilege.enableCommission && charge.special && !this._view.job.opOffice_original && this._view.job.opOffice === this.$store.getters.currentOfficeId && (this._view.settleBranchId === 0 || this._view.settleBranchId === this._view.job.opOffice))) {
          continue
        }
        if (RateUtil.useOrderCenterMode() && this._view.settleBranchId === 0 && this._view.privilege.enableCommission && charge.special && this._view.job.opOffice_original) {
          continue
        }
        if (charge.shared) {
          if (this._view.checkbox.chkShowSharedCharge.selected) { // 分摊费用
            // 这一步移动到【extractCharges】方法中参与权限验证了
            // 显示分摊费用方法【chkShowSharedChargeHandler】
            // if (charge.receivable) {
            //   if (this._view.tabCost.grid.overseaCostDetails.findIndex(item => charge.uuid === item.uuid) === -1) {
            //     this._view.tabCost.grid.overseaCostDetails.push(charge)
            //   }
            // } else {
            //   if (this._view.tabSelling.grid.overseaSellingDetails.findIndex(item => charge.uuid === item.uuid) === -1) {
            //     this._view.tabSelling.grid.overseaSellingDetails.push(charge)
            //   }
            // }
          } else {
            if (charge.receivable) {
              this._view.tabCost.grid.overseaCostDetails = this._view.tabCost.grid.overseaCostDetails.filter(item => {
                return item.uuid !== charge.uuid
              })
            } else {
              this._view.tabSelling.grid.overseaSellingDetails = this._view.tabSelling.grid.overseaSellingDetails.filter(item => {
                return item.uuid !== charge.uuid
              })
            }
          }
        }
      }
    }

    // this._view.tabCost.grid.gridOptions.api.redrawRows()
    // this._view.tabSelling.grid.gridOptions.api.redrawRows()
    // overseaCostDetails.refresh();
    // overseaSellingDetails.refresh();
    // 开了参数，业务状态 非待审核或者拒绝，就不验证
    if (!this._view.job.uuid && parseInt(this.cacheConfig.get('saveCharge')) === 1) {
      if (this._view.tabCost.grid.overseaCostDetails.length === 0) {
        this._view.job.estimateAccountsReceivable = 0.00
      }
      if (this._view.tabSelling.grid.overseaSellingDetails.length === 0) {
        this._view.job.estimateAccountsPayable = 0.00
      }
    }
    this._view.job.estimateGrossProfit = this._view.job.estimateAccountsReceivable - this._view.job.estimateAccountsPayable
    const arList = this.getArTotalCharges(this._view.tabCost.grid.overseaCostDetails)
    const apList = this.getApTotalCharges(this._view.tabSelling.grid.overseaSellingDetails)
    this._view.arAuxiliaryDataMap = this.getCurrencyTotalMap(arList)
    this._view.apAuxiliaryDataMap = this.getCurrencyTotalMap(apList)
    this._view.arTotalGroup.dataProvider = arList
    this._view.apTotalGroup.dataProvider = apList
    this._view.revenueTotalGroup.dataProvider = this._view.privilege.showControlledProfit ? this._view.jobControlledCharges : this.getTotalCharges()
    // 刷新预估利润
    this.$nextTick(async() => {
      await this.refreshEstimateProfit()
    })
  }

  /**
   * 获取总的应付金额
   */
  getApTotalCharges(charges) {
    const aps = []
    // 商务特殊费用不参与应付汇总统计（明细行照常显示）
    aps.push(...charges.filter(charge => !charge.businessSpecial))
    if (this._view.privilege.showControlledProfit) {
      for (const charge of this._view.jobControlledCharges) {
        if (!charge.receivable && !charge.businessSpecial && charge.controlled && !this._view.privilege.isControlled && !aps.includes(charge)) {
          aps.push(charge)
        }
      }
    }
    return aps
  }

  /**
   * 获取总的应收金额
   */
  getArTotalCharges(charges) {
    const ars = []
    ars.push(...charges)
    if (this._view.privilege.showControlledProfit) {
      for (const charge of this._view.jobControlledCharges) {
        if (charge.receivable && charge.controlled && !this._view.privilege.isCostControlled && !ars.includes(charge)) {
          ars.push(charge)
        }
      }
    }
    return ars
  }

  /**
   * 获取总的应收应付金额（利润/毛利率口径：剔除商务特殊费用，见 chargeProfitTotal）
   */
  getTotalCharges() {
    return mergeChargesForProfitTotal(this._view.tabCost.grid.overseaCostDetails, this._view.tabSelling.grid.overseaSellingDetails)
  }

  /**
   * 费用添加验证
   */
  checkChargeAdd(charge) {
    const controlled = charge.controlled && ((charge.receivable && !this._view.privilege.isCostControlled) || (!charge.receivable && !this._view.privilege.isControlled))
    if (controlled) {
      if (this._view.privilege.showControlledProfit) {
        this._view.jobControlledCharges.push(charge)
      }
      return false
    }
    if (charge.advance) {
      return false
    }
    if (this._view.chargeSource === parseInt(ChargeUtilsForConstant.CHARGE_SOURCE_WAREHOUSE.code) && charge.chargeSource !== parseInt(ChargeUtilsForConstant.CHARGE_SOURCE_WAREHOUSE.code)) {
      return false
    }
    if (!this._view.checkbox.chkOffset.selected && charge.offsetState > 0) {
      return false
    }

    return true
  }

  /**
   * 是否可编辑列
   */
  isEditColumn(params) {
    return this.chargeGridItemEditBeginningHandler(params)
  }

  /**
   * @private
   */
  chargeGridItemEditBeginningHandler(params) {
    const dataField = params.colDef.field
    // console.log('params.colDef', params.colDef)
    // console.log('params======', params)
    // console.log('params.colDef', this._view.tabCost.grid.gridOptions)
    const office = this.$store.getters.currentOffice
    const charge = params.data
    if (charge) {
      if (dataField === 'serviceType' && (charge.serviceType > 0 || !this._view.config.isInputChargeBaseOnService)) {
        return false
      } else if (dataField === 'accountId' && this.checkAccountPreventDefault('dgOverseaSelling') && charge.serviceType === 0) {
        return false
      } else if (dataField === 'exchangeRate' && office && office.currency === charge.currency) {
        return false
      } else if (dataField === 'oversea' && parseInt(this.cacheConfig.get('canChangeOverseaOfCharge')) === 0) {
        return false
      }
    }
    return true
  }

  /**
   * 是否可编辑
   */
  checkAccountPreventDefault(gridId) {
    if (gridId === 'dgOverseaSelling') {
      // todo-shengsheng  Desc: serviceTypeOnSellingColumn 服务类型的列状态 需判断
      return this._view.config.isInputChargeBaseOnService && (this._view.tabSelling.grid.gridOptions.columnApi.getAllDisplayedColumns().findIndex(column => column.colDef.field === 'serviceType') !== -1)
    }
    // todo-shengsheng  Desc: serviceTypeOnSellingColumn 服务类型的列状态 需判断
    //   return this._view.config.isInputChargeBaseOnService && serviceTypeOnCostColumn.visible;
    return this._view.config.isInputChargeBaseOnService && (this._view.tabCost.grid.gridOptions.columnApi.getAllDisplayedColumns().findIndex(column => column.colDef.field === 'serviceType') !== -1)
  }

  /**
   * 应收,应付用同一个事件
   */
  async chargeGridItemEditEndHandler(params) {
    const charge = params.data
    charge.modifiedBy = this.$store.getters.userId
    charge.changer = this.$store.getters.userId
    charge.dateModified = DateUtils.formatStandardDateTime(new Date())
    // if (charge.receivable && String(charge.taxRate) === 'NaN') {
    //   const office = this.$store.getters.currentOffice
    //   if (office && String(office.taxRate) !== 'NaN') {
    //     charge.taxRate = office.taxRate
    //   }
    // }
    // console.log('chargeGridItemEditEndHandler 编辑前', charge)
    const oldInvoceTitle = charge.invoiceTitle
    const oldChargeItemId = charge.chargeItemId
    const oldWhtTaxRate = charge.whtTaxRate
    const oldExcludingTaxAmount = charge.excludingTaxAmount
    await this.gridDataFieldChanged(params)

    // 加载开票抬头
    await this.getTitlesByCompanyId(charge)

    // CARGO-18184 H5：新增费用时，联系人不应自动带出
    // CARGO-18168 费用的联系人根据结算单位自动带出。费用的 联系人已有值的情况下 ，切换结算单位不会自动带出或者重置联系人信息
    // 加载联系人
    // if (!charge.contactPerson) {
    //   const contacts = await this.getContactsByCompanyId(charge.accountId)
    //   charge.contactPerson = (contacts && contacts.length >= 0) ? contacts[0].contactPerson : ''
    // }
    if (charge.contactPerson && charge.accountId > 0) {
      // 检查联系人是否属于当前结算单位
      const contacts = await ChargeColumnUtil.getContactsByCompanyId(charge.accountId, this._view.currentViewCacheData)
      let has = false
      for (const c of contacts) {
        if (c.contactPerson === charge.contactPerson) {
          has = true
        }
      }
      if (!has) {
        charge.contactPerson = ''
      }
    }
    if (charge.accountId === 0 || charge.accountId === '') {
      charge.contactPerson = ''
    }
    // CARGO-31783 费用页签新增【结算类型】显示列（更改结算对象刷新结算类型）
    if (charge.accountId > 0) {
      const creditInfo = this._view.creditInfoVOMap[charge.accountId]
      if (creditInfo) {
        charge.settlementType = creditInfo.creditDateLimited > 0
        // 绑定了【真实规则】的合同，编辑时不展示结算类型
        charge.normalRuleContactExist = creditInfo.normalRuleContactExist
      } else {
        // const cmp = await Company.getCompanyById(charge.accountId)
        // if (cmp) {
        //   await Company.loadCreditInfo(cmp.uuid).then(list => {
        //     if (list[0]) {
        //       charge.settlementType = list[0].creditDateLimited > 0
        //       this._view.creditInfoVOMap[charge.accountId] = list[0]
        //     }
        //   })
        // }
        CreditInfo.checkCreditInfo(charge.accountId).then(res => {
          if (res.data && res.data.length > 0) {
            charge.settlementType = res.data[0].creditDateLimited > 0
            // 绑定了【真实规则】的合同，编辑时不展示结算类型
            charge.normalRuleContactExist = res.data[0].normalRuleContactExist
            this._view.creditInfoVOMap[charge.accountId] = res.data[0]
          }
        })
      }
    }
    if (isNaN(charge.unitRate) || charge.unitRate === 0) {
      charge.unitRate = Number((charge.excludingTaxAmount / charge.quantity).toFixed(3))
      if (this._view.config.inputIncludingTaxUnitPrice) {
        charge.unitRate = Number((charge.taxAmount / charge.quantity).toFixed(3))
      }
    }
    if (isNaN(charge.excludingTaxAmount)) {
      charge.excludingTaxAmount = 0
    }

    // dataGrid.invalidateList();
    // dataGrid.validateNow();
    this._view.arTotalGroup.dataProvider = this.getArTotalCharges(this._view.tabCost.grid.overseaCostDetails)
    this._view.apTotalGroup.dataProvider = this.getApTotalCharges(this._view.tabSelling.grid.overseaSellingDetails)
    this._view.arAuxiliaryDataMap = this.getCurrencyTotalMap(this._view.arTotalGroup.dataProvider)
    this._view.apAuxiliaryDataMap = this.getCurrencyTotalMap(this._view.apTotalGroup.dataProvider)
    charge.verifiedAmount = 0
    charge.remainAmount = 0
    // 刷新预估利润
    this.$nextTick(async() => {
      await this.refreshEstimateProfit()
    })

    const office = this._view.$store.getters.currentOffice
    if (!charge.whtTaxRate && office.whtTaxMode && charge.invoiceTitle && charge.chargeItemId && (charge.invoiceTitle !== oldInvoceTitle || params.field === 'invoiceTitle' ||
      charge.chargeItemId !== oldChargeItemId || params.field === 'chargeItemId')) {
      const invoiceTitleList = this._view.getInvoiceTitleList(charge.accountId)
      if (invoiceTitleList) {
        const invoiceTitle = invoiceTitleList.find(p => p.title === charge.invoiceTitle)
        if (invoiceTitle && invoiceTitle.suitWhtTax) {
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
          if (chargeItem && chargeItem.defaultWhtRate > 0) {
            charge.whtTaxRate = chargeItem.defaultWhtRate
          }
        }
      }
    }
    if (charge.whtTaxRate !== oldWhtTaxRate || params.field === 'whtTaxRate' || charge.excludingTaxAmount !== oldExcludingTaxAmount) {
      if (charge.whtTaxRate > 0 && charge.excludingTaxAmount > 0) {
        charge.whtTaxAmount = NumberUtils.ToFixed2(charge.excludingTaxAmount * charge.whtTaxRate / 100, 2)
      } else {
        charge.whtTaxAmount = 0
      }
    }

    // console.log('编辑单元格后的 结果为：params', params.data)
    // 开启更新 // todo-shengsheng  Desc: 替换为 agGrid 的更新表格的方式   this._view.tabCost.grid.gridApi.setColumnDefs(this.getDynamicColumnDefsForCost())

    if (charge.receivable && this._view.tabCost.grid.gridApi) this._view.tabCost.grid.gridApi.refreshCells({ force: true }) // 刷新
    if (!charge.receivable && this._view.tabSelling.grid.gridApi) this._view.tabSelling.grid.gridApi.refreshCells({ force: true }) // 刷新
    this.refreshProfitTotalComponent()
  }

  /**
   * @private
   */
  async gridDataFieldChanged(params) {
    const charge = params.data
    if (charge.receivable) {
      // 修改的費用只需要考虑数据库中存在的，新增的费用不用管
      if (!charge.uuid.startsWith(this._view.tabCost.grid.uuidPrefixRule)) {
        this._view.tabCost.grid.modifyUuids.push(charge.uuid)
      }
    } else {
      // 修改的費用只需要考虑数据库中存在的，新增的费用不用管
      if (!charge.uuid.startsWith(this._view.tabSelling.grid.uuidPrefixRule)) {
        this._view.tabSelling.grid.modifyUuids.push(charge.uuid)
      }
    }
    const isRowEdit = this.isRowEdit(charge)
    const job = this._view.job
    const currentViewCacheData = this._view.currentViewCacheData
    const oldInvoceTitle = charge.invoiceTitle
    // debugger
    switch (params.field) {
      case 'chargeItemId': {
        await ChargeColumnUtil.chargeItemChange(charge, params, isRowEdit, job, currentViewCacheData, 1, true, this._view.config.accountObjectControlMode, this._view.config.toExoSystemZY, this._view.isExcludedOffice)
        break
      }
      case 'accountId': {
        await ChargeColumnUtil.accountIdChange(charge, params, isRowEdit, job, this._view, currentViewCacheData, 1, this._view.config.currencyChangeBySettlementAccount)
        JobUtils.handleChargeCreditRemind(this._view.creditConfig, job, charge, 'accountId')
        break
      }
      case 'measure': {
        await ChargeColumnUtil.changeChargeMeasureCombo(charge, params, job)
        break
      }
      case 'currency': {
        await ChargeColumnUtil.currencyChangeHandler(charge, job)
        break
      }
      case 'quantity': {
        await ChargeColumnUtil.quantityChange(charge, params)
        break
      }
      case 'unitRate': {
        await ChargeColumnUtil.unitRateChange(charge, params)
        break
      }
      case 'amount': {
        await ChargeColumnUtil.amountChange(charge, params)
        break
      }
      case 'excludingTaxAmount': {
        await ChargeColumnUtil.excludingTaxAmountChange(charge, params)
        break
      }
      case 'taxRate': {
        await ChargeColumnUtil.taxRateChange(charge, params)
        break
      }
      case 'unitPrice': {
        if (!charge.receivable) {
          const unitPriceData = params.value
          params.data.unitPrice = NumberUtils.formatNumber(NumberUtils.formatNumber(unitPriceData, 2))
        }
        break
      }
      case 'invoiceTitle': {
        charge.invoiceTitle = params.value
        break
      }
      case 'unitPriceIncludeTax': {
        await ChargeColumnUtil.unitPriceIncludeTaxChange(charge)
        break
      }
      case 'relationContainerNo': {
        if (params.value && params.value.length > 0) {
          charge.relationContainerNo = params.value.join()
        } else {
          charge.relationContainerNo = ''
        }
        break
      }
      case 'settlementAgentId': {
        charge.settlementAgentId = params.value
        JobUtils.handleChargeCreditRemind(this._view.creditConfig, job, charge, 'settlementAgentId')
        break
      }
      case 'whtTaxRate': {
        charge.whtTaxRate = Number(params.value)
        break
      }
      case 'relatedMbl': {
        await ChargeColumnUtil.changeChargeRelatedMblCombo(charge, params, job)
        break
      }
      default: {
        break
      }
    }
    // 加载开票抬头
    await this.getTitlesByCompanyId(charge)
    // 修改accountId之后需要修改联系人数据
    await ChargeColumnUtil.getContactsByCompanyId(charge.accountId, currentViewCacheData)
    // debugger
    // alert(charge.measure + charge.currency)
    if (charge.invoiceTitle) {
      if (params.field === 'invoiceTitle' || charge.invoiceTitle !== oldInvoceTitle) {
        const flag = ChargeUtils.updateOverseaByInvoiceTitle(charge, this._view.getInvoiceTitleList(charge.accountId))
        if (!flag && charge.invoiceTitle !== oldInvoceTitle && charge.accountId > 0 && params.field === 'accountId') {
          await ChargeUtils.updateOverseaByAccountId(charge)
        }
      }
    } else if (charge.accountId > 0) {
      if (params.field === 'accountId') {
        await ChargeUtils.updateOverseaByAccountId(charge)
      }
    }

    // 刷新
    if (charge.receivable && this._view.tabCost.grid.gridApi) {
      this._view.tabCost.grid.gridApi.refreshCells({ force: true })
      this.redrawRows(this._view.tabCost.grid.gridApi, this._view.$refs.tabCostGrid, params.rowIndex, params.colId)
    }
    if (!charge.receivable && this._view.tabSelling.grid.gridApi) {
      this._view.tabSelling.grid.gridApi.refreshCells({ force: true })
      this.redrawRows(this._view.tabSelling.grid.gridApi, this._view.$refs.tabSellingGrid, params.rowIndex, params.colId)
    }
  }

  // 重新渲染行数据
  redrawRows(gridApi, gridRef, excludingRowIndex, excludingColId) {
    const editingRow = gridRef.$el.querySelector('.ag-row-inline-editing')
    if (editingRow) {
      const editingCell = editingRow.querySelector('.ag-cell-inline-editing')
      if (editingCell) {
        const rowIndex = Number(editingRow.getAttribute('row-index'))
        const colId = editingCell.getAttribute('col-id')
        if (rowIndex !== excludingRowIndex || colId !== excludingColId) {
          gridApi.redrawRows()
          gridApi.startEditingCell({ rowIndex, colKey: colId })
          return
        }
      }
    }
    gridApi.redrawRows()
  }

  /**
   * @private
   */
  async loadCustomerResultHandler(customerId) {
    if (!this._view.currentViewCacheData.customerDefaultTitleMap.has(customerId)) {
      const titles = await getTitleByCmpIdxList([customerId]).then(res => res.data)
      if (titles && titles.length > 0) {
        this._view.currentViewCacheData.customerDefaultTitleMap.set(customerId, titles[0])
        this._view.costCharge.invoiceTitle = titles[0].title
      }
    } else {
      this._view.costCharge.invoiceTitle = this._view.currentViewCacheData.customerDefaultTitleMap.get(customerId)
    }
  }
  /**
   * 新增应收
   */
  async addCost() {
    if (!this.checkProvisionFeeLocked()) {
      return
    }
    if (this._view.tabCost.grid.overseaCostDetails.length <= 0) {
      this._view.tabCost.grid.overseaCostDetails = []
    }
    const overseaCostDetails = this._view.tabCost.grid.overseaCostDetails
    const obj = new Charge().fillDefaultValue().getData() // new Charge();

    /* 先将费用加入到列表，在列表中显示出来 */
    this.addChargeForJob(obj)
    this._view.jobControlledCharges.push(obj)
    obj.receivable = true
    const office = this.$store.getters.currentOffice
    obj.branchId = this._view.privilege.showOtherBranchCharge ? this._view.currentSettleBranchId : office.officeId
    if (this._view.config.currentOfficeCharge && this._view.job.salesOffice) {
      obj.branchId = this._view.job.salesOffice
    }
    obj.serialNumber = this.getMaxSerialNumber(obj.receivable) + 1 // 序号，CARGO-5881，按照录入顺序排序
    // this.$nextTick(() => {
    //   if (this._view.tabCost.grid.gridApi) {
    //     const len = this._view.tabCost.grid.overseaCostDetails.length
    //     this._view.tabCost.grid.gridApi.forEachNode((node, index) => {
    //       // console.log('index index', index)
    //
    //       const groupColumns = this._view.tabCost.grid.groupColumns
    //       // 无字段分组
    //       if (!groupColumns || !groupColumns.columns || !groupColumns.columns.length) {
    //         if (len - 1 === index) {
    //           this._view.tabCost.grid.selectedRow = node.data
    //           this._view.tabCost.grid.gridApi.setFocusedCell(node.rowIndex, 'serialNumber')
    //           // CARGO-8041 【海运出口-海运订舱极速版】费用页签，新增费用不要默认勾选
    //           // node.selectThisNode(true)
    //           // this._view.tabCost.grid.chooseUuidSet.add(node.data.uuid)
    //           // this._view.toResetTabCostSelected()
    //         }
    //       }
    //     })
    //   }
    // })

    const job = this._view.job
    obj.uuid = this._view.tabCost.grid.uuidPrefixRule + getUuid()
    obj.jobUuid = job.uuid
    if (!this._view.config.isInputChargeBaseOnService) {
      obj.accountId = job.customerId
      this.updateGroupFields(this._view.tabCost.grid, obj)
      // 设置开票抬头
      await ChargeUtils.updateDefaultInvoiceTitle([obj])
      await ChargeUtils.getChargeisOverseaNotControlledByConfig(obj)
    }
    obj.inputBy = this.$store.getters.userId
    //				obj.isNeedInvoice = true;
    obj.inputDate = DateUtils.formatStandardDateTime(new Date())
    // New charge: use currently selected department (editing should keep original value).
    obj.inputByDep = Number(this.$store.getters.currentDeptId) || Number(job.opDepartment) || 0
    const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(this._view.privilege.showOtherBranchCharge ? this._view.currentSettleBranchId : this.getBranchIdForCharge())
    obj.localCurrency = localCurrency
    if (this._view.config.currencyChangeBySettlementAccount === 2 || this._view.config.currencyChangeBySettlementAccount === 1) {
      obj.currency = obj.oversea ? 'USD' : localCurrency
    }
    obj.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, obj.currency, job, obj.branchId, function(rate) {
      obj.exchangeRate = rate
    })
    obj.unitRate = 0
    obj.amount = 0
    obj.measure = this.getMeasureData()
    // HQ币种/汇率
    obj.hqCurrency = RateUtil.getHqCurrency(obj.branchId)
    obj.hqRate = await RateUtil.getForeignExchangeRateByJob(obj.hqCurrency, localCurrency, job, obj.branchId)
    obj.taxAmount = 0
    obj.excludingTaxAmount = 0
    obj.verifiedAmount = 0
    obj.taxRate = ChargeUtils.getTaxRateAtCreateCharge(obj)
    obj.accountingDate = null
    obj.counterPartyBillingNo = null
    obj.chargeSource = this._view.chargeSource
    obj.chargeState = 0
    obj.unitPriceIncludeTax = this._view.config.inputIncludingTaxUnitPrice === 2
    if (this._view.config.openHecConfig) {
      obj.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
    }
    obj.accountId = Number(obj.accountId) > 0 ? Number(obj.accountId) : 0
    if (obj.accountId && obj.accountId > 0) {
      // 默认的结算代理
      await this.getSettlementByCompanyId(obj)
    }

    if (obj.accountId && obj.accountId > 0) {
      // 加载联系人
      await ChargeColumnUtil.getContactsByCompanyId(obj.accountId, this._view.currentViewCacheData)
      // 加载开票抬头
      await this.getTitlesByCompanyId(obj)
    }
    const canChangeOverseaOfCharge = parseInt(this.cacheConfig.get('canChangeOverseaOfCharge'))

    if (canChangeOverseaOfCharge !== 2 && canChangeOverseaOfCharge !== 3) {
      if (obj.invoiceTitle) {
        const flag = ChargeUtils.updateOverseaByInvoiceTitle(obj, this._view.getInvoiceTitleList(obj.accountId))
        if (!flag && obj.accountId > 0) {
          await ChargeUtils.updateOverseaByAccountId(obj)
        }
      } else if (obj.accountId > 0) {
        await ChargeUtils.updateOverseaByAccountId(obj)
      }
    }
    this.updateGridDataAndRestoreState(this._view.tabCost.grid, obj, 'overseaCostDetails')
  }
  getMeasureData() {
    const l = getCacheListByKey(basicCacheKeys.basic_data_ChargeUnit)
    let measure = ''
    for (const item of l) {
      if (item && item.ifDefault && item.unit) {
        measure = item.code
      }
    }
    return measure
  }
  /**
   * 序号,递减
   */
  refreshSerialNumber(receivable, serialNumber) {
    const overseaCostDetails = this._view.tabCost.grid.overseaCostDetails || []
    const overseaSellingDetails = this._view.tabSelling.grid.overseaSellingDetails || []
    if (receivable) {
      if (overseaCostDetails.length === 1) { // 只有一条数据的时候，序号就是1
        for (const charge of overseaCostDetails) {
          charge.serialNumber = 1
        }
      } else {
        for (const charge of overseaCostDetails) {
          if (charge.serialNumber > serialNumber) {
            charge.serialNumber = charge.serialNumber - 1
          }
        }
      }
    } else {
      if (overseaSellingDetails.length === 1) {
        for (const charge of overseaSellingDetails) {
          charge.serialNumber = 1
        }
      } else {
        for (const charge of overseaSellingDetails) {
          if (charge.serialNumber > serialNumber) {
            charge.serialNumber = charge.serialNumber - 1
          }
        }
      }
    }
  }

  /**
   * 删除费用时，校验费用UUID是否为其他费用的DIFF_CHAREG_UUID
   * @param chooseRows
   * @param allRows
   * @returns {boolean}
   */
  checkDeleteCharges(chooseRows, allRows) {
    const diffChargeUuidMap = new Map()
    if (allRows && allRows.length > 0) {
      for (const curRow of allRows) {
        if (!curRow.diffChargeUuid) continue
        diffChargeUuidMap.set(curRow.diffChargeUuid, curRow.diffChargeUuid)
      }
    }
    if (chooseRows && chooseRows.length > 0) {
      for (const curRow of chooseRows) {
        const chargeUuid = diffChargeUuidMap.has(curRow.uuid) ? diffChargeUuidMap.get(curRow.uuid) : null
        if (chargeUuid && chargeUuid === curRow.uuid) {
          this.$message.warning(this._view.$t('Message.CheckSplitCharges'))
          return false
        }
      }
    }
    return true
  }

  /**
   * 删除费用
   */
  deleteCost() {
    const overseaCostDetails = this._view.tabCost.grid.overseaCostDetails
    const chooseRows = this._view.tabCost.grid.gridApi.getSelectedRows()
    // CARGO-14167 业务在正操作的情况下，无法删除可操作费用
    if (!this.checkDeleteCharges(chooseRows, overseaCostDetails)) return
    for (const charge of chooseRows) {
      if (!this.isRowEdit(charge) || !this.checkDeletePersonalArCharge(charge) || !this.checkRoleDelete(charge)) {
        // dgOverseaCost.selectedIndex = i;
        this.$message.warning(this._view.$t('Message.ThereAreFeesCantBeDeletedPleaseRecheck'))
        return
      }
      // 同步的费用不可删除
      if (charge.syncStatus === 1) {
        this.$message.warning(this._view.$t('Message.TheSynchronizedExpensesCannotBeDeleted'))
        return
      }
    }
    for (const charge of chooseRows) {
      charge.deleted = true
      charge.jobUuid = null
      // overseaCostDetails.removeItemAt(i);
      const index = overseaCostDetails.indexOf(charge)
      overseaCostDetails.splice(index, 1)
      const index2 = this._view.jobControlledCharges.indexOf(charge)
      this._view.jobControlledCharges.splice(index2, 1)
      if (charge.uuid && !charge.uuid.startsWith('addTabSelling__') && !charge.uuid.startsWith('addTabCost__')) {
        this._view.tabCost.grid.deleteUuids.push(charge.uuid)
      }
      this.removeChargeForJob(charge)
      this.refreshSerialNumber(charge.receivable, charge.serialNumber) // 序号,递减
      this.removeChargeForModifiedData(charge)
    }

    this.refDgChargeInfo()
  }

  // 保存校验单价
  // CARGO-25284 单价为0的费用 增加提示允许客户直接保存业务
  async validateUnitRate(delChargeUuids) {
    if (!delChargeUuids) delChargeUuids = []
    if (this._view.config.isInputZeroFee) {
      let checkValue = SystemConstants.CHARGE_UNIT_RATE_CHECK_NO.code // 0-未选择 1-继续保存 2-清除为0费用
      // 应收
      const overseaCostDetails = this._view.tabCost.grid.overseaCostDetails
      checkValue = await this.handleUnitRateSupportZero(overseaCostDetails, delChargeUuids, checkValue)
      // 应付
      const overseaSellingDetails = this._view.tabSelling.grid.overseaSellingDetails
      await this.handleUnitRateSupportZero(overseaSellingDetails, delChargeUuids, checkValue)
    } else {
      // 应收
      const overseaCostDetails = this._view.tabCost.grid.overseaCostDetails
      const isKeep = await this.handleUnitRate(overseaCostDetails, delChargeUuids, false)
      // 应付
      const overseaSellingDetails = this._view.tabSelling.grid.overseaSellingDetails
      await this.handleUnitRate(overseaSellingDetails, delChargeUuids, isKeep)
    }
  }

  // 保存校验单价
  // CARGO-25284 单价为0的费用 增加提示允许客户直接保存业务
  async handleUnitRate(charges, delChargeUuids, isCheck) {
    let isKeep = isCheck
    if (!isKeep) { // 应收应付只弹框一次
      for (const charge of charges) {
        if (!charge.unitRate || Number(charge.unitRate) === 0) {
          await this.$confirm(this._view.$t('CargoMsg.Cargo_CheckUnitRate'), this._view.$t('common.tips.prompt'), {
            confirmButtonText: this._view.$t('common.btn.yes'),
            cancelButtonText: this._view.$t('common.btn.no'),
            type: 'info'
          }).then(() => {
            // 清除单价为0的费用（flash系统的做法），保存成功
            isKeep = true
          }).catch(() => {
            throw new TabError('', this._view.tabName)
          })
        }
        // 只要有一笔弹过就不再弹
        if (isKeep) break
      }
    }
    if (isKeep) {
      this.doHandleUnitRate(charges, delChargeUuids)
    }
    return isKeep
  }

  // 保存校验单价
  // CARGO-25284 单价为0的费用 增加提示允许客户直接保存业务
  async handleUnitRateSupportZero(charges, delChargeUuids, checkValue) {
    if (checkValue === SystemConstants.CHARGE_UNIT_RATE_CHECK_NO.code) { // 应收应付只弹框一次
      for (const charge of charges) {
        if (!charge.unitRate || Number(charge.unitRate) === 0) {
          await this.$confirm(this._view.$t('CargoMsg.Cargo_ZeroUnitPrice'), this._view.$t('common.tips.prompt'), {
            confirmButtonText: this._view.$t('CargoMsg.Cargo_ContinueToSave'),
            cancelButtonText: this._view.$t('CargoMsg.Cargo_ClearZeroFee'),
            distinguishCancelAndClose: true,
            type: 'info'
          }).then(() => {
            // 继续保存
            checkValue = SystemConstants.CHARGE_UNIT_RATE_CHECK_SAVE.code
          }).catch(action => {
            if (action === 'cancel') {
              // 清除单价为0的费用（flash系统的做法），保存成功
              checkValue = SystemConstants.CHARGE_UNIT_RATE_CHECK_CLEAR.code
            } else if (action === 'close') {
              throw new TabError('', this._view.tabName)
            }
          })
        }
        // 只要有一笔弹过就不再弹
        if (checkValue !== SystemConstants.CHARGE_UNIT_RATE_CHECK_NO.code) {
          break
        }
      }
    }
    if (checkValue === SystemConstants.CHARGE_UNIT_RATE_CHECK_CLEAR.code) {
      this.doHandleUnitRate(charges, delChargeUuids)
    }
    return checkValue
  }

  doHandleUnitRate(charges, delChargeUuids) {
    let isCostRefresh = false
    let isSaleRefresh = false
    const jobCharges = this._view.job.charges
    const modifiedDataCharges = this._view.context && this._view.context.modifiedData ? this._view.context.modifiedData.charges : []
    for (let i = charges.length - 1; i >= 0; --i) {
      const charge = charges[i]
      if (!charge.unitRate || Number(charge.unitRate) === 0) {
        if (charge.uuid) { // 如果数据存库，且单价为0，则将此费用删除
          if (!delChargeUuids.includes(charge.uuid)) {
            delChargeUuids.push(charge.uuid)
          }
          if (jobCharges && jobCharges.length > 0) {
            const chargeIndex = jobCharges.findIndex(p => p.uuid === charge.uuid)
            // 针对于数据库真实存在的费用，需要记录一下删除的UUID
            if (!charge.uuid.startsWith('addTabSelling__') && !charge.uuid.startsWith('addTabCost__')) {
              if (charge.receivable) {
                this._view.tabSelling.grid.deleteUuids.push(charge.uuid)
              } else {
                this._view.tabCost.grid.deleteUuids.push(charge.uuid)
              }
            }
            if (chargeIndex > -1) {
              jobCharges.splice(chargeIndex, 1)
            }
          }
          if (modifiedDataCharges && modifiedDataCharges.length > 0) {
            const modifiedDataChargeIndex = modifiedDataCharges.findIndex(p => p.uuid === charge.uuid)
            if (modifiedDataChargeIndex > -1) {
              modifiedDataCharges.splice(modifiedDataChargeIndex, 1)
            }
          }
        } else {
          if (jobCharges && jobCharges.length > 0) {
            const chargeIndex = jobCharges.indexOf(charge)
            if (chargeIndex > -1) {
              jobCharges.splice(chargeIndex, 1)
            }
          }
          if (modifiedDataCharges && modifiedDataCharges.length > 0) {
            const modifiedDataChargeIndex = modifiedDataCharges.indexOf(charge)
            if (modifiedDataChargeIndex > -1) {
              modifiedDataCharges.splice(modifiedDataChargeIndex, 1)
            }
          }
        }
        const index = charges.indexOf(charge)
        if (index > -1) {
          charges.splice(index, 1)
          if (charge.receivable) {
            isCostRefresh = true
          } else {
            isSaleRefresh = true
          }
        }
      }
    }
    if (isCostRefresh) {
      this._view.isCostRowDragEnd = true
    }
    if (isSaleRefresh) {
      this._view.isSellingRowDragEnd = true
    }
  }

  /**
   * 验证费 输入
   * 保存校验
   */
  checkModels(charges) {
    const job = this._view.job
    if (!job) return

    if (!charges || charges.length <= 0) return
    const tabName = this._view.tabName

    this.refreshChargeJob(charges)
    this.checkInputCharges(charges, tabName)
    // CARGO-6128 CW委托单保存时，结算公司要设置必填，没填要弹出提醒
    if (parseInt(this.cacheConfig.get('openSapConfig')) === 1) {
      if (!this.checkChargeSettleDepartment(charges)) {
        throw new TabError(this._view.$t('SeaExport.SettlementCompanyNotEmpty'), tabName)
      }
    }
    this.removeEmptyUnitRate(charges)

    for (const charge of charges) {
      if (charge.accountId > 0 && this.checkAccountId) {
        if (!SecurityUtil.companyisActive(this._view.$t('CargoMsg.Cargo_ExpenseSettlingParty'), charge.accountId, tabName)) {
          return
        }
      }
      // cargo-426 费用币种汇率为0 的时候，不允许保存
      if (charge.exchangeRate === 0 || isNaN(charge.exchangeRate)) {
        throw new TabError(lang.t('Message.NotFindCurrencyRatePleaseMaintain', [charge.currency]), tabName)
      }
    }
    return true
  }

  /**
   * 防止job被清空
   */
  refreshChargeJob(charges) {
    for (const charge of charges) {
      if (!charge.jobUuid) {
        charge.jobUuid = this._view.job.uuid
      }
      // CARGO-39571 根据页面调整取值，不在此处进行强转
      // this.refreshOversea(charge)
    }
  }

  /**
   * 国内国外不能错
   */
  refreshOversea(charge) {
    const company = this._view.currentViewCacheData.companyCmpIdxForCustomerMap.get(charge.accountId)
    if (company != null && !ChargeUtils.isSettled(charge) && parseInt(this.cacheConfig.get('canChangeOverseaOfCharge')) === 0) {
      charge.oversea = (company.designationAgent || company.overseaAgent)
    }
  }

  /**
   * 输入验证
   */
  checkInputCharges(charges, tabName) {
    // const overseaCostDetails = this._view.tabCost.grid.overseaCostDetails
    // for (const charge of overseaCostDetails) {
    //   this.checkChargeModel(charge, tabName, overseaCostDetails)
    // }
    // const overseaSellingDetails = this._view.tabSelling.grid.overseaSellingDetails
    // for (const charge of overseaSellingDetails) {
    //   this.checkChargeModel(charge, tabName, overseaSellingDetails)
    // }
    for (const charge of charges) {
      this.checkChargeModel(charge, tabName, charges)
    }
    this.checkChargeServiceType(charges, tabName)
  }

  /**
   * 验证费用结算公司不为空
   */
  checkChargeSettleDepartment(charges) {
    if (charges && charges.length > 0) {
      for (const charge of charges) {
        if (!charge.settleDepartmentPrefix) {
          return false
        }
      }
    }
    return true
  }

  /**
   * 输入验证
   */
  checkChargeModel(charge, tabName, overseaDetails) {
    if (!charge.chargeItemId || charge.chargeItemId <= 0) {
      throw new TabError(lang.t('Message.ChargeItemCannotBeNull'), tabName)
      // MessageDialog.warning(resourceManager.getString('Message', 'ChargeItemCannotBeNull'), null, null, function (e) {
      //   dataGrid.selectedIndex = overseaDetails.getItemIndex(charge);
      // });
      // return false;
    }
    if (!charge.measure) {
      throw new TabError(lang.t('Message.MeasureCannotBeNull'), tabName)
    }
    if (!charge.accountId || charge.accountId <= 0) {
      throw new TabError(lang.t('Message.SettlementPartyCannotBeNull'), tabName)
      // MessageDialog.warning(resourceManager.getString('Message', 'SettlementPartyCannotBeNull'), null, null, function (e) {
      //   dataGrid.selectedIndex = overseaDetails.getItemIndex(charge);
      //   dataGrid.editedItemPosition = {rowIndex: dataGrid.selectedIndex, columnIndex: 3};
      // });
      // return false;
    }
    // if (charge.unitRate === 0) {
    //   throw new TabError(lang.t('Message.UnitRateCannotBeNull'), tabName)
    // }
    if (!charge.currency) {
      throw new TabError(lang.t('Message.CurrencyCannotBeNull'), tabName)
      // MessageDialog.warning(resourceManager.getString('Message', 'CurrencyCannotBeNull'), null, null, function (e) {
      //   dataGrid.selectedIndex = overseaDetails.getItemIndex(charge);
      //   dataGrid.editedItemPosition = {rowIndex: dataGrid.selectedIndex, columnIndex: 5};
      // });
      // return false;
    }
    if (!charge.quantity || isNaN(charge.quantity) || charge.quantity === 0 || Number(charge.quantity) === 0) {
      throw new TabError(lang.t('Message.AmountCannotBeNull'), tabName)
      // MessageDialog.warning(resourceManager.getString('Message', 'AmountCannotBeNull'), null, null, function (e) {
      //   dataGrid.selectedIndex = overseaDetails.getItemIndex(charge);
      //   dataGrid.editedItemPosition = {rowIndex: dataGrid.selectedIndex, columnIndex: 7};
      // });
      // return false;
    }
    if (charge.chargeItemId) {
      const message = ChargeUtils.checkChargeRateRange(charge)
      if (message) {
        throw new TabError(lang.t('CargoMsg.Cargo_TaxRateRangeLimit', [message]), tabName)
      }
    }
    // return true;
  }

  /**
   * 验证服务项
   */
  checkChargeServiceType(charges, tabName) {
    if (!this._view.job || !(this._view.job.lob === 'SE')) return
    if (!this._view.config.isVerifyChargeServiceType) return
    const customsCharge = []
    const warehousingCharge = []
    const truckingCharge = []
    let c = null
    let msg = ''
    for (const charge of charges) {
      if (charge.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_CUSTOMS.code && !new SeaExportJob(this._view.job).customs) {
        customsCharge.push(charge)
      } else if (charge.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_WAREHOUSING.code && !this._view.job.warehousing) {
        warehousingCharge.push(charge)
      } else if (charge.serviceType === ChargeServiceTypeItem.CHARGE_SERVICE_CARRYING.code && !this._view.job.landTransportation) {
        truckingCharge.push(charge)
      }
    }
    if (customsCharge.length > 0) {
      msg = lang.t('Message.CustomsSeclarationServiceIsNotSelectedInBookingCannotAdd')
      for (const charge of customsCharge) {
        c = ChargeItem.getChargeItemById(charge.chargeItemId)
        if (c != null && msg.indexOf(c.zhName) === -1) {
          msg += (',' + c.zhName)
        }
      }
    }
    if (warehousingCharge.length > 0) {
      msg += '\n' + lang.t('Message.WaerhouseServiceIsNotSelectedInBookingCannotAdd')
      for (const charge in warehousingCharge) {
        c = ChargeItem.getChargeItemById(charge.chargeItemId)
        if (c != null && msg.indexOf(c.zhName) === -1) {
          msg += (',' + c.zhName)
        }
      }
    }
    if (truckingCharge.length > 0) {
      msg += '\n' + lang.t('Message.HaulageServiceIsNotSelectedInBookingCannotAdd')
      for (const charge of truckingCharge) {
        c = ChargeItem.getChargeItemById(charge.chargeItemId)
        if (c != null && msg.indexOf(c.zhName) === -1) {
          msg += (',' + c.zhName)
        }
      }
    }
    if (!StrUtils.isEmpty(msg)) {
      throw new TabError(msg, tabName)
      // MessageDialog.warning(msg);
      // return false;
    }
    // return true;
  }

  /**
   * 新增时删除单价为零的费用
   */
  removeEmptyUnitRate(charges) {
    if (this._view.config.isInputZeroFee) {
      return
    }
    // console.log('===========charges1', charges)
    if (charges && charges.length > 0) {
      let charge = null
      const indexArr = []
      let isCostRefresh = false
      let isSaleRefresh = false
      for (let i = charges.length - 1; i >= 0; i--) {
        charge = charges[i]
        if (charge && (!charge.uuid || (charge.uuid.startsWith(this._view.tabCost.grid.uuidPrefixRule) || charge.uuid.startsWith(this._view.tabSelling.grid.uuidPrefixRule))) && !charge.advance && ((isNaN(charge.unitRate) || charge.unitRate === 0) || (isNaN(charge.amount) || charge.amount === 0))) {
          const index = charges.indexOf(charge)
          if (index > -1) {
            indexArr.push(index)
            if (charge.receivable) {
              isCostRefresh = true
            } else {
              isSaleRefresh = true
            }
          }
        }
      }
      // console.log('===========indexArr', indexArr)
      if (indexArr && indexArr.length > 0) {
        for (const key in indexArr) {
          if (indexArr[key] > -1) {
            charges.splice(indexArr[key], 1)
          }
        }
      }
      if (isCostRefresh) {
        this._view.isCostRowDragEnd = true
      }
      if (isSaleRefresh) {
        this._view.isSellingRowDragEnd = true
      }
      // console.log('===========charges2', charges)
    }
    // CARGO-7916 删除费用后对费用序号重新排序
    // let j = 0; let k = 0
    // if (charges && charges.length > 0) {
    //   for (let i = 0; i < charges.length; i++) {
    //     const charge = charges[i]
    //     if (charge.receivable) {
    //       charge.serialNumber = ++j
    //     } else {
    //       charge.serialNumber = ++k
    //     }
    //   }
    // }
  }

  /**
   * 预估利润计算
   */
  fillModel() {
    //     refreshEstimateProfit();
  }

  //
  getJobTruckingCarring() {
    //     if (job && job.trucking && job.trucking.length > 0) {
    //       const trucking:TruckingInfo = job.trucking.getItemAt(0) as TruckingInfo;
    //       return trucking.carryingCmp;
    //     }
    //     return 0;
  }

  //
  getJobWarehouseCarring() {
    //     if (job && job.warehouseInfo && job.warehouseInfo.length > 0) {
    //       const warehouse:WarehouseInfo = job.warehouseInfo.getItemAt(0) as WarehouseInfo;
    //       return warehouse.warehouseCmp;
    //     }
    //     return 0;
  }

  //
  //   /**
  //    * 费用表格键盘事件(上下左右键)
  //    */
  keyCapture(event) {
    //     const dg = event.currentTarget as DataGrid;
    //     const item = Object(dg.editedItemPosition);
    //     const editorInstance = UIComponent(dg.itemEditorInstance);
    //     const keyCode:uint = event.keyCode;
    //     if (item === null)
    //       return;
    //     if (!item.hasOwnProperty("columnIndex"))
    //       return;
    //     const colName = dg.columns[item.columnIndex].dataField;
    //     if (isSetNextFocus(keyCode) && !isExcKeyEvent(colName, editorInstance)) {
    //       focusManager.setFocus(focusManager.getNextFocusManagerComponent());
    //     }
    //     if (keyCode === Keyboard.LEFT) {
    //       if (colName === "remarks") {
    //         item.columnIndex = 12;
    //       } else if (colName === "measure") {
    //         item.columnIndex = 5;
    //       } else if (colName === "currency") {
    //         item.columnIndex = 3;
    //       } else {
    //         if (item.columnIndex > 2) {
    //           item.columnIndex--;
    //         }
    //       }
    //       if (dg.columns[item.columnIndex] && dg.columns[item.columnIndex].editable)
    //         dg.editedItemPosition = item;
    //     } else if (keyCode === Keyboard.RIGHT) {
    //       if (colName === "accountId") {
    //         item.columnIndex = 5;
    //       } else if (colName === "currency") {
    //         item.columnIndex = 7;
    //       } else if (colName === "taxRate") {
    //         item.columnIndex = 14;
    //       } else {
    //         if (item.columnIndex < 14) {
    //           item.columnIndex++;
    //         }
    //       }
    //       if (dg.columns[item.columnIndex] && dg.columns[item.columnIndex].editable)
    //         dg.editedItemPosition = item;
    //     } else if (keyCode === Keyboard.DOWN) {
    //       if (isExcKeyEvent(colName, editorInstance))
    //         return;
    //       if (item.rowIndex < dg.dataProvider.length - 1) {
    //         item.rowIndex++;
    //         if (dg.columns[item.columnIndex] && dg.columns[item.columnIndex].editable)
    //           dg.editedItemPosition = item;
    //       }
    //     } else if (keyCode === Keyboard.UP) {
    //       if (isExcKeyEvent(colName, editorInstance))
    //         return;
    //       if (item.rowIndex > 0) {
    //         item.rowIndex--;
    //         if (dg.columns[item.columnIndex] && dg.columns[item.columnIndex].editable)
    //           dg.editedItemPosition = item;
    //       }
    //     } else if (keyCode === Keyboard.ENTER) {
    //       if (item.rowIndex === dg.dataProvider.length - 1 && colName === "remarks") {
    //         event.target.text = "";
    //         //						event.preventDefault();
    //         //						dg.destroyItemEditor();
    //         //						dg.dataProvider.notifyItemUpdate(dg.editedItemRenderer);
    //         if (dg.id === "dgOverseaCost") {
    //           addCost();
    //         } else {
    //           addSelling();
    //         }
    //         dg.dispatchEvent(new FocusEvent("keyFocusChange", true, true, null, false, 11));
    //       } else {
    //         if (dg.columns[item.columnIndex] && dg.columns[item.columnIndex].editable)
    //           dg.editedItemPosition = item;
    //       }
    //     }
  }

  //
  //   /**
  //    * 是否执行光标定位
  //    */
  isSetNextFocus(keyCode) {
    //     if (keyCode === Keyboard.LEFT || keyCode === Keyboard.RIGHT ||
    //       keyCode === Keyboard.DOWN || keyCode === Keyboard.UP) {
    //       return true;
    //     }
    //     return false;
  }

  //
  //   /**
  //    * 是否执行上下键移动
  //    */
  isExcKeyEvent(colName, editorInstance) {
    //     if (colName === "chargeItemId") {
    //       if (ChargeItemAutoComplete(editorInstance) != null && ChargeItemAutoComplete(editorInstance).isDropDownVisible()) {
    //         return true;
    //       }
    //     } else if (colName === "accountId") {
    //       if (CompanyAutoComplete(editorInstance) != null && CompanyAutoComplete(editorInstance).isDropDownVisible()) {
    //         return true;
    //       }
    //     } else if (colName === "currency") {
    //       return true;
    //     } else if (colName === "measure") {
    //       return true;
    //     } else if (colName === "contactPerson") {
    //       if (ContactPersonAutoComplete(editorInstance) != null && ContactPersonAutoComplete(editorInstance).isDropDownVisible()) {
    //         return true;
    //       }
    //     }
    //     return false;
  }

  dgOverseaCostChangeHandler() {
    // setDataGridSelectAll(dgOverseaCost.dataProvider as ArrayCollection, e.isSelected, "1");
    this.changeControllButton(true)
  }

  dgOverseaSellingChangeHandler() {
    // setDataGridSelectAll(dgOverseaSelling.dataProvider as ArrayCollection, e.isSelected, "0");
    this.changeControllButton(false)
  }

  //
  //   /**
  //    * @private
  //    */
  setDataGridSelectAll(datas, isSelect, type) {
    //     for each(const charge in datas) {
    //       charge.isSelect = isSelect;
    //     }
    //     if (type === "1") {
    //       refreshCostSelected();
    //     } else {
    //       refreshSellingSelected();
    //     }
  }

  // 获取选中的所有费用，财务审核使用
  getAllSelectedRows(tips = false) {
    return [...this.readSelectedRows(true, tips), ...this.readSelectedRows(false, tips)]
  }

  // 获取选中费用行，receivable 【true 应收  false 应付】 tips 是否需要弹出提示
  readSelectedRows(receivable, tips = true) {
    let rows = []
    if (receivable) {
      rows = this._view.tabCost.grid.gridApi.getSelectedRows()
    } else {
      rows = this._view.tabSelling.grid.gridApi.getSelectedRows()
    }
    if (rows.length === 0 && tips) {
      this.$message.error(this._view.$t('common.tips.hasOneAtleast'))
      return rows
    }
    return rows
  }

  // isAr true → 创建应收账单 (AR), false → 创建应付账单 (AP).
  // 自包含实现：费用页签自己组装账单数据并直接调用保存接口，不依赖 internalBillInfoBase/overseaBillingBase，
  // 也不挂载 billDialog/overseaBillingDialog —— 避免常驻重组件导致内存膨胀/OOM。
  // 国内账单走 saveBilling，国外账单走 saveOverseaBilling；非关键字段用默认值。
  async createBillingFromCharges(isAr) {
    const selected = this.readSelectedRows(isAr, false)
    if (!selected || !selected.length) {
      this.$message.warning(this.$t('FinanceManage.charge_noSelection'))
      return
    }
    const { domestic, oversea, skipped } = groupChargesForBilling(selected, isAr)
    if (skipped > 0) {
      this.$message.info(`已剔除 ${skipped} 条不可开账费用（已开账/无结算对象/佣金/代垫/分摊/冲抵中）`)
    }
    if (!domestic.length && !oversea.length) {
      this.$message.warning('所选费用均不可开账')
      return
    }
    const loading = getLoading()
    try {
      if (domestic.length) {
        await this._createInternalBillingFromCharges(domestic, isAr)
      }
      if (oversea.length) {
        await this._createOverseaBillingFromCharges(oversea, isAr)
      }
      // 保存成功后刷新费用页签自身（onShow 是费用页签通用的重载入口）
      await this._view.onShow(this._view.job, true)
      this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
    } finally {
      if (loading && loading.close) loading.close()
    }
  }

  // 按结算对象(accountId)分组费用
  _groupChargesByAccount(charges) {
    const map = {}
    for (const c of charges) {
      if (!map[c.accountId]) map[c.accountId] = []
      map[c.accountId].push(c)
    }
    return map
  }

  // 合作伙伴开启“指定币种”时，调整账单默认币种
  async _applyCustomerAppointCurrency(billing, accountId) {
    const company = await Company.getCompanyById(accountId)
    if (!company) return
    const customerDetail = await new Company(company).getCustomerDetail()
    if (customerDetail && customerDetail.currencyRequirements === 2 && customerDetail.appointCurrency) {
      billing.currency = customerDetail.appointCurrency
    }
  }

  // 国内账单：按结算对象(createBillWay=0)分组开账，与国内账单 tab「新建应收」单结算对象的默认行为一致。
  // 不再用「费用自带 settlementAgentId → createBillWay=1」强行按代理开账——后端无论 createBillWay 都要求
  // billing.settlementAgentId 是 accountId 的合法代理；createBillWay=1 下费用自带代理若非法即报"结算代理错误"。
  // 这里统一 createBillWay=0，并在 _saveInternalBillingForGroup 里解析合法 settlementAgentId + 补 title。
  // 若确需让用户手选代理，应走国内账单 tab「新建应收」（accounts/settlements 不唯一时弹窗）。
  async _createInternalBillingFromCharges(charges, isAr) {
    const groups = this._groupChargesByAccount(charges)
    for (const accountId of Object.keys(groups)) {
      await this._saveInternalBillingForGroup(groups[accountId], Number(accountId), isAr)
    }
  }

  // 国内账单：按一组费用（同一结算对象）组装 billing 并 saveBilling，统一按结算对象开账(createBillWay=0)。
  async _saveInternalBillingForGroup(group, accountId, isAr) {
    const currentOfficeId = this._view.$store.getters.currentOfficeId
    const buildCharges = await loadChargeByUuids(group.map(c => c.uuid)).then(res => res.data || [])
    const checkBranch = await ReconciliationUtils.checkChargeBranch(buildCharges, false)
    if (!checkBranch) {
      this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
      return
    }
    const item = await ReconciliationUtils.createBillingByCharge(0, buildCharges, isAr, 0)
    if (!item) return
    const billing = item.billing
    billing.billingType = BillingConstants.BILLING_TYPE_INTERNAL.code
    billing.ar = isAr
    billing.createBillWay = 0 // 按结算对象开账
    // 开票抬头：取首条费用的开票抬头（与 billDialog checkChargesIsSameInvoiceTitleAndSettlementAgent 一致）
    if (!billing.title && buildCharges[0] && buildCharges[0].chargeInvoiceTitle) {
      billing.title = buildCharges[0].chargeInvoiceTitle
    }
    // 结算代理：createBillWay=0 也必须 >0 且为 accountId 的合法代理，否则后端报"结算代理错误"
    const acctId = Number(billing.accountId) || accountId
    const settlementAgents = await getSettlementAgentsByCmpIdx(acctId).then(res => res.data || [])
    const legalIds = settlementAgents.map(a => Number(a.cmpIdx))
    const chargeAgent = buildCharges.find(c => Number(c.chargeSettlementAgentId) > 0)
    const chargeAgentId = Number(chargeAgent && chargeAgent.chargeSettlementAgentId)
    billing.settlementAgentId = (chargeAgentId && legalIds.includes(chargeAgentId))
      ? chargeAgentId
      : (legalIds.length > 0 ? legalIds[0] : acctId)
    await this._applyCustomerAppointCurrency(billing, acctId)
    // 补全账单显示字段（结算对象名称/购方税号/邮箱/联系人/默认银行/币种汇总），对齐 billDialog 默认带出
    await this._fillBillingDisplayFields(billing, buildCharges)
    const payload = buildDirectInternalBillingPayload(billing, item.charges, {
      currentOfficeId,
      location: this._view.location,
      affirm: false
    })
    if (!payload.bankAccountId) payload.bankAccountId = 0
    if (payload.revoked && ((payload.createCharges && payload.createCharges.length) || (payload.updateCharges && payload.updateCharges.length))) {
      payload.revoked = false
    }
    await saveBilling(payload)
  }

  // 补全账单显示字段（对齐 billDialog/billForm 打开时自动带出的默认值）：结算对象名称、开票抬头关联的
  // 购方税号/地址/电话/邮箱/发票类型、结算对象默认联系人、当前分公司默认我司银行、币种金额汇总。
  // 快速创建不走弹窗，createBilling 不填这些；不补则账单信息不全（且 currencyAmount 会被 createBilling 覆盖成空）。
  async _fillBillingDisplayFields(billing, buildCharges) {
    const accountId = Number(billing.accountId)
    if (!accountId) return
    const isZh = this._view.$store.getters.language === 'zh'
    // 1. 结算对象名称（billForm.querySettlement / billDetailHp.querySettlement）
    const company = await Company.getCompanyById(accountId)
    if (company) {
      billing.settlement = isZh ? company.chineseName : company.englishName
    }
    // 2. 开票抬头 → 购方税号/地址/电话/邮箱/发票类型（billForm.queryTitleList + getTitleBankByTitle）
    if (billing.title) {
      const titles = await queryTitleByCpmIdx(accountId).then(res => res.data || [])
      const matched = titles.find(t => t.title === billing.title) || titles.find(t => t.defaultTitle) || titles[0]
      if (matched) {
        billing.buyerTaxAccount = matched.taxAccount || ''
        billing.buyerAddress = matched.address || ''
        billing.buyerTelephone = matched.telephone || ''
        if (matched.email) billing.customerEmail = matched.email
        billing.invoiceMakeType = matched.invoiceMakeType
        billing.invoiceType = matched.invoiceType
        if (matched.invoiceDemand) billing.invoiceDemand = matched.invoiceDemand
      }
    }
    // 3. 结算对象默认联系人（billForm.queryAccountContact）
    const contacts = await getContactList({ cmpIdx: accountId }).then(res => (res.data && res.data.list) || [])
    const contact = contacts.find(c => c.defaultContact) || contacts[0]
    if (contact) {
      billing.accountContacts = contact.contactPerson || ''
      billing.accountContactsTel = contact.telephone || ''
    }
    // 4. 当前分公司默认我司银行（billForm.queryOurBankAccountList：币种匹配 + defaultPayment，否则取首条币种匹配）
    const bankList = await getBankAccountList(this._view.$store.getters.currentOfficeUuid).then(res => res.data || [])
    let bank = null
    for (const b of bankList) {
      if (b.currency === billing.currency) {
        bank = b
        if (b.defaultPayment) break
      }
    }
    if (bank) {
      billing.bankAccountId = bank.accountId
      billing.bankAccount = bank.accountNo
    }
    // 5. 币种金额汇总（createBilling 用 groupCurrencyAmount 的 undefined 返回值覆盖了 billing.currencyAmount，重算）
    ReconciliationUtils.groupCurrencyAmount(billing, buildCharges)
  }

  // 国外账单：自己用默认值组装 billing 并 saveOverseaBilling
  async _createOverseaBillingFromCharges(charges, isAr) {
    const currentOfficeId = this._view.$store.getters.currentOfficeId
    const job = this._view.job
    const groups = this._groupChargesByAccount(charges)
    for (const accountId of Object.keys(groups)) {
      const group = groups[accountId]
      const billing = new Billing().fillDefaultValue().getData()
      billing.accountId = Number(accountId)
      billing.billingType = BillingConstants.BILLING_TYPE_OVERSEA.code
      billing.ar = isAr
      billing.inputBy = cache.user.userId
      billing.state = -1
      billing.inputDate = moment(new Date()).format('yyyy-MM-DD')
      billing.currency = group[0].currency
      // 汇率：按操作公司本币取一次
      const localCurrency = RateUtil.localCurrencyByOfficeId(job.opOffice)
      billing.rate = NumberUtils.roundHalfUp(
        await RateUtil.getForeignExchangeRateSafely(localCurrency, billing.currency, billing.inputDate, job.opOffice), 8)
      // 抬头/结算代理：单条取自身；多条取与账单结算对象一致的那条
      if (group.length === 1) {
        billing.title = group[0].invoiceTitle
      } else {
        const matched = group.find(c => billing.accountId && billing.accountId === c.accountId)
        if (matched) {
          billing.title = matched.invoiceTitle
          billing.settlementAgentId = matched.settlementAgentId
        }
      }
      const payload = buildDirectOverseaBillingPayload(billing, group, {
        location: this._view.location,
        branchId: currentOfficeId,
        inputBy: billing.inputBy
      })
      const settlementAgents = await getSettlementAgentsByCmpIdx(payload.accountId).then(res => res.data || [])
      payload.settlementAgentId = resolveOverseaSettlementAgentId(payload, group, settlementAgents)
      if (payload.revoked && ((payload.createCharges && payload.createCharges.length) || (payload.updateCharges && payload.updateCharges.length))) {
        payload.revoked = false
      }
      await saveOverseaBilling(payload)
    }
  }

  // 获取所有选中的费用
  getSapChargeAll(chargeState, receivable) {
    let items = []
    if (this._view.config.chargeCommitAll) {
      // 应收
      let tabCostSelectedRows = []
      const tabCostRows = this.readSelectedRows(true, false)
      if (tabCostRows && tabCostRows.length > 0) {
        tabCostSelectedRows = this.getChargeSelectItems(chargeState, tabCostRows)
      }
      // 应付
      let tabSellingSelectedRows = []
      const tabSellingRows = this.readSelectedRows(false, false)
      if (tabSellingRows && tabSellingRows.length > 0) {
        tabSellingSelectedRows = this.getChargeSelectItems(chargeState, tabSellingRows)
      }
      items = [...tabCostSelectedRows, ...tabSellingSelectedRows]
    } else {
      //
      const selectedRows = this.readSelectedRows(receivable, false)
      if (receivable) {
        items = this.getChargeSelectItems(chargeState, selectedRows)
      } else {
        items = this.getChargeSelectItems(chargeState, selectedRows)
      }
    }
    return items
  }

  // 获取选中费用
  getChargeSelectItems(chargeState, charges) {
    const items = []
    for (const charge of charges) {
      if (chargeState === 1 ? (charge.chargeState === ChargeConstants.STATE_UNCOMMIT.code || charge.chargeState === ChargeConstants.STATE_REJECT.code) : charge.chargeState === 1) {
        items.push(charge)
      }
    }
    return items
  }

  // 提交费用(应收、应付)
  async chargeSubmitEventHandler(chargeState, receivable = false) {
    const loading = getLoading4Cxt(this._view)
    let items = []
    this.sapSelectChargeList = null
    this.submitSapStatus = null

    const job = this._view.job
    if (this._view.config.openHecConfig) { // 打开SAP配置
      if (chargeState) {
        for (const ch of job.charges) {
          if (ch.sapStatus && ch.sapStatus !== ChargeUtilsForConstant.CHARGE_US.code) {
            this.$message.info(this._view.$t('Message.SapCommitCheck'))
            loading.close()
            return
          }
        }
      }
      // sapChargeList 中的费用都是选中的费用
      const sapChargeList = this.getSapChargeAll(chargeState, receivable)
      for (const c of sapChargeList) {
        if (chargeState && c.sapStatus && c.sapStatus !== ChargeUtilsForConstant.CHARGE_US.code) {
          this.$message.info(this._view.$t('Message.SapCommitCheck'))
          loading.close()
          return
        }
        if (!chargeState && c.sapStatus !== ChargeUtilsForConstant.CHARGE_SH.code) {
          this.$message.info(this._view.$t('Message.SapCommitCheck'))
          loading.close()
          return
        }
        if (this._view.config.openSapConfig && !c.settleDepartmentPrefix) {
          const n = await Company.getCompanyName(c.accountId)
          this.$message.info(n + this._view.$t('Message.escnm'))
          loading.close()
          return
        }
      }
      for (const charge of sapChargeList) {
        if (chargeState === 1 ? (charge.chargeState === ChargeConstants.STATE_UNCOMMIT.code || charge.chargeState === ChargeConstants.STATE_REJECT.code) : charge.chargeState === 1) {
          // 提交时 修改sap状态为为SH
          charge.chargeState = chargeState
          if (chargeState) {
            this.submitSapStatus = ChargeUtilsForConstant.CHARGE_SH.code
            charge.sapStatus = ChargeUtilsForConstant.CHARGE_SH.code
          } else {
            // 取消提交时 修改sap状态为 null
            this.submitSapStatus = ChargeUtilsForConstant.CHARGE_US.code
            charge.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
          }
          items.push(charge)
        }
      }
    } else {
      // 未打开SAP配置
      items = this.getSapChargeAll(chargeState, receivable)
    }
    if (!items || items.length === 0) {
      this.$message.warning(chargeState === 1 ? this._view.$t('Message.ChargeIsNotSelectedOrAllChargesSubmit') : this._view.$t('Message.ChargeIsNotSelectedOrNotInTheSubmissionStatus'))
      loading.close()
      return
    }

    this.sapSelectChargeList = items
    // 提交或者取消提交费用
    const chargeKeys = Array.from(items, p => p.uuid)
    await chargeSubmit(chargeKeys, chargeState, this._view.location).then(res => {
      if (res.data && Number(res.data) > 0) {
        // 提交成功后刷新数据
        for (const charge of items) {
          if (chargeState === 1 ? (charge.chargeState === ChargeConstants.STATE_UNCOMMIT.code || charge.chargeState === ChargeConstants.STATE_REJECT.code) : charge.chargeState === 1) {
            charge.chargeState = chargeState
            charge.version += 1
          }
        }
        this.refreshAgGrid(receivable)
        if (this._view.config.openHecConfig) {
          this.sendSapMessage()
        } else {
          // 提交费用成功后执行，隆和金蝶EAS费用推送 chargeState=1提交，=0是取消提交
          if (this._view.config.toExoSystemLHEAS && chargeState) {
            this.sendLhJdEas(items, receivable)
            return
          }
          this.saveChargeEventHandler()
        }
      }
    }).catch((err) => {
      this.failureHandler(err)
    }).finally(() => {
      loading.close()
    })
  }

  // 提交成功
  saveChargeEventHandler(e) {
    this.$message.success(this._view.$t('Message.OperationSuccessfully'))
    this.refDgChargeInfo()
  }

  async sendSapMessage(e) {
    let oldSapStatus = ChargeUtilsForConstant.CHARGE_SH.code
    if (ChargeUtilsForConstant.CHARGE_SH.code === this.submitSapStatus) {
      oldSapStatus = ChargeUtilsForConstant.CHARGE_US.code
    }

    // 发送更新sap费用消息
    const chargeKeys = Array.from(this.sapSelectChargeList, p => p.uuid)
    if (this._view.config.openSapConfig) {
      await sendSapMessageByCharge(chargeKeys, oldSapStatus, this.submitSapStatus, true).then(res => {
        this.sendSapSuccess(res)
      }).catch((err) => {
        this.failureHandler(err)
      })
    }
    if (this._view.config.openHecConfig) {
      await sendHecMessageByCharge(chargeKeys, oldSapStatus, this.submitSapStatus, true, false).then(res => {
        this.sendSapSuccess(res)
      }).catch((err) => {
        this.failureHandler(err)
      })
    }
  }

  //
  sendSapSuccess(res) {
    let r = 'failure'
    if (res && Number(res.data) > 0) {
      r = 'success'
      this.$message.success(this._view.$t('Message.SapSynchronizationSuccess'))
    } else {
      this.$message.error(this._view.$t('Message.SapSynchronizationFault'))
    }
    this.refDgChargeInfo()
    this.$logger.log('chargeInfo sendSapSuccess key: ' + this._view.job.uuid + ' result:  ' + r)
  }

  /**
   * 分摊应收费用
   */
  shareChargeCostHandler() {
    // if (!this.shareChargeAdjust(true)) return
    if (!this.showChargeShareDialog(true)) return
    this._view.shareChargeDialog.visible = true
    this._view.shareChargeDialog.job = lodash.cloneDeep(this._view.job)
    this.showChargeShareDialog(true)
  }

  /**
   * 分摊应付费用
   */
  shareChargeSellingHandler() {
    // if (!this.shareChargeAdjust(false)) return
    if (!this.showChargeShareDialog(false)) return
    this._view.shareChargeDialog.visible = true
    this._view.shareChargeDialog.job = lodash.cloneDeep(this._view.job)
    this.showChargeShareDialog(false)
  }

  // /**
  //  * 费用分摊升级
  //  */
  // shareChargeAdjust(receivable = true) {
  //   if (this._view.config.shareCharge) {
  //     const rows = this.readSelectedRows(receivable, false)
  //     if (!rows || rows.length <= 0) {
  //       this.$message.warning(this._view.$t('common.tips.hasOneAtleast'))
  //       return false
  //     }
  //     if (rows.length > 1) {
  //       const currency = rows[0].currency
  //       const receivable = rows[0].receivable
  //       for (const row of rows) {
  //         if (!row.currency || row.currency !== currency || row.receivable !== receivable) {
  //           // 费用分摊的币种和收付方向应一致。
  //           this.$message.warning(this._view.$t('CargoMsg.Cargo_ShareChargeCheckCurrency'))
  //           return false
  //         }
  //       }
  //     }
  //     this._view.shareChargeDialog.charges = lodash.cloneDeep(rows)
  //   }
  //   return true
  // }

  /**
   * 显示费用分摊弹窗
   */
  showChargeShareDialog(receivable = true) {
    const rows = this.readSelectedRows(receivable, false)
    if (!rows || rows.length <= 0) {
      this.$message.warning(this._view.$t('common.tips.hasOneAtleast'))
      return false
    }
    if (rows.length > 1) {
      const currency = rows[0].currency
      const receivable = rows[0].receivable
      for (const row of rows) {
        if (!row.currency || row.currency !== currency || row.receivable !== receivable) {
          // 费用分摊的币种和收付方向应一致。
          this.$message.warning(this._view.$t('CargoMsg.Cargo_ShareChargeCheckCurrency'))
          return false
        }
      }
    }
    this._view.shareChargeDialog.charges = lodash.cloneDeep(rows)
    const allRows = receivable ? this._view.tabCost.grid.overseaCostDetails : this._view.tabSelling.grid.overseaSellingDetails
    const diffChargeKeys = []
    for (const row of allRows) {
      if (row.diffChargeUuid) {
        diffChargeKeys.push(row.diffChargeUuid)
      }
    }
    this._view.shareChargeDialog.diffChargeKeys = diffChargeKeys
    return true
  }

  //
  //   /**
  //    * 分摊费用
  //    */
  shareCharge(isCost = true) {
    //     if (shareChargeWindow === null) {
    //       shareChargeWindow = new ShareChargeWindow();
    //       shareChargeWindow.addEventListener("chargeShared", chargeSharedHandler);
    //     }
    //     shareChargeWindow.charge = isCost ? dgOverseaCost.selectedItem as Charge : dgOverseaSelling.selectedItem as Charge;
    //     PopUpUtils.addPopUp(shareChargeWindow, this, true);
  }

  /**
   * 分摊费用弹窗回调
   */
  async chargeSharedHandler() {
    if (this._view.config.automaticAllocation && this._view.job.automaticAllocation) {
      this._view.job.automaticAllocation = false
    }
    await this._view.onShow(this._view.job, true)
  }

  // 抄录应付
  async copySellingHandler() {
    // CARGO-28543 勾选抄录时，相同费用名称也可抄录
    const chooseSellingRows = this._view.tabSelling.grid.gridApi.getSelectedRows()
    if (chooseSellingRows.length !== 0) {
      // CARGO-2399，抄录应付/应收：只抄录普通费用
      this.chooseSellingRows = chooseSellingRows.filter(charge => !(this._view.privilege.enableCommission && charge.special))
      if (this.chooseSellingRows.length === 0) {
        this.$message.info(this._view.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems1') + ' ' + 0 + ' ' + this._view.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems2'))
        return
      }
      for (const charge of this.chooseSellingRows) {
        if (!this.checkChargeItemId(charge, true)) {
          // 存在重复的，则弹窗让用户确认
          this.$confirm(this.$t('Tool.RepeatCopyMessage'), this.$t('CargoMsg.Cargo_ConfirmR')).then(() => {
            this.copyChooseSellingHandler()
          }).catch(() => {})
          return
        }
      }
      this.copyChooseSellingHandler()
      return
    }
    // 抄录所有时，相同费用名称不可抄录
    const sellings = this._view.tabSelling.grid.overseaSellingDetails
    const overseaCostDetails = this._view.tabCost.grid.overseaCostDetails
    if (!sellings || sellings.length === 0) {
      this.$message.info(this._view.$t('Message.PayablesIsNull'))
      return
    }
    this.copyCount = 0
    const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(this.getBranchIdForCharge())
    this._view.copyedChargeList = []
    // 是否有禁用的收费项目标识
    let haveDisableItem = false
    for (const charge of sellings) {
      // CARGO-2399，抄录应付/应收：只抄录普通费用
      if (this._view.privilege.enableCommission && charge.special) {
        continue
      }
      if (charge.chargeItemId) {
        // 判断费用项目是否被禁用，若被禁用，不在进行抄录并提醒
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
        if (!chargeItem || !chargeItem.active) {
          haveDisableItem = true
          continue
        }
      }
      if (this.checkChargeItemId(charge, true)) {
        await this.realCopySellingHandler(charge, localCurrency, overseaCostDetails)
      }
    }
    // 抄录的有禁用的收费项目提示
    if (haveDisableItem) {
      this.$message.warning(this._view.$t('Message.Some_Items_Have_Expired'))
      await sleep(100)
    }
    if (this.copyCount > 0) {
      this.$message.info(this._view.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems1') + ' ' + this.copyCount + ' ' + this._view.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems2'))
    } else {
      this.$message.info(this._view.$t('Message.NoPayablesCanBeCopiedThereMayBeSameChargeItems'))
    }
    await this.refreshCopyedChargeTitle()
    if (this._view.copyedChargeList != null && this._view.copyedChargeList.length > 0) {
      for (const charge of this._view.copyedChargeList) {
        await this.loadChargeWht(charge)
      }
    }
    // 按费用序号排序【需要升序】
    this._view.tabCost.grid.overseaCostDetails = sortByMultiField(overseaCostDetails, ['serialNumber'], false)
    this.refDgChargeInfo()
  }

  async copyChooseSellingHandler() {
    const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(this.getBranchIdForCharge())
    const overseaCostDetails = this._view.tabCost.grid.overseaCostDetails
    for (const charge of this.chooseSellingRows) {
      await this.realCopySellingHandler(charge, localCurrency, overseaCostDetails)
    }
    this.$message.info(this._view.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems1') + ' ' + this.chooseSellingRows.length + ' ' + this._view.$t('Message.CopyThePayablesSuccessfullyTotallyOfNItems2'))
    await this.refreshCopyedChargeTitle()
    if (this._view.copyedChargeList != null && this._view.copyedChargeList.length > 0) {
      for (const charge of this._view.copyedChargeList) {
        await this.loadChargeWht(charge)
      }
    }
    // 按费用序号排序【需要升序】
    this._view.tabCost.grid.overseaCostDetails = sortByMultiField(overseaCostDetails, ['serialNumber'], false)
    this.refDgChargeInfo()
  }

  async realCopySellingHandler(charge, localCurrency, overseaCostDetails) {
    const obj = new Charge().fillDefaultValue().getData()
    obj.uuid = this._view.tabCost.grid.uuidPrefixRule + getUuid()
    obj.jobUuid = this._view.job.uuid
    obj.chargeItemId = charge.chargeItemId
    if (this._view.config.isSpecialExpenseEntryFunction) {
      const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
      if (chargeItem && chargeItem.specialExpenseMarker) {
        obj.chargeItemId = 0
      }
    }
    obj.inputBy = this.$store.getters.userId
    obj.inputDate = DateUtils.formatStandardDateTime(new Date())
    obj.currency = charge.currency
    obj.measure = charge.measure
    obj.receivable = true
    obj.quantity = charge.quantity
    obj.localCurrency = localCurrency
    // 后端的  syncBranchId 在前端此处赋值即可
    obj.branchId = this._view.privilege.showOtherBranchCharge ? this._view.currentSettleBranchId : this.getBranchIdForCharge()
    obj.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, obj.currency, this._view.job, obj.branchId)
    obj.exchangeRate = NumberUtils.roundHalfUp(obj.exchangeRate, 8)// CARGO-7779
    obj.unitRate = charge.unitRate
    obj.amount = charge.amount
    obj.taxRate = charge.taxRate
    obj.taxAmount = charge.taxAmount
    obj.excludingTaxAmount = charge.excludingTaxAmount
    obj.verifiedAmount = 0
    obj.accountingDate = null
    obj.counterPartyBillingNo = null
    obj.chargeSource = this._view.chargeSource
    obj.unitPriceIncludeTax = charge.unitPriceIncludeTax
    if (this._view.config.openHecConfig) {
      obj.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
    }
    obj.serialNumber = this.getMaxSerialNumber(obj.receivable) + 1 // 序号，CARGO-5881，按照录入顺序排序
    // HQ币种/汇率
    obj.hqCurrency = RateUtil.getHqCurrency(obj.branchId)
    obj.hqRate = await RateUtil.getForeignExchangeRateByJob(obj.hqCurrency, localCurrency, this._view.job, obj.branchId)
    // New copied charge: use currently selected department.
    obj.inputByDep = Number(this.$store.getters.currentDeptId) || Number(this._view.job.opDepartment) || 0
    obj.businessDate = this._view.job.businessDate

    // 判断是否符合工厂数据
    if (this._view.config.arSettlementUnitOptional && charge.receivable && !ChargeUtils.checkFactorySign(this._view.companyFactorySigns, charge.accountId)) {
      charge.accountId = 0
    } else if (this._view.config.accountObjectControlMode) {
      obj.accountId = this._view.job.customerId
    } else {
      this.fillDefaultCopyValueByCharge(obj, charge, this._view.job, true)
    }
    // CARGO-32882 合作伙伴增加客户代码/供应商代码字段，并且增加客户/供应商隔离配置项当
    if (obj.accountId && obj.accountId > 0) {
      const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', obj.accountId)
      // 抄录应付到应收，应收对象不是客户时，清空应收对象
      // CARGO-36892,合作伙伴无效时置为0
      if (!company.ifCustomer || !company.active) {
        obj.accountId = 0
      }
    }
    await ChargeUtils.getChargeisOverseaNotControlledByConfig(obj)
    if (obj.accountId && obj.accountId > 0) {
      await this.getSettlementByCompanyId(obj)
    }
    this._view.jobControlledCharges.push(obj)
    this.copyCount++
    this._view.copyedChargeList.push(obj)
    if (this._view.tabCost.grid.overseaCostDetails.findIndex(item => obj.uuid === item.uuid) === -1) {
      this._view.tabCost.grid.overseaCostDetails.push(obj)
    }
    this.addChargeForJob(obj)
  }

  // 将新增的费用加入job,作用是在编辑状态下切换不同页签，当前页签新增的费用不会丢失
  addChargeForJob(charge) {
    if (!this._view.job.charges) this._view.job.charges = []
    this._view.job.charges.push(charge)
  }

  // 将费用从job移除,作用是在编辑状态下切换不同页签，当前页签新增的费用不会丢失
  removeChargeForJob(c) {
    if (this._view.job.charges && this._view.job.charges.length > 0) {
      for (const charge of this._view.job.charges) {
        // CARGO-21740 海出-复制新增业务中的费用，保存时删除的费用又会随机出现一条
        if (charge === c || (charge.uuid && c.uuid && charge.uuid === c.uuid) || (charge.receivable === c.receivable && charge.serialNumber && charge.serialNumber === c.serialNumber)) {
          const chargeIndex = this._view.job.charges.indexOf(charge)
          if (chargeIndex > -1) {
            this._view.job.charges.splice(chargeIndex, 1)
          }
        }
      }
    }
  }

  checkCompanyData(accountId, ar) {
    const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', accountId)
    // 抄录应收到应付，应收对象不是供应商时，清空应收对象
    // CARGO-36892,合作伙伴无效时置为0
    if (!company.active) {
      return 0
    }
    // 应收需要是客户  应付需要是供应商
    if ((ar && !company.ifCustomer) || (!ar && !company.ifSupplier)) {
      return 0
    }
    return accountId
  }
  // 复制时填充默认对象
  fillDefaultCopyValueByCharge(targetCharge, sourceCharge, job, isArTarget) {
    let chargeItem = null
    if (Number(sourceCharge.chargeItemId) !== 0) {
      chargeItem = ChargeItem.getChargeItemById(sourceCharge.chargeItemId)
    }
    // 取值默认固定结算对象
    let defaultAccountId = 0
    if (chargeItem != null && isArTarget && chargeItem.defaultArAccountId) {
      defaultAccountId = this.checkCompanyData(chargeItem.defaultArAccountId, true)
    } else if (chargeItem != null && !isArTarget && chargeItem.defaultApAccountId) {
      defaultAccountId = this.checkCompanyData(chargeItem.defaultApAccountId, false)
    }
    if (defaultAccountId) {
      targetCharge.accountId = defaultAccountId
    } else if (chargeItem != null && isArTarget && chargeItem.defaultArCode != null && chargeItem.defaultArCode !== '') {
      targetCharge.accountId = ChargeUtils.getChargeDefaultChargeItem(job, chargeItem.defaultArCode)
    } else if (chargeItem != null && !isArTarget && chargeItem.defaultApCode != null && chargeItem.defaultApCode !== '') {
      targetCharge.accountId = ChargeUtils.getChargeDefaultChargeItem(job, chargeItem.defaultApCode)
    } else {
      targetCharge.accountId = job.customerId
    }
  }

  // 抄录应收
  async copyCostHandler() {
    // CARGO-28543 勾选抄录时，相同费用名称也可抄录
    const chooseCostRows = this._view.tabCost.grid.gridApi.getSelectedRows()
    if (chooseCostRows.length !== 0) {
      // CARGO-2399，抄录应付/应收：只抄录普通费用
      this.chooseCostRows = chooseCostRows.filter(charge => !(this._view.privilege.enableCommission && charge.special))
      if (this.chooseCostRows.length === 0) {
        this.$message.info(this._view.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems1') + ' ' + 0 + ' ' + this._view.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems2'))
        return
      }
      for (const charge of this.chooseCostRows) {
        if (!this.checkChargeItemId(charge, false)) {
          // 存在重复的，则弹窗让用户确认
          this.$confirm(this.$t('Tool.RepeatCopyMessage'), this.$t('CargoMsg.Cargo_ConfirmR')).then(() => {
            this.copyChooseCostHandler()
          }).catch(() => {})
          return
        }
      }
      this.copyChooseCostHandler()
      return
    }
    // 抄录所有时，相同费用名称不可抄录
    const costCharges = this._view.tabCost.grid.overseaCostDetails
    const overseaSellingDetails = this._view.tabSelling.grid.overseaSellingDetails
    if (costCharges === null || costCharges.length === 0) {
      this.$message.info(this._view.$t('Message.ReceivalbeIsNull'))
      return
    }
    this.copyCount = 0
    const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(this.getBranchIdForCharge())
    this._view.copyedChargeList = []
    // 是否有禁用的收费项目标识
    let haveDisableItem = false
    for (const charge of costCharges) {
      // CARGO-2399，抄录应付/应收：只抄录普通费用
      if (this._view.privilege.enableCommission && charge.special) {
        continue
      }
      if (charge.chargeItemId) {
        // 判断费用项目是否被禁用，若被禁用，不在进行抄录并提醒
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
        if (!chargeItem || !chargeItem.active) {
          haveDisableItem = true
          continue
        }
      }
      if (this.checkChargeItemId(charge, false)) {
        await this.realCopyCostHandler(charge, localCurrency, overseaSellingDetails)
      }
    }
    // 抄录的有禁用的收费项目提示
    if (haveDisableItem) {
      this.$message.warning(this._view.$t('Message.Some_Items_Have_Expired'))
      await sleep(100)
    }
    if (this.copyCount > 0) {
      this.$message.info(this._view.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems1') + ' ' + this.copyCount + ' ' + this._view.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems2'))
    } else {
      this.$message.info(this._view.$t('Message.NoReceivablesCanBeCopiedThereMayBeSameChargeItems'))
    }
    await this.refreshCopyedChargeTitle()
    if (this._view.copyedChargeList != null && this._view.copyedChargeList.length > 0) {
      for (const charge of this._view.copyedChargeList) {
        await this.loadChargeWht(charge)
      }
    }
    // 按费用序号排序【需要升序】
    this._view.tabSelling.grid.overseaSellingDetails = sortByMultiField(overseaSellingDetails, ['serialNumber'], false)
    this.refDgChargeInfo()
  }

  async copyChooseCostHandler() {
    const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(this.getBranchIdForCharge())
    const overseaSellingDetails = this._view.tabSelling.grid.overseaSellingDetails
    for (const charge of this.chooseCostRows) {
      await this.realCopyCostHandler(charge, localCurrency, overseaSellingDetails)
    }
    this.$message.info(this._view.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems1') + ' ' + this.chooseCostRows.length + ' ' + this._view.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems2'))
    await this.refreshCopyedChargeTitle()
    if (this._view.copyedChargeList != null && this._view.copyedChargeList.length > 0) {
      for (const charge of this._view.copyedChargeList) {
        await this.loadChargeWht(charge)
      }
    }
    // 按费用序号排序【需要升序】
    this._view.tabSelling.grid.overseaSellingDetails = sortByMultiField(overseaSellingDetails, ['serialNumber'], false)
    this.refDgChargeInfo()
  }

  async realCopyCostHandler(charge, localCurrency, overseaSellingDetails) {
    const obj = new Charge().fillDefaultValue().getData()
    obj.uuid = this._view.tabSelling.grid.uuidPrefixRule + getUuid()
    obj.jobUuid = this._view.job.uuid
    obj.chargeItemId = charge.chargeItemId
    if (this._view.config.isSpecialExpenseEntryFunction) {
      const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
      if (chargeItem && chargeItem.specialExpenseMarker) {
        obj.chargeItemId = 0
      }
    }
    obj.accountId = this._view.job.customerId
    obj.inputBy = this.$store.getters.userId
    obj.inputDate = DateUtils.formatStandardDateTime(new Date())
    obj.currency = charge.currency
    obj.measure = charge.measure
    obj.receivable = false
    obj.quantity = charge.quantity
    obj.localCurrency = localCurrency
    // 后端的  syncBranchId 在前端此处赋值即可
    obj.branchId = this._view.privilege.showOtherBranchCharge ? this._view.currentSettleBranchId : this.getBranchIdForCharge()
    obj.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, obj.currency, this._view.job, obj.branchId)
    obj.exchangeRate = NumberUtils.roundHalfUp(obj.exchangeRate, 8) // CARGO-7779
    obj.unitRate = charge.unitRate
    obj.amount = charge.amount
    obj.taxRate = charge.taxRate
    obj.taxAmount = charge.taxAmount
    obj.unitPriceIncludeTax = charge.unitPriceIncludeTax
    if (this._view.config.openHecConfig) {
      obj.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
    }
    obj.excludingTaxAmount = charge.excludingTaxAmount
    obj.verifiedAmount = 0
    obj.accountingDate = null
    obj.counterPartyBillingNo = null
    obj.serialNumber = this.getMaxSerialNumber(obj.receivable) + 1 // 序号，CARGO-5881，按照录入顺序排序
    // HQ币种/汇率
    obj.hqCurrency = RateUtil.getHqCurrency(obj.branchId)
    obj.hqRate = await RateUtil.getForeignExchangeRateByJob(obj.hqCurrency, localCurrency, this._view.job, obj.branchId)
    // New copied charge: use currently selected department.
    obj.inputByDep = Number(this.$store.getters.currentDeptId) || Number(this._view.job.opDepartment) || 0
    obj.businessDate = this._view.job.businessDate

    this.fillDefaultCopyValueByCharge(obj, charge, this._view.job, false)
    // CARGO-32882 合作伙伴增加客户代码/供应商代码字段，并且增加客户/供应商隔离配置项当
    if (obj.accountId && obj.accountId > 0) {
      const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', obj.accountId)
      // 抄录应收到应付，应收对象不是供应商时，清空应收对象
      // CARGO-36892,合作伙伴无效时置为0
      if (!company.ifSupplier || !company.active) {
        obj.accountId = 0
      }
    }
    ChargeUtils.getChargeisOverseaNotControlledByConfig(obj)
    if (obj.accountId && obj.accountId > 0) {
      await this.getSettlementByCompanyId(obj)
    }
    obj.chargeSource = this._view.chargeSource
    this._view.jobControlledCharges.push(obj)
    this.copyCount++
    this._view.copyedChargeList.push(obj)
    this._view.tabSelling.grid.overseaSellingDetails.push(obj)
    this.addChargeForJob(obj)
  }

  // 是否存在相同的费用名称  isAr: true- 应收费用(抄录应付),false-应付费用(抄录应收)
  checkChargeItemId(charge, isAr) {
    let charges = null
    if (isAr) {
      charges = this._view.tabCost.grid.overseaCostDetails
    } else {
      charges = this._view.tabSelling.grid.overseaSellingDetails
    }
    for (const c of charges) {
      if (Number(c.chargeItemId) === Number(charge.chargeItemId) && c.currency === charge.currency && c.measure === charge.measure) {
        return false
      }
    }
    return true
  }

  // 费用方案
  async chargeSchemeHandler() {
    if (!this._view.job) {
      this.$message.info(this._view.$t('Message.TheCurrentlyRelevantBusinessInformationIsNull'))
      return
    }
    if (this._view.viewSource === 'salesDetail') {
      if (!await this.checkChargeLocked(true, true)) {
        return
      }
    }
    const job = this._view.job
    if (!job.manifestInfoPage) {
      if (!job.manifestInfos || job.manifestInfos.length === 0) {
        job.manifestInfos = await job.getManifestInfos()
      }
      if (job.manifestInfos) {
        const combinedManifest = Number(this.cacheConfig.get('CombinedManifest')) === 1 // 锦昶才会开这个参数
        for (const m of job.manifestInfos) {
          if (combinedManifest) {
            if (m.delete) continue // 已删除舱单排除
            if (m.invalid) continue // 已作废舱单排除
          }
          if (m.uuid) {
            m.manifestGoods = await getManifestGoods({ manifestInfoUuid: m.uuid }).then(res => res.data)
          }
        }
      }
    }
    this._view.chargePlanDialog.isSea = job.lob === 'SE' || job.lob === 'SI'
    this._view.chargePlanDialog.lob = job.lob
    this._view.chargePlanDialog.chargeSchemeIsApproved = Number(this.cacheConfig.get('ChargeSchemeIsApproved')) === 1 // 费用方案需是否审核后才能使用【费用方案页签使用】
    this._view.chargePlanDialog.visible = true
  }

  // 抄录费用
  async cpoyChargeHandler() {
    if (!this._view.job) {
      this.$message.info(this._view.$t('Message.TheCurrentlyRelevantBusinessInformationIsNull'))
      return
    }
    // 检查是否有抄录费用权限
    if (!this._view.privilege.copyCharge) {
      this.$message.warning(this._view.$t('Message.NoNewPermissionsForFees'))
      return
    }
    const job = this._view.job
    this._view.copyChargeDialog.isSea = job.lob === 'SE' || job.lob === 'SI'
    this._view.copyChargeDialog.lob = job.lob
    this._view.copyChargeDialog.visible = true
  }

  // 同步云平台
  async synchronizationLtsCharge(ar) {
    let row = []
    if (ar) {
      // 同步应收费用
      row = this._view.tabCost.grid.gridApi.getSelectedRows()
    } else {
      // 同步应付费用
      row = this._view.tabSelling.grid.gridApi.getSelectedRows()
    }
    if (row.length === 0) {
      this.$message.info(this._view.$t('Message.PleaseSelectTheFeeYouNeedToPush'))
      return
    }
    const list = []
    for (const d of row) {
      list.push(d.uuid)
    }
    batchPushLtsFunc(list).then(res => {
      if (res.data === 'ok') {
        this.$message.success(this._view.$t('Message.SynchronizationSucceeded'))
        this._view.onShow(this._view.job, true)
      } else if (res.data === 'not data') {
        this.$message.warning(this._view.$t('Message.NoSynchronizationContent'))
      } else {
        this.$message.warning(res.data)
      }
    })
  }
  // 费用方案 -选择费用后事件
  async selectedSchemeHandler(allSchemeDetails) {
    if (!allSchemeDetails || allSchemeDetails.length <= 0) return
    let schemeDetails = allSchemeDetails
    // 费用合并后，费用方案只留应收费用
    if (this._view.showMergeChargeItemSalesView) {
      schemeDetails = allSchemeDetails.filter(p => p.receivable)
      if (!schemeDetails || schemeDetails.length <= 0) return
    }
    if (this._view.config.accountObjectControlMode) {
      for (const schemeDetail of schemeDetails) {
        if (schemeDetail.receivable && !this._view.config.arSettlementUnitOptional) {
          schemeDetail.accountId = this._view.job.customerId
        }
      }
    }
    const chargeBranchId = this._view.privilege.showOtherBranchCharge ? this._view.currentSettleBranchId : this.getBranchIdForCharge()
    const charges = await ChargeUtils.applyChargeScheme(this._view.job, schemeDetails, this._view.chargeSource, this._view.config._getHBLcWeight, chargeBranchId)
    // CARGO-33201 选择费用方案后若开启合创交单参数则默认未提交
    for (const charge of charges) {
      if (this._view.config.openHecConfig) {
        charge.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
      }
      if (this._view.config.currentOfficeCharge && this._view.job.salesOffice) {
        charge.branchId = this._view.job.salesOffice
      }
      if (charge.accountId && charge.accountId > 0) {
        const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
        // CARGO-36892,合作伙伴无效时置为0
        if (!company.active) {
          charge.accountId = 0
        }
        if (this._view.config.arSettlementUnitOptional && charge.receivable && !ChargeUtils.checkFactorySign(this._view.companyFactorySigns, charge.accountId)) {
          charge.accountId = 0
          charge.invoiceTitle = ''
        }
      }
    }
    if (this._view.privilege.showOtherBranchCharge && charges && charges.length > 0) charges.forEach(charge => { charge.branchId = this._view.currentSettleBranchId })
    if (this._view.viewSource === 'salesDetail') {
      // 是否有禁用的收费项目标识
      let haveDisableItem = false
      // 有效费用
      const effectiveCharges = []
      for (const charge of charges) {
        // 判断费用项目是否被禁用，若被禁用，不在进行抄录并提醒
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
        if (!chargeItem || !chargeItem.active) {
          haveDisableItem = true
          continue
        }
        if (chargeItem.rateRange) {
          const message = ChargeUtils.checkChargeRateRange(charge)
          if (message) {
            this.$message.warning(this.$t('CargoMsg.Cargo_TaxRateRangeLimit', [message]))
            return
          }
        }
        await this.loadChargeWht(charge)
        effectiveCharges.push(charge)
      }
      if (effectiveCharges.length > 0) {
        this._view.loading = getLoading()
        saveChargeSchemeByJob(charges).then(res => {
          const newJob = res.data
          for (const key in newJob) {
            if (typeof this._view.job[key] === 'object' || !newJob[key]) {
              continue
            }
            this._view.job[key] = newJob[key]
          }
          this.clickHandler1Handler()
        }).finally(() => {
          this._view.loading.close()
        })
      }
      // 抄录的有禁用的收费项目提示
      if (haveDisableItem) {
        this.$message.warning(this._view.$t('Message.Some_Items_Have_Expired'))
        await sleep(100)
      }
    } else {
      // CARGO-1072，默认开票抬头：通过费用方案
      await ChargeUtils.updateDefaultInvoiceTitle(charges)
      // 是否有禁用的收费项目标识
      let haveDisableItem = false
      if (charges && charges.length > 0) {
        const accountTitleMap = new Map()
        this.$logger.log('费用方案--charges', charges)
        for (const charge of charges) {
          // 判断费用项目是否被禁用，若被禁用，不在进行抄录并提醒
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
          if (!chargeItem || !chargeItem.active) {
            haveDisableItem = true
            continue
          }
          // 特殊费用
          if (this._view.config.isSpecialExpenseEntryFunction) {
            if (chargeItem && chargeItem.specialExpenseMarker) {
              charge.chargeItemId = 0
            }
          }
          if (charge.accountId && charge.accountId > 0) {
            await this.getSettlementByCompanyId(charge)
            // CARGO-35852 通过费用方案生成费用，没有按照开票要求里选的国内国外，生成费用的国内国外（有备注）
            const canChangeOverseaOfCharge = parseInt(cache.config.get('canChangeOverseaOfCharge'))
            if (canChangeOverseaOfCharge !== 2 && canChangeOverseaOfCharge !== 3) {
              if (charge.invoiceTitle) {
                let invoiceTitleList = null
                if (accountTitleMap.has(charge.accountId)) {
                  invoiceTitleList = accountTitleMap.get(charge.accountId)
                } else {
                  invoiceTitleList = await ChargeUtils.getTitleListByCompanyCmpIdx(charge.accountId)
                  accountTitleMap.set(charge.accountId, invoiceTitleList)
                }
                const flag = ChargeUtils.updateOverseaByInvoiceTitle(charge, invoiceTitleList)
                if (!flag) { // 费用的开票抬头不在结算对象维护的开票抬头中时，根据结算对象带出默认的国内国外
                  await ChargeUtils.updateOverseaByAccountId(charge)
                }
              } else if (charge.accountId > 0) {
                await ChargeUtils.updateOverseaByAccountId(charge)
              }
            }
          }
          await this.loadChargeWht(charge)
          if (charge.receivable) {
            if (!this._view.lockAr) {
              charge.uuid = this._view.tabCost.grid.uuidPrefixRule + getUuid()
              this._view.tabCost.grid.overseaCostDetails.push(charge)
              this.addChargeForJob(charge)
              this._view.isCostRowDragEnd = true
            }
          } else {
            if (!this._view.lockAp) {
              charge.uuid = this._view.tabSelling.grid.uuidPrefixRule + getUuid()
              this._view.tabSelling.grid.overseaSellingDetails.push(charge)
              this.addChargeForJob(charge)
              this._view.isSellingRowDragEnd = true
            }
          }
        }
      }
      // 抄录的有禁用的收费项目提示
      if (haveDisableItem) {
        this.$message.warning(this._view.$t('Message.Some_Items_Have_Expired'))
        await sleep(100)
      }
      this.loadForBookingResultHandler()
    }
  }

  /**
   * 带出费用WHT税率和税额
   * @param charge
   */
  async loadChargeWht(charge) {
    const office = this._view.$store.getters.currentOffice
    charge.whtTaxAmount = 0
    if (office.whtTaxMode && charge.invoiceTitle && charge.chargeItemId) {
      const invoiceTitleList = await this.getTitlesByCompanyId(charge)
      if (invoiceTitleList) {
        const invoiceTitle = invoiceTitleList.find(p => p.title === charge.invoiceTitle)
        if (invoiceTitle && invoiceTitle.suitWhtTax) {
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
          if (chargeItem && chargeItem.defaultWhtRate > 0) {
            charge.whtTaxRate = chargeItem.defaultWhtRate
            if (charge.whtTaxRate > 0 && charge.excludingTaxAmount > 0) {
              charge.whtTaxAmount = NumberUtils.ToFixed2(charge.excludingTaxAmount * charge.whtTaxRate / 100, 2)
            }
          }
        }
      }
    }
  }

  // 抄录费用-选择费用后返回事件
  async selectedCopyChargeHandler(chargeList) {
    const costCharges = chargeList
    // 应付费用
    const overseaSellingDetails = this._view.tabSelling.grid.overseaSellingDetails
    // 应收费用
    const overseaCostDetails = this._view.tabCost.grid.overseaCostDetails
    let i = 0
    const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(this.getBranchIdForCharge())
    this._view.copyedChargeList = []
    // 是否有禁用的收费项目标识
    let haveDisableItem = false

    // 销售查询页面：校验应收和应付费用新增权限
    if (this._view.viewSource === 'salesDetail') {
      const isAdmin = this.$store.getters.isAdmin || this.$store.getters.admin

      // 非管理员需要进行权限校验
      if (!isAdmin) {
        // 获取权限状态（costAddCharge=应付，payAddCharge=应收）
        const hasCostAddChargePermission = this._view.privilege.isCostAddChargeRole // 应付新增权限
        const hasPayAddChargePermission = this._view.privilege.isPayAddChargeRole // 应收新增权限
        const hasAddSpecialChargePermission = this._view.privilege.addSpecialCharge // 特殊费用新增权限

        // 遍历所有选中的费用进行校验
        for (const charge of costCharges) {
          if (charge.receivable) {
            // 应收费用
            if (charge.special) {
              // 特殊应收费用：需要特殊费用新增权限
              if (!hasAddSpecialChargePermission) {
                this.$message.warning('没有特殊费用新增权限')
                return
              }
            } else {
              // 普通应收费用：需要应收新增权限
              if (!hasPayAddChargePermission) {
                this.$message.warning('没有应收费用新增权限')
                return
              }
            }
          } else {
            // 应付费用
            if (charge.special) {
              // 特殊应付费用：需要特殊费用新增权限
              if (!hasAddSpecialChargePermission) {
                this.$message.warning('没有特殊费用新增权限')
                return
              }
            } else {
              // 普通应付费用：需要应付新增权限
              if (!hasCostAddChargePermission) {
                this.$message.warning('没有应付费用新增权限')
                return
              }
            }
          }
        }
      }
    }

    for (const charge of costCharges) {
      const obj = new Charge().fillDefaultValue().getData()
      if (charge.receivable) {
        obj.uuid = this._view.tabCost.grid.uuidPrefixRule + getUuid()
      } else {
        obj.uuid = this._view.tabSelling.grid.uuidPrefixRule + getUuid()
      }
      obj.jobUuid = this._view.job.uuid
      // 判断费用项目是否被禁用，若被禁用，不在进行抄录并提醒
      const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
      if (!chargeItem || !chargeItem.active) {
        haveDisableItem = true
        continue
      }
      // 特殊费用（销售查询页面跳过此处理）
      if (this._view.config.isSpecialExpenseEntryFunction && this._view.viewSource !== 'salesDetail') {
        if (chargeItem && chargeItem.specialExpenseMarker) {
          charge.chargeItemId = 0
        }
      }
      obj.chargeItemId = charge.chargeItemId
      obj.unitPriceIncludeTax = charge.unitPriceIncludeTax
      // 销售查询页面抄录费用时，使用当前订单的委托单位作为结算对象
      if (this._view.viewSource === 'salesDetail') {
        // 使用当前订单的委托单位(customerId)作为结算对象
        obj.accountId = Number(this._view.job.customerId) || 0
        // 结算代理(settlementAgentId)也使用委托单位的值
        obj.settlementAgentId = obj.accountId
        // 如果委托单位有效，获取其开票抬头
        if (obj.accountId > 0) {
          const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', obj.accountId)
          if (company) {
            obj.invoiceTitle = company.chineseName || company.englishName || ''
          }
        }
      } else if (this._view.config.arSettlementUnitOptional && charge.receivable) {
        if (!ChargeUtils.checkFactorySign(this._view.companyFactorySigns, charge.accountId)) {
          obj.accountId = 0
        }
      } else {
        obj.accountId = this._view.config.accountObjectControlMode && charge.receivable ? this._view.job.customerId : charge.accountId
      }
      // 销售查询页面跳过合作伙伴有效性检查（避免accountId被错误置为0）
      if (this._view.viewSource !== 'salesDetail') {
        if (obj.accountId && obj.accountId > 0) {
          const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', obj.accountId)
          // CARGO-36892,合作伙伴无效时置为0
          if (!company || !company.active) {
            obj.accountId = 0
          }
        }
      }
      if (obj.accountId && obj.accountId > 0) {
        await this.getSettlementByCompanyId(obj)
      }
      obj.inputBy = this.$store.getters.userId
      obj.inputDate = DateUtils.formatStandardDateTime(new Date())
      obj.oversea = charge.oversea
      obj.currency = charge.currency
      obj.measure = charge.measure
      if (this._view.config.openHecConfig) {
        obj.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
      }
      obj.receivable = charge.receivable
      // obj.invoiceTitle = charge.invoiceTitle
      await this.refreshQuantity(obj)
      obj.unitRate = charge.unitRate
      obj.taxRate = charge.taxRate
      if (obj.unitPriceIncludeTax) {
        ChargeUtils.calculateTaxAmount(obj, multiply(obj.quantity, obj.unitRate), obj.taxRate)
      } else {
        ChargeUtils.calculateTax(obj, multiply(obj.quantity, obj.unitRate), obj.taxRate)
      }
      obj.verifiedAmount = 0
      obj.accountingDate = null
      obj.counterPartyBillingNo = null
      // 后端的  syncBranchId 在前端此处赋值即可
      obj.branchId = this._view.privilege.showOtherBranchCharge ? this._view.currentSettleBranchId : this.getBranchIdForCharge()
      // 序号，CARGO-5881，按照录入顺序排序
      obj.serialNumber = this.getMaxSerialNumber(obj.receivable) + 1
      // New copied charge: use currently selected department.
      obj.inputByDep = Number(this.$store.getters.currentDeptId) || Number(this._view.job.opDepartment) || 0
      obj.businessDate = this._view.job.businessDate
      obj.localCurrency = localCurrency
      obj.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, obj.currency, this._view.job, obj.branchId)
      // HQ币种/汇率
      obj.hqCurrency = RateUtil.getHqCurrency(obj.branchId)
      obj.hqRate = await RateUtil.getForeignExchangeRateByJob(obj.hqCurrency, localCurrency, this._view.job, obj.branchId)
      // this.fillDefaultCopyValueByCharge(obj, charge, this._view.job, false)
      // await ChargeUtils.getChargeisOverseaNotControlledByConfig(obj)
      await ChargeUtils.updateDefaultInvoiceTitle([obj])
      obj.chargeSource = this._view.chargeSource
      if ((charge.receivable && !this._view.lockAr) || (!charge.receivable && !this._view.lockAp)) {
        this._view.jobControlledCharges.push(obj)
        i++
        this._view.copyedChargeList.push(obj)
      }
      if (charge.receivable) {
        if (this._view.tabCost.grid.overseaCostDetails.findIndex(item => obj.uuid === item.uuid) === -1 && !this._view.lockAr) {
          this._view.tabCost.grid.overseaCostDetails.push(obj)
          this.addChargeForJob(obj)
        }
      } else {
        if (this._view.tabSelling.grid.overseaSellingDetails.findIndex(item => obj.uuid === item.uuid) === -1 && !this._view.lockAp) {
          this._view.tabSelling.grid.overseaSellingDetails.push(obj)
          this.addChargeForJob(obj)
        }
      }
    }
    // 抄录的有禁用的收费项目提示
    if (haveDisableItem) {
      this.$message.warning(this._view.$t('Message.Some_Items_Have_Expired'))
      await sleep(100)
    }
    if (i > 0) {
      // 销售查询页面：调用后端接口保存费用
      if (this._view.viewSource === 'salesDetail') {
        // 准备保存的数据（删除 tenantId 和 uuid 字段）
        const chargesToSave = this._view.copyedChargeList.map(charge => {
          const chargeData = { ...charge }
          // 删除 tenantId 和 uuid（不传这些字段）
          delete chargeData.tenantId
          delete chargeData.uuid
          return chargeData
        })
        // 调用后端接口保存
        await saveAdjustJob(chargesToSave, { editMode: 'add', location: this._view.location })
        // 销售查询页面使用绿色成功提示
        this.$message.success(this._view.$t('Message.CopyChargeSuccessfullyTotallyOfNItems1') + ' ' + i + ' ' + this._view.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems2'))
      } else {
        this.$message.info(this._view.$t('Message.CopyChargeSuccessfullyTotallyOfNItems1') + ' ' + i + ' ' + this._view.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems2'))
      }
    } else {
      this.$message.info(this._view.$t('Message.NoChargeCanBeCopiedThereMayBeSameChargeItems'))
    }
    await this.refreshCopyedChargeTitle()
    if (this._view.copyedChargeList != null && this._view.copyedChargeList.length > 0) {
      for (const charge of this._view.copyedChargeList) {
        await this.loadChargeWht(charge)
      }
      this._view.tabCost.grid.gridApi.refreshCells({ force: true })
    }
    // 按费用序号排序【需要升序】
    this._view.tabSelling.grid.overseaSellingDetails = sortByMultiField(overseaSellingDetails, ['serialNumber'], false)
    this.refDgChargeInfo()
  }

  /**
   * 根据服务新增 (应收和应付)
   */
  async addServiceTypChargeEvent() {
    const job = this._view.job
    const chargeBranchId = this._view.privilege.showOtherBranchCharge ? this._view.currentSettleBranchId : this.getBranchIdForCharge()
    if (this._view.tabCost.visible) {
      const costCharges = await ChargeUtils.getServiceDefaultCostCharge(job, chargeBranchId)
      // this.$logger.log('costCharges', costCharges)
      if (costCharges && costCharges.length > 0) {
        for (const charge of costCharges) {
          if (this._view.privilege.showOtherBranchCharge) charge.branchId = this._view.currentSettleBranchId
          charge.uuid = this._view.tabCost.grid.uuidPrefixRule + getUuid()
          this._view.tabCost.grid.overseaCostDetails.push(charge)
          this.addChargeForJob(charge)
        }
      }
    }
    if (this._view.tabSelling.visible) {
      const sellingCharges = await ChargeUtils.getServiceDefaultSellingCharge(job, chargeBranchId)
      // this.$logger.log('sellingCharges', sellingCharges)
      if (sellingCharges && sellingCharges.length > 0) {
        for (const charge of sellingCharges) {
          if (this._view.privilege.showOtherBranchCharge) charge.branchId = this._view.currentSettleBranchId
          charge.uuid = this._view.tabSelling.grid.uuidPrefixRule + getUuid()
          this._view.tabSelling.grid.overseaSellingDetails.push(charge)
          this.addChargeForJob(charge)
        }
      }
    }
    this.refDgChargeInfo()
  }

  /**
   * 销账历史 应收
   */
  btnVerifiedCost_clickHandler() {
    if (this._view.tabCost.grid.selectedRow && this._view.tabCost.grid.selectedRow.uuid) {
      this._view.verifiedDialog.charge = this._view.tabCost.grid.selectedRow
      this._view.verifiedDialog.visible = true
    }
  }

  /**
   * 销账历史 应付
   */
  btnVerifiedSelling_clickHandler() {
    if (this._view.tabSelling.grid.selectedRow && this._view.tabSelling.grid.selectedRow.uuid) {
      this._view.verifiedDialog.charge = this._view.tabSelling.grid.selectedRow
      this._view.verifiedDialog.visible = true
    }
  }

  //
  //   /**
  //    * 费用项目过滤
  //    */
  chargeItemFilter(itemItem) {
    //     if (job.lob === "SE")
    //       return item.isForSeaExp;
    //     else if (job.lob === "AE")
    //       return item.isForAirExp;
    //     else if (job.lob === "SI")
    //       return item.isForSeaImp;
    //     else if (job.lob === "AI")
    //       return item.isForAirImp;
    //     else if (job.lob === "RE")
    //       return item.isForRailwayExp;
    //     return false;
  }

  /**
   * 应收受控（取消受控）,一般有受控权限的人才能去操作
   */
  controlledEventHandler(isReceivable) {
    this._view.isSelChargeReceivabel = isReceivable
    const controlledOrCancel = isReceivable ? this._view.isAllCostControlled : this._view.isAllSellingControlled
    const chargeSource = this.readSelectedRows(isReceivable, false) // 获取选中的费用
    if (!chargeSource || chargeSource.length === 0) {
      this.$message.warning(this._view.$t('Message.PleaseSelectCharges'))
      return
    }

    if (!this._view.isAdjust) {
      for (const charge of chargeSource) {
        if (charge.uuid) {
          if (isReceivable) {
            this._view.tabCost.grid.modifyUuids.push(charge.uuid)
          } else {
            this._view.tabSelling.grid.modifyUuids.push(charge.uuid)
          }
        }
        // controlledOrCancel 取消受控操作【true】 受控操作【false】
        charge.controlled = !controlledOrCancel
      }
      this.refreshAgGrid(isReceivable, false) // 传入false 不去掉勾选
      this.saveControlledHandler()
    } else {
      const chargeKeys = Array.from(chargeSource, p => p.uuid)
      updateChargeControlled(chargeKeys, !controlledOrCancel, this._view.location).then(res => {
        if (res && res.data > 0) {
          const controlledOrCancel = isReceivable ? this._view.isAllCostControlled : this._view.isAllSellingControlled
          const chargeSource = this.readSelectedRows(isReceivable) // 获取选中的费用
          for (const select of chargeSource) {
            // controlledOrCancel 取消受控操作【true】 受控操作【false】
            select.controlled = !controlledOrCancel
          }
          this.refreshAgGrid(isReceivable, false) // 传入false 不去掉勾选
          this.saveControlledHandler()
        } else {
          this.$message.error('操作失败')
        }
      }).catch((err) => {
        this.failureHandler(err)
      })
    }
  }

  // 刷新表格
  refreshAgGrid(isReceivable, isSelect = true) {
    if (this._view.config.chargeCommitAll) {
      if (isSelect) {
        this._view.tabCost.grid.gridApi.deselectAll() // 需要将已勾选的数据变成未勾选
        this._view.tabSelling.grid.gridApi.deselectAll()
      }
      this._view.tabCost.grid.gridApi.refreshCells({ force: true }) // 刷新
      this._view.tabCost.grid.gridApi.redrawRows()
      this._view.tabSelling.grid.gridApi.refreshCells({ force: true }) // 刷新
      this._view.tabSelling.grid.gridApi.redrawRows()
    } else {
      if (isReceivable) {
        if (isSelect) {
          this._view.tabCost.grid.gridApi.deselectAll() // 需要将已勾选的数据变成未勾选
        }
        this._view.tabCost.grid.gridApi.refreshCells({ force: true }) // 刷新
        this._view.tabCost.grid.gridApi.redrawRows()
      } else {
        if (isSelect) {
          this._view.tabSelling.grid.gridApi.deselectAll() // 需要将已勾选的数据变成未勾选
        }
        this._view.tabSelling.grid.gridApi.refreshCells({ force: true }) // 刷新
        this._view.tabSelling.grid.gridApi.redrawRows()
      }
    }
  }

  /**
   * @private
   */
  saveControlledHandler() {
    const msg1 = this._view.$t('Message.SelectChargesAreInControl')
    const msg2 = this._view.$t('Message.SelectedChargesAreCancelledControlling')
    let controlledOrCancel = null
    // 应收受控
    if (this._view.isSelChargeReceivabel) {
      controlledOrCancel = this._view.isAllCostControlled
    } else {
      // 应付受控
      controlledOrCancel = this._view.isAllSellingControlled
    }

    if (controlledOrCancel) {
      this.$message.success(msg2)
    } else {
      this.$message.success(msg1)
    }

    if (this._view.isSelChargeReceivabel) {
      // dgOverseaCost.invalidateList() // 在下次更新时刷新所有行
      // dgOverseaCost.validateNow()
      this.changeControllButton(true)
    } else {
      // dgOverseaSelling.invalidateList() // 在下次更新时刷新所有行
      // dgOverseaSelling.validateNow()
      this.changeControllButton(false)
    }
  }

  /**
   * 错误信息
   */
  failureHandler(err) {
    this.sapSelectChargeList = null
    this.$message.error('前端error：回调失败' + err)
  }

  //
  //   /**
  //    * 显示分票信息
  //    */
  chkLcLChargeHandler(event) {
    if (this._view.checkbox.chkLcLCharge.selected) {
      // console.log('this._view.privilege.departmentChargeRole', this._view.privilege.departmentChargeRole)
      // console.log('this._view.privilege.userChargeRole', this._view.privilege.userChargeRole)
      if (this._view.isOtherSettleBranchId || (this._view.privilege.queryArAllRole || this._view.privilege.queryApAllRole)) {
        this.showLclCharge()
      } else if (this._view.privilege.queryArDeptChargeRole || this._view.privilege.queryApDeptChargeRole) {
        this.extractDepartmentTeamLCLCharge()
      } else {
        this.extractCurrentUserLCLCharge()
      }
    } else {
      [...this._view.tabCost.grid.overseaCostDetails].forEach((item, index) => {
        if (item.jobUuid !== this._view.job.uuid) {
          this._view.tabCost.grid.overseaCostDetails.splice(this._view.tabCost.grid.overseaCostDetails.indexOf(item), 1)
        }
      })
      ;[...this._view.tabSelling.grid.overseaSellingDetails].forEach((item, index) => {
        if (item.jobUuid !== this._view.job.uuid) {
          this._view.tabSelling.grid.overseaSellingDetails.splice(this._view.tabSelling.grid.overseaSellingDetails.indexOf(item), 1)
        }
      })
      ;[...this._view.jobControlledCharges].forEach((item, index) => {
        if (item.jobUuid !== this._view.job.uuid) {
          this._view.jobControlledCharges.splice(this._view.jobControlledCharges.indexOf(item), 1)
        }
      })
    }
    LocalStorageUtilsNew.setConfiguration(this.cachePrefix + 'showLCLCharges', this._view.checkbox.chkLcLCharge.selected)
    this.refDgChargeInfo()
    this._view.updateReceiptsRate()
  }

  /**
   * 显示红冲费用
   */
  chkOffsetChargeHandler(event = null) {
    const { overseaCostDetails } = this._view.tabCost.grid
    const { overseaSellingDetails } = this._view.tabSelling.grid
    const { jobControlledCharges } = this._view
    for (const charge of this._view.job.charges) {
      if (RateUtil.useOrderCenterMode() && charge.branchId !== this._view.currentSettleBranchId && this._view.settleBranchId > 0) {
        continue
      }
      if (charge.offsetState > 0) {
        if (this._view.checkbox.chkOffset.selected) {
          if (charge.receivable) {
            const index = overseaCostDetails.indexOf(charge)
            if (index === -1) {
              overseaCostDetails.push(charge)
            }
          } else {
            const index = overseaSellingDetails.indexOf(charge)
            if (index === -1) {
              overseaSellingDetails.push(charge)
            }
          }
          if (jobControlledCharges) {
            const index = jobControlledCharges.indexOf(charge)
            if (index === -1) {
              jobControlledCharges.push(charge)
            }
          }
        } else {
          if (charge.receivable) {
            const index = overseaCostDetails.indexOf(charge)
            if (index > -1) {
              overseaCostDetails.splice(index, 1)
            }
          } else {
            const index = overseaSellingDetails.indexOf(charge)
            if (index > -1) {
              overseaSellingDetails.splice(index, 1)
            }
          }
          if (jobControlledCharges) {
            const index = jobControlledCharges.indexOf(charge)
            if (index > -1) {
              jobControlledCharges.splice(index, 1)
            }
          }
        }
      }
    }
    this.refDgChargeInfo()
    LocalStorageUtilsNew.setConfiguration(this.cachePrefix + 'showRedCharges', this._view.checkbox.chkOffset.selected)
  }

  /**
   * 显示更改费用
   */
  chkShowChangeChargeHandler(event = null) {
    LocalStorageUtils.setConfiguration(this.cachePrefix + 'showChangeCharge', this._view.checkbox.chkShowChangeCharge.selected)
    this.showChangeChargeHandler()
  }

  showChangeChargeHandler(event = null) {
    const { overseaCostDetails } = this._view.tabCost.grid
    const { overseaSellingDetails } = this._view.tabSelling.grid
    const { jobControlledCharges } = this._view
    for (const charge of this._view.job.charges) {
      if (RateUtil.useOrderCenterMode() && charge.branchId !== this._view.currentSettleBranchId && this._view.settleBranchId > 0) {
        continue
      }
      // CARGO-33286 13855兰高：没有受控权限可以查看受控费用
      const controlled = charge.controlled && ((charge.receivable && !this._view.privilege.isCostControlled) || (!charge.receivable && !this._view.privilege.isControlled))
      if (controlled) {
        continue
      }
      if (this._view.chargeChangeStateMap && this._view.chargeChangeStateMap.hasOwnProperty(charge.uuid)) {
        if (this._view.checkbox.chkShowChangeCharge.selected) {
          if (charge.receivable) {
            const index = overseaCostDetails.indexOf(charge)
            if (index === -1) {
              overseaCostDetails.push(charge)
            }
          } else {
            const index = overseaSellingDetails.indexOf(charge)
            if (index === -1) {
              overseaSellingDetails.push(charge)
            }
          }
          if (jobControlledCharges) {
            const index = jobControlledCharges.indexOf(charge)
            if (index === -1) {
              jobControlledCharges.push(charge)
            }
          }
        } else {
          if (charge.receivable) {
            const index = overseaCostDetails.indexOf(charge)
            if (index > -1) {
              overseaCostDetails.splice(index, 1)
            }
          } else {
            const index = overseaSellingDetails.indexOf(charge)
            if (index > -1) {
              overseaSellingDetails.splice(index, 1)
            }
          }
          if (jobControlledCharges) {
            const index = jobControlledCharges.indexOf(charge)
            if (index > -1) {
              jobControlledCharges.splice(index, 1)
            }
          }
        }
      }
    }
    this.refDgChargeInfo()
  }
  //
  /**
   * 显示普通/特殊费用
   */
  chkShowCommonChargeHandler(event) {
    if (!this._view.privilege.enableCommission && !this._view.config.toExoSystemHC) return // 启用佣金
    // 注意，与 loadForBookingResultHandler 加载后的处理，必须一致
    this._view.needLoadDeptUser = false
    this._view.tabCost.grid.overseaCostDetails = []
    this._view.tabSelling.grid.overseaSellingDetails = []
    this._view.jobControlledCharges = []
    // overseaCostDetails.disableAutoUpdate();
    // overseaSellingDetails.disableAutoUpdate();
    // jobControlledCharges.disableAutoUpdate();
    if (this._view.privilege.queryArAllRole || this._view.privilege.queryApAllRole) {
      this.extractCharges(this._view.job)
      this.showLclCharge()
      this.sortCharges()
      this.refDgChargeInfo()
      // dispatchEvent(new Event("chargeCostAdjustEvent"));
    } else if (this._view.privilege.queryArDeptChargeRole || this._view.privilege.queryApDeptChargeRole) {
      this._view.needLoadDeptUser = true
      this.getUserDepartmentTeam()
    } else {
      this.extractCurrentUserCharge(this._view.job)
      this.extractCurrentUserLCLCharge()
      this.sortCharges()
      this.refDgChargeInfo()
      // dispatchEvent(new Event("chargeCostAdjustEvent"));
    }
    if (!this._view.needLoadDeptUser) {
      this.getUserDepartmentTeam()
    }
    // 按钮触发
    if (event != null) {
      LocalStorageUtils.setConfiguration(this.cachePrefix + 'showCommonCharge', this._view.checkbox.chkShowCommonCharge.selected)
      LocalStorageUtils.setConfiguration(this.cachePrefix + 'showSpecialCharge', this._view.checkbox.chkShowCommonCharge.selected)
      LocalStorageUtils.setConfiguration(this.cachePrefix + 'showBusinessSpecialCharge', this._view.checkbox.chkShowBusinessSpecialCharge.selected)
    }
  }

  //
  //   private const _queryFCLWin:PriceFclPopup;
  //   private const _queryLCLWin:PriceLclPopup;
  //   private const _priceAirPopup:PriceAirPopup;
  //
  onPrice() {
    this.showQuotationWin()
  }

  //
  showQuotationWin() {
    const job = this._view.job
    if (job instanceof SeaExportJob) {
      const containerLoadType = job.containerLoadType
      if (containerLoadType === 'FCL' || containerLoadType === 'BCF' || (containerLoadType === 'LCL' && job.masterFlag)) {
        this._view.addPriceDialog.visible = true
      } else if (containerLoadType === 'LCL') {
        this._view.lclPriceDialog.visible = true
      }
    }
    // todo 运价表空运 待开发
    /* else if (job is AirExportJob) {
        if (_priceAirPopup === null) {
          _priceAirPopup = new PriceAirPopup();
          _priceAirPopup.addEventListener("select", priceAirPopupSelectEvent);
        }
        _priceAirPopup.job = job;
        PopUpUtils.addPopUp(_priceAirPopup, this, true);
      }*/
  }

  //
  //   /**
  //    * 生成空运运价费用
  //    */
  priceAirPopupSelectEvent(e) {
    //     const items = _priceAirPopup.selectedItems;
    //     if (items.length > 0) {
    //       //查询成本
    //       const priceNos = new ArrayCollection();
    //       for each(const p:PriceAir in items) {
    //         if (p.priceNo != null) {
    //           priceNos.addItem(p.priceNo);
    //         }
    //       }
    //       PriceAir.queryByPriceNos(priceNos, queryByPriceNosHandler, failureHandler);
    //     }
  }

  //
  //   /**
  //    * 生成费用
  //    */
  queryByPriceNosHandler(e = null) {
    //     const items = _priceAirPopup.selectedItems;
    //     if (e != null && e.result != null) {
    //       const result = e.result as ArrayCollection;
    //       for each(const p:PriceAir in result) {
    //         if (p.level === 0) {
    //           items.addItem(p);
    //         }
    //       }
    //     }
    //     const charges:IList = PriceAirUtils.generatingCharge(items, job);
    //     const compKeys:IList = new ArrayCollection();
    //     for each(const charge in charges) {
    //       if (parseInt(Config.configMap["canChangeOverseaOfCharge"]) === 2) {
    //         charge.oversea = false;
    //       }else if(parseInt(Config.configMap["canChangeOverseaOfCharge"]) === 3){
    //         charge.oversea = true;
    //       }
    //       // 当前结算对象
    //       charge.invoiceTitle = ColumnUtils.getInstance().getCompanyName(charge.accountId);
    //       compKeys.addItem(charge.accountId);
    //       if (charge.receivable) {
    //         overseaCostDetails.addItem(charge);
    //       } else {
    //         overseaSellingDetails.addItem(charge);
    //       }
    //     }
    //     refreshGrid();
    //     // CARGO-1129 费用页签-通过运价生成费用
    //     Title.queryDefaultTitlesByCompanyIds2(compKeys,queryJobInvoiceTitleHandler,queryJobInvoiceTitlefailureHandler);
  }

  queryJobInvoiceTitleHandler(e = null) {
    //     const titleMap = e.result as Object;
    //     for each(const c in job.charges) {
    //       if (titleMap && titleMap.hasOwnProperty(String(c.accountId))) {
    //         // 新增
    //         if (c.isNewInstance() && c.accountId > 0) {
    //           if (titleMap[String(c.accountId)] != null)
    //             c.invoiceTitle = titleMap[String(c.accountId)];
    //         }
    //       }
    //     }
    //     refreshGrid();
  }

  //
  queryJobInvoiceTitlefailureHandler(e = null) {
    //
  }

  //
  win_closeHandler(e) {
    //     e.target.visible = false;
  }

  //
  //   private const priceApply = null;
  //
  //   /**
  //    * 特价申请
  //    */
  convertPrice2ChargeFromApply(priceApply) {
    //     this.priceApply = priceApply;
    //     if (job.priceNo) {
    //       const proxy = {};
    //       proxy.priceNo = job.priceNo;
    //       if (Price.getPriceType(job.priceNo) === 0) {
    //         PriceFcl.queryByPriceNo(proxy,
    //           function (event) {
    //             const arr = event.result as ArrayCollection;
    //             if (arr && arr.length > 0) {
    //               pf = arr[0] as PriceFcl;
    //               loadFclSurcharges(true);
    //             }
    //           },
    //           function (event) {
    //             MessageDialog.showFault(event);
    //           });
    //       }
    //     }
  }

  //
  //   /**
  //    * 运价订舱生成费用
  //    */
  convertPrice2Charge() {
    //     const proxy = {};
    //     proxy.priceNo = job.priceNo;
    //     if (!StrUtils.isEmpty(job.priceNo) && Price.getPriceType(job.priceNo) === 0) {
    //       PriceFcl.queryByPriceNo(proxy,
    //         function (event) {
    //           const arr = event.result as ArrayCollection;
    //           if (arr && arr.length > 0) {
    //             pf = arr[0] as PriceFcl;
    //             loadPriceFclSurcharge();
    //           } else {
    //             dispatchEvent(new Event("priceConvertComplete"));
    //           }
    //         },
    //         function (event) {
    //           MessageDialog.showFault(event);
    //         });
    //     } else if (!StrUtils.isEmpty(job.priceNo) && Price.getPriceType(job.priceNo) === 2) {
    //       PriceLcl.queryByPriceNo(proxy,
    //         function (event) {
    //           const arr = event.result as ArrayCollection;
    //           if (arr && arr.length > 0) {
    //             pl = arr[0] as PriceLcl;
    //             loadPodCharges();
    //           } else {
    //             dispatchEvent(new Event("priceConvertComplete"));
    //           }
    //         },
    //         function (event) {
    //           MessageDialog.showFault(event);
    //         });
    //     } else {
    //       dispatchEvent(new Event("priceConvertComplete"));
    //     }
  }

  //
  //   /**
  //    * @private
  //    */
  loadPriceFclSurcharge() {
    const job = this._view.job
    const pf = this.pf
    const proxy = {}
    proxy.pol = pf.pol
    proxy.pod = pf.pod
    proxy.via = pf.via
    const region = resolveSpecificField2Value(TYPE_NAMES.basic_data_Seaport, 'code', pf.pod, 'region')
    if (region) {
      proxy.rod = region
    }
    if (pf && job && job.lob === 'SE' && pf.freeTime === 0) {
      job.freeTime = pf.freeTime
    }
    job.priceNo = pf.priceNo
    proxy.carriers = pf.carrier
    proxy.bookingAgents = pf.bookingAgent
    proxy.eqType = pf.eqType
    proxy.beginDate = pf.beginDate
    proxy.endDate = pf.endDate
    queryEffectiveSurchargeFCL(proxy).then(res => {
      this.loadPriceFclSurchargeHandler(res.data)
    })
  }

  //
  async loadPriceFclSurchargeHandler(event) {
    const job = this._view.job
    const overseaCostDetails = this._view.tabCost.grid.overseaCostDetails
    const overseaSellingDetails = this._view.tabSelling.grid.overseaSellingDetails

    let lengthCost = overseaCostDetails.length // 已有应收费用记录数
    let lengthSelling = overseaSellingDetails.length // 已有应付费用记录数

    const source = event
    const charges = await PriceFcl2JobChargeUtil.convertPriceChargeToEqType(job, this.pf, source)
    const compKeys = []
    for (const charge of charges) {
      if (parseInt(this.cacheConfig.get('canChangeOverseaOfCharge')) === 2) {
        charge.oversea = false
      } else if (parseInt(this.cacheConfig.get('canChangeOverseaOfCharge')) === 3) {
        charge.oversea = true
      }
      if (this._view.config.accountObjectControlMode) {
        if (charge.receivable) {
          charge.accountId = job.customerId
        }
      }
      // 当前结算对象
      charge.invoiceTitle = await Company.getCompanyName(charge.accountId)
      if (charge.accountId && charge.accountId > 0) {
        await this.getSettlementByCompanyId(charge)
      }
      compKeys.push(charge.accountId)
      if (charge.receivable) {
        if (!this._view.lockAr) {
          lengthCost += 1
          charge.serialNumber = lengthCost
          overseaCostDetails.push(charge)
        }
      } else {
        if (!this._view.lockAp) {
          lengthSelling += 1
          charge.serialNumber = lengthSelling
          overseaSellingDetails.push(charge)
        }
      }
    }
    // // cargo 未实现此方法 dispatchEvent(new Event('priceConvertComplete'))
    this.refreshGrid()
    // CARGO-1129 费用页签-通过运价生成费用(合作伙伴维护的默认发票抬头)
    if (compKeys.length > 0) {
      getTitleByCmpIdxList(compKeys).then(res => {
        this.queryInvoiceTitleHandler(res.data)
      })
    }
  }

  queryInvoiceTitleHandler(e = null) {
    const job = this._view.job
    const titleMap = e

    for (const c of job.charges) {
      if (titleMap && titleMap.hasOwnProperty(String(c.accountId))) {
        // 新增
        if (StrUtils.isEmpty(c.uuid) && c.accountId > 0) {
          if (titleMap[String(c.accountId)] !== null) {
            c.invoiceTitle = titleMap[String(c.accountId)]
          }
        }
      }
    }
    // cargo 未实现此方法 dispatchEvent(new Event("priceConvertComplete"));
    this.refreshGrid()
  }

  queryInvoiceTitlefailureHandler(e = null) {
    //
  }

  //
  //   private const pf:PriceFcl;
  //   private const pl:PriceLcl;
  //
  onFCLSelected(event) {
    this.pf = event
    if (this.pf) {
      this.loadPriceFclSurcharge()
    }
  }

  //
  loadFclSurcharges(isApply = false) {
    //     const proxy = {};
    //     proxy.pol = pf.pol;
    //     proxy.pod = pf.pod;
    //     proxy.via = pf.via;
    //     const pt:Seaport = Seaport.getSeaport(pf.pod);
    //     if (pt && pt.region) {
    //       proxy.rod = pt.region;
    //     }
    //     proxy.carriers = pf.carrier;
    //     proxy.bookingAgents = pf.bookingAgent;
    //     proxy.eqType = pf.eqType;
    //     proxy.beginDate = pf.beginDate;
    //     proxy.endDate = pf.endDate;
    //     if (isApply) {
    //       SurchargeFCL.queryEffectiveSurchargeFCL(proxy, onSurchargeLoaded2, onSurchargeLoadFailed);
    //     } else {
    //       SurchargeFCL.queryEffectiveSurchargeFCL(proxy, onSurchargeLoaded, onSurchargeLoadFailed);
    //     }
    //     if (pf && job && job is SeaExportJob) {
    //       if (SeaExportJob(job).freeTime === 0) {
    //         SeaExportJob(job).freeTime = pf.freeTime;
    //       }
    //       if (StrUtils.isEmpty(SeaExportJob(job).vesselLineCode)) {
    //         SeaExportJob(job).vesselLineCode = pf.lane;
    //       }
    //     }
  }

  //
  onLCLSelected(event) {
    this.pl = event
    if (this.pl) {
      this.loadPodCharges()
    }
  }

  //
  loadPodCharges() {
    const pl = this.pl
    const proxy = {}
    proxy.pol = pl.pol
    proxy.pod = pl.pod
    proxy.bookingAgent = pl.bookingAgent
    proxy.beginDate = pl.beginDate
    proxy.endDate = pl.endDate
    this._view.job.priceNo = pl.priceNo
    queryEffectivePodCharge(proxy).then(res => {
      this.onPodChargeLoaded(res.data)
    })
  }

  async onPodChargeLoaded(event) {
    const job = this._view.job
    const source = event
    const isColoader = this.pl.chkColoader
    const costArr = []
    const sellArr = []
    let charges = await PriceLcl2JobChargeUtil.convertPrice2SellCharge(this._view.job, this.pl, source, isColoader)
    const compKeys = []
    const chargesNew = []
    for (const charge of charges) {
      if (charge.unitRate !== 0 && charge.unitRate !== Infinity && charge.unitRate !== PriceConstant.NIL) {
        chargesNew.push(charge)
      }
    }
    charges = chargesNew
    for (const charge of charges) {
      if (parseInt(this.cacheConfig.get('canChangeOverseaOfCharge')) === 2) {
        charge.oversea = false
      } else if (parseInt(this.cacheConfig.get('canChangeOverseaOfCharge')) === 3) {
        charge.oversea = true
      }
      if (this._view.config.accountObjectControlMode) {
        if (charge.receivable && charge.unitRate >= 0) {
          charge.accountId = job.customerId
        }
      }
      // 当前结算对象
      charge.invoiceTitle = await Company.getCompanyName(charge.accountId)
      if (charge.accountId && charge.accountId > 0) {
        await this.getSettlementByCompanyId(charge)
      }
      compKeys.push(charge.accountId)
      if (charge.unitRate < 0) {
        charge.receivable = false
        charge.unitRate = Math.abs(charge.unitRate)
        charge.amount = Math.abs(charge.amount)
        charge.taxAmount = Math.abs(charge.taxAmount)
        charge.excludingTaxAmount = Math.abs(charge.excludingTaxAmount)
        // CARGO-16424 如果锁定了应付费用，则不能生成新的应付费用
        if (!this._view.lockAp) {
          sellArr.push(charge)
        }
      } else {
        // CARGO-16424 如果锁定了应收费用，则不能生成新的应收费用
        if (!this._view.lockAr) {
          costArr.push(charge)
        }
      }
    }

    this._view.tabCost.grid.overseaCostDetails = costArr
    this._view.tabSelling.grid.overseaSellingDetails = sellArr

    job.charges = charges
    job.priceNo = this.pl.priceNo
    this._view.jobControlledCharges = charges
    this.refDgChargeInfo()
    // cargo 未实现此方法 dispatchEvent(new Event("priceConvertComplete"));
    // CARGO-1129 费用页签-通过运价生成费用
    getTitleByCmpIdxList(compKeys).then(res => {
      this.queryPodInvoiceTitleHandler(res.data)
    })
  }

  queryPodInvoiceTitleHandler(e) {
    const titleMap = e
    for (const c of this._view.job.charges) {
      if (titleMap && titleMap.hasOwnProperty(String(c.accountId))) {
        // 新增
        if (StrUtils.isEmpty(c.uuid) && c.accountId > 0) {
          if (titleMap[String(c.accountId)] !== null) {
            c.invoiceTitle = titleMap[String(c.accountId)]
          }
        }
      }
    }
    this.refDgChargeInfo()
    // cargo 未实现此方法 dispatchEvent(new Event("priceConvertComplete"))
  }

  //
  queryPodInvoiceTitlefailureHandler(e) {
    //
  }

  //
  onSurchargeLoaded(event) {
    //     const source = event.result as ArrayCollection;
    //     const tier = _queryFCLWin === null ? (job.priceTier > 0 ? job.priceTier : 1) : _queryFCLWin.targetLevel;
    //     const qf:QuotationFCLDetail = pf.createQuotationFclDetail(tier);
    //     convertSurcharge2Charge(qf, source);
  }

  //
  onSurchargeLoaded2(event) {
    //     const source = event.result as ArrayCollection;
    //     const tier = _queryFCLWin === null ? (job.priceTier > 0 ? job.priceTier : 1) : _queryFCLWin.targetLevel;
    //     const qf:QuotationFCLDetail = pf.createQuotationFclDetail(tier);
    //     qf.eq20 = priceApply.new20 === PriceConstant.NIL ? "" : String(priceApply.new20);
    //     qf.eq40 = priceApply.new40 === PriceConstant.NIL ? "" : String(priceApply.new40);
    //     qf.eqHC = priceApply.newHC === PriceConstant.NIL ? "" : String(priceApply.newHC);
    //     qf.eq45 = priceApply.new45 === PriceConstant.NIL ? "" : String(priceApply.new45);
    //     convertSurcharge2Charge(qf, source);
  }

  //
  convertSurcharge2Charge(qf, source) {
    //     qf.cost20 = pf.cost20 === PriceConstant.NIL ? "" : String(pf.cost20);
    //     qf.cost40 = pf.cost40 === PriceConstant.NIL ? "" : String(pf.cost40);
    //     qf.costHC = pf.costHC === PriceConstant.NIL ? "" : String(pf.costHC);
    //     qf.cost45 = pf.cost45 === PriceConstant.NIL ? "" : String(pf.cost45);
    //
    //     source = PriceFcl2JobChargeUtil.getUnconflictSurcharges(job, source);
    //
    //     const isAllIN = _queryFCLWin === null ? true : _queryFCLWin.chkAllIn.selected;
    //     const isTEU = _queryFCLWin === null ? false : _queryFCLWin.chkTEU.selected;
    //     overseaCostDetails = PriceFcl2JobChargeUtil.convertPrice2SellCharge(job, qf, source, isAllIN, isTEU);
    //     overseaSellingDetails = PriceFcl2JobChargeUtil.convertPrice2CostCharge(job, qf, source, isAllIN, isTEU);
    //
    //     const charges = new ArrayCollection();
    //
    //     const i = 0;
    //     const charge;
    //     if (overseaSellingDetails) {
    //       for (i = overseaSellingDetails.length - 1; i >= 0; i--) {
    //         charge = overseaSellingDetails[i];
    //         if (charge.unitRate < 0) {
    //           charge.unitRate = Math.abs(charge.unitRate);
    //           charge.taxAmount = Math.abs(charge.taxAmount);
    //           charge.amount = Math.abs(charge.amount);
    //           charge.excludingTaxAmount = Math.abs(charge.excludingTaxAmount);
    //           charge.receivable = !charge.receivable;
    //           if (overseaCostDetails === null) {
    //             overseaCostDetails = new ArrayCollection();
    //           }
    //           overseaSellingDetails.removeItemAt(i);
    //           overseaCostDetails.addItem(charge);
    //         }
    //       }
    //     }
    //
    //     if (overseaCostDetails) {//负数金额自动反向带入对向的收付
    //       for (i = overseaCostDetails.length - 1; i >= 0; i--) {
    //         charge = overseaCostDetails[i];
    //         if (charge.unitRate < 0) {
    //           charge.unitRate = Math.abs(charge.unitRate);
    //           charge.taxAmount = Math.abs(charge.taxAmount);
    //           charge.amount = Math.abs(charge.amount);
    //           charge.excludingTaxAmount = Math.abs(charge.excludingTaxAmount);
    //           charge.taxAmount = Math.abs(charge.taxAmount);
    //           charge.receivable = !charge.receivable;
    //           if (overseaSellingDetails === null) {
    //             overseaSellingDetails = new ArrayCollection();
    //           }
    //           overseaCostDetails.removeItemAt(i);
    //           overseaSellingDetails.addItem(charge);
    //         }
    //       }
    //
    //     }
    //     if (overseaSellingDetails) {
    //       charges.addAll(overseaSellingDetails);
    //     }
    //
    //     if (overseaCostDetails) {
    //       charges.addAll(overseaCostDetails);
    //     }
    //     job.charges = charges;
    //     job.priceNo = pf.priceNo;
    //     jobControlledCharges = charges;
    //     refDgChargeInfo();
    //     this.dispatchEvent(new Event("priceConvertComplete"));
  }

  //
  onSurchargeLoadFailed(event) {
    //     FlexGlobals.topLevelApplication.status = resourceManager.getString('Pricing', 'ErrorRaised');
  }

  onPriceNoClick(text, event) {
    handleClipboard(text || '', event)
    // const lbl:spark.components.Label = event.currentTarget as spark.components.Label;
    // todo-shengsheng  Desc: 剪切
    // System.setClipboard(lbl.text);
  }

  onPriceNoDoubleClick(event) {
    if (this._view.job instanceof SeaExportJob) {
      this.$message.info(this._view.$t('Message.PleaseGoToTheFCLFreightInquiryModuleToCheckFreightDetails'))
    } else if (this._view.job instanceof AirExportJob) {
      this.$message.info(this._view.$t('Message.PleaseGoToTheAirFreightInquiryModuleToCheckFreightDetails'))
    }
  }

  /**
   * 刷新汇率
   */
  async refreshRateHandler() {
    if (!await SecurityUtil.canEdit(this._view.job, false)) {
      this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
      return
    }
    if (!this._view.job.charges || this._view.job.charges.length <= 0) {
      await new Job(this._view.job).getCharges()
    }
    if (!this._view.job.charges || this._view.job.charges.length <= 0) {
      return
    }
    this._view.loading = getLoading()
    updateChargeRatesByJob({ branchId: this.$store.getters.currentOfficeId, jobKey: this._view.job.uuid, location: this._view.location }).then(async res => {
      if (res.data && res.data.length > 0 && this._view.job.charges && this._view.job.charges.length > 0) {
        for (const row of this._view.job.charges) {
          for (const charge of res.data) {
            if (row.uuid && charge.uuid && row.uuid === charge.uuid) {
              row.exchangeRate = charge.exchangeRate
              row.hqCurrency = charge.hqCurrency
              row.hqRate = charge.hqRate
              break
            }
          }
        }
        this.refreshGrid()
        this._view.tabCost.grid.gridApi.refreshCells({ force: true }) // 刷新
        this._view.tabSelling.grid.gridApi.refreshCells({ force: true }) // 刷新
      }
      this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
    }).catch().finally(() => {
      this._view.loading.close()
    })
  }

  //
  //   /**
  //    * 应收费用过滤
  //    */
  costAccountDataFilterFunction(com) {
    //     if (!isInputChargeBaseOnService || !serviceTypeOnCostColumn.visible)
    //       return true;
    //     return ChargeUtils.getServiceAccountDataFilter(dgOverseaCost.selectedItem as Charge, com);
  }

  //
  //   /**
  //    * 应付费用过滤
  //    */
  sellingAccountDataFilterFunction(com) {
    //     if (!isInputChargeBaseOnService || !serviceTypeOnSellingColumn.visible)
    //       return true;
    //     return ChargeUtils.getServiceAccountDataFilter(dgOverseaSelling.selectedItem as Charge, com);
  }

  //
  checkedInvoiceTitle(data, column) {
    //     //				const cmpIdx = int(ColumnUtils.getData(data ,"accountId"));
    //     //				const cmpStr =  ColumnUtils.getInstance().getCompanyName(cmpIdx);
    //     //				if (data["invoiceTitle"] === null || data["invoiceTitle"] === "")
    //     //				{
    //     //					return cmpStr;
    //     //				}
    //     //				else
    //     //				{
    //     //					return data["invoiceTitle"];
    //     //				}
    //     return "";
  }

  //
  //
  //   /**
  //    * 开票日期
  //    */
  invoiceDateLabFun(item, column) {
    //     const charge = item as Charge;
    //     if (charge === null || charge.invoice === null) return "";
    //     return DateUtils.formatStandardDate(charge.invoice.invoiceDate);
  }

  //
  //   /**
  //    * 发票号
  //    */
  invoiceNoLabFun(item, column) {
    //     return item.invoice === null ? "" : item.invoice.invoiceNo;
  }

  //
  //   /**
  //    * 刷新表格
  //    */
  refreshGrid() {
    // vue双向数据绑定，不执行表格刷新
    // dgOverseaCost.invalidateList()
    // dgOverseaCost.validateNow()
    // dgOverseaSelling.invalidateList()
    // dgOverseaSelling.validateNow()
    this.refDgChargeInfo()
  }

  /**
   * 抄录小票成本
   */
  copySlaveCostHandler() {
    this._view.copySlaveCostDialog.params = this._view.job
    this._view.copySlaveCostDialog.visible = true
    // if (copySlaveCostWindow === null) {
    //   copySlaveCostWindow = new CopySlaveChargeWindow();
    //   copySlaveCostWindow.addEventListener("success", copySlaveCostSuccessHandler);
    // }
    // copySlaveCostWindow.job = job;
    // PopUpUtils.addPopUp(copySlaveCostWindow, this, true);
  }

  //
  //   /**
  //    * @private
  //    */
  copySlaveCostSuccessHandler(event) {
    //     loadForBookingResultHandler();
  }

  /**
   * 邀请确认费用弹出提示
   */
  confirmInviteCharge() {
    this.$confirm(this._view.$t('Message.DoYouNeedToInviteOthersToConfirmTheCharges'), this._view.$t('common.tips.prompt'), {
      confirmButtonText: this._view.$t('common.btn.ok'),
      cancelButtonText: this._view.$t('common.btn.cancel'),
      type: 'info'
    }).then(() => {
      this.inviteToConfirmCharge()
    }).catch(() => {
    })
  }

  /**
   * 邀请费用确认
   */
  inviteToConfirmCharge() {
    if (!this._view.job || !this._view.job.uuid) return
    inviteToConfirmCharge(this._view.job.uuid).then(res => {
      this.inviteToConfirmChargeHandler()
      if (res && !res.data) {
        this.$logger.log('操作失败：未维护相关SOP节点【CODE = CHARGE_CONFIRM】')
      }
    }).catch((err) => {
      this.failureHandler(err)
    })
    // Charge.inviteToConfirmCharge(job, new mx.rpc.Responder(inviteToConfirmChargeHandler, faultHandler));
  }

  inviteToConfirmChargeHandler() {
    this.$message.success(this._view.$t('Message.TheMailHasBeenSentPleaseNoteAndHaveACheck'))
    // MessageDialog.success(resourceManager.getString('Message', 'TheMailHasBeenSentPleaseNoteAndHaveACheck'));
    // if (e.result === true) {
    //   job.reload2(function (e2) {
    //   }, faultHandler);
    // }
  }

  /**
   * @private
   */
  faultHandler(evt) {
    //     MessageDialog.showFault(evt);
  }

  /**
   * 获取应收的选中项
   * modified by Deep Lau 2016-04-12
   * @private
   */
  getCostSelections() {
    const selections = getGridSelected(this._view.tabCost.grid.gridOptions)
    return selections
  }

  /**
   * 获取应付的选中项
   * modified by Deep Lau 2016-04-12
   * @private
   */
  getSellingSelections() {
    const selections = getGridSelected(this._view.tabSelling.grid.gridOptions)
    return selections
  }

  /**
   * 获取应付的选中项
   * @returns {[]}
   */
  getSellingMergeSelections() {
    const selections = getGridSelected(this._view.tabSellingMerge.grid.gridOptions)
    return selections
  }

  /**
   * 重新计算应收的选中项并刷新应收的合计
   * modified by Deep Lau 2016-04-12
   * @private
   */
  refreshCostSelected(arg, selections) {
    if (arg === 0) {
      this._view.arTotalGroup.dataProvider = selections
    } else if (arg === 1) {
      this._view.arTotalGroup.dataProvider = this.getArTotalCharges(selections)
    } else {
      this._view.arTotalGroup.dataProvider = this.getArTotalCharges(this._view.tabCost.grid.overseaCostDetails)
    }
  }

  //
  //   /**
  //    * 重新计算应付的选中项并刷新应付的合计
  //    * modified by Deep Lau 2016-04-12
  //    * @private
  //    */
  refreshSellingSelected(arg, selections) {
    if (arg === 0) {
      // 商务特殊费用不参与应付汇总统计
      this._view.apTotalGroup.dataProvider = (selections || []).filter(charge => !charge.businessSpecial)
    } else if (arg === 1) {
      this._view.apTotalGroup.dataProvider = this.getApTotalCharges(selections)
    } else {
      this._view.apTotalGroup.dataProvider = this.getApTotalCharges(this._view.tabSelling.grid.overseaSellingDetails)
    }
  }

  //
  //   /**
  //    * 调用应收重新计算的方法
  //    * modified by Deep Lau 2016-04-12
  //    * private
  //    */
  selectedCostChangeHandler(event) {
    //     refreshCostSelected();
    //     changeControllButton(true);
  }

  //
  //   /**
  //    * 调用应付重新计算的方法
  //    * modified by Deep Lau 2016-04-12
  //    * private
  //    */
  selectedSellingChangeHandler(event) {
    //     refreshSellingSelected();
    //     changeControllButton(false);
  }

  /**
   * isReceivable: true 应收   false 应付
   * 根据勾选的应收费用，改变按钮显示，若应收全部为受控费用，则isAllCostControlled为true，其他一律为false;
   */
  changeControllButton(isReceivable) {
    // 重置按钮状态，之前有可能变为了true
    if (isReceivable) {
      this._view.isAllCostControlled = false
    } else {
      this._view.isAllSellingControlled = false
    }
    // 勾选的数量
    let selectCount = 0
    // 受控费用的数量
    let controlledCount = 0
    const chargeSource = this.readSelectedRows(isReceivable, false)
    for (const select of chargeSource) {
      selectCount++
      if (select.controlled) {
        controlledCount++
      }
    }
    if (selectCount > 0 && selectCount === controlledCount) {
      if (isReceivable) {
        this._view.isAllCostControlled = true
      } else {
        this._view.isAllSellingControlled = true
      }
    }
  }

  //
  //   /**
  //    * @private
  //    */
  cbTitleChangeHandler(event) {
    //     //				if (cbTitle.selectedItem)
    //     //				{
    //     //					cbTitle.title = cbTitle.selectedItem is Title ? Title(cbTitle.selectedItem).title : cbTitle.textInput.text;
    //     //				}
  }

  /**
   * 获取需要审核（取消审核）的费用
   */
  getNeedfulAuditSelections(isAr, isAudit) {
    this._view.isAuditOpr = isAudit
    const selections = []
    let dgCharges = null
    if (isAr) {
      // 应收费用
      dgCharges = this.readSelectedRows(true, false)
    } else {
      // 应付费用
      dgCharges = this.readSelectedRows(false, false)
    }
    // 获取所需费用
    for (const select of dgCharges) {
      if (select.auditor === this.$store.getters.userInfo.userId) {
        if (isAudit && select.chargeState === ChargeConstants.STATE_COMMITED.code) {
          selections.push(select)
        } else if (!isAudit && select.chargeState === ChargeConstants.STATE_VERIFIED.code) {
          selections.push(select)
        }
      }
    }
    return selections
  }

  /**
   * 获取所给状态的费用
   * isAr: true-应收   false-应付
   */
  getSelectedPendingRejectedCharges(isAr, chargeState) {
    const selections = []
    let dgCharges
    if (isAr) {
      // 应收费用
      dgCharges = this.readSelectedRows(true, false)
    } else {
      // 应付费用
      dgCharges = this.readSelectedRows(false, false)
    }
    for (const select of dgCharges) {
      // console.log('select', select ,select.auditor, this.$store.getters.userInfo.userId)
      if (select.chargeState === chargeState && select.auditor === this.$store.getters.userInfo.userId) {
        selections.push(select)
      }
    }
    return selections
  }

  /**
   * 费用审核（取消审核）
   * isAr  true-应收   false-应付
   * isAudit  true-审核    false-取消审核
   */
  chargeAuditHandler(isAr, isAudit) {
    if (!isAudit) {
      // 财务归档生效判断
      const warnflag = ArchiveEffectUtils.checkArchiveEffect(this._view.job)
      if (warnflag) {
        this.$message.warning(this._view.$t('CargoMsg.NOT_OPERATIONAL'))
        return
      }
    }
    const needFulCharges = this.getNeedfulAuditSelections(isAr, isAudit)
    if (needFulCharges === null || needFulCharges.length === 0) {
      let msg = ''
      if (isAudit) {
        // this.$message.info(this._view.$t('Message.PayablesIsNull'))
        msg = this._view.$t('Message.NoChargesToAudit')
      } else {
        msg = this._view.$t('Message.NoChargesToUnAudit')
      }
      this.$message.error(msg)
      return
    }

    let billinged = false // 已生成账单
    let invoiced = false // 已开票
    let writeOff = false // 已核销
    for (const charge of needFulCharges) {
      if (charge['chargeState'] === ChargeConstants.STATE_VERIFIED.code) {
        if (charge.billingUuid) {
          billinged = true
        }
        if (charge.invoiceUuid) {
          invoiced = true
        }
        if (Number(charge.verifiedAmount) !== 0) {
          writeOff = true
        }
      }
    }

    const chargeIds = []
    const jobIds = []
    for (const c of needFulCharges) {
      // if (isAudit) {
      //   c.chargeState = ChargeConstants.STATE_VERIFIED.code
      // } else {
      //   c.chargeState = ChargeConstants.STATE_UNCOMMIT.code
      //   c.auditor = 0
      // }
      chargeIds.push(c.uuid)
    }

    const firstCharge = needFulCharges[0]
    jobIds.push(firstCharge.jobUuid)
    const params = { chargeIds, jobIds, isAudit, location: this._view.location, branchId: this.$store.getters.currentOfficeId }
    if (isAudit) {
      putAuditCharges(params).then(res => {
        this.chargeAuditEventHandler(res, needFulCharges)
        this.refreshAgGrid(isAr)
      }).catch(err => {
        this.failureHandler(err)
      })
    } else {
      const msg = this.cancelChargesAuditCheckMsg(billinged, invoiced, writeOff)
      this.$confirm(msg ? this.$t('CargoMsg.Cargo_SureToCancelReviewOfTheExpenseCheck', [msg]) + this.$t('CargoMsg.Cargo_SureToCancelVerification') : this.$t('CargoMsg.Cargo_SureToCancelReviewOfTheExpense', [chargeIds.length]), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        putAuditCharges(params).then(res => {
          this.chargeAuditEventHandler(res, needFulCharges)
          this.refreshAgGrid(isAr)
        }).catch(err => {
          this.failureHandler(err)
        })
      }).catch(() => {
      })
    }
  }

  // 取消费用审核提醒:已生成账单、已开票、已核销
  cancelChargesAuditCheckMsg(billinged = false, invoiced = false, writeOff = false) {
    let msg = ''
    if (billinged) {
      msg = '【' + this.$t('CargoMsg.Cargo_Billinged') + '】'
    }
    if (invoiced) {
      msg += (msg ? '、' : '') + '【' + this.$t('CargoMsg.Cargo_Invoiced') + '】'
    }
    if (writeOff) {
      msg += (msg ? '、' : '') + '【' + this.$t('CargoMsg.Cargo_WriteOffed') + '】'
    }
    return msg
  }

  chargeAuditEventHandler(res, needFulCharges) {
    const { chargeIds, syncYongYou } = res.data
    for (const c of needFulCharges) {
      if (!chargeIds.includes(c.uuid)) {
        continue
      }
      if (this._view.isAuditOpr) {
        c.chargeState = ChargeConstants.STATE_VERIFIED.code
      } else {
        c.chargeState = ChargeConstants.STATE_UNCOMMIT.code
        c.auditor = 0
      }
    }
    if (syncYongYou) {
      this.$message.warning(this._view.$t('queryJob.SyncYongYouNotCancelReview'))
    } else {
      if (this._view.isAuditOpr) {
        this.$message.success(this._view.$t('Message.AuditSuccessfully'))
      } else {
        this.$message.success(this._view.$t('Message.CancelSuccessfully'))
      }
    }
    this.refDgChargeInfo()
  }

  /**
   * 费用驳回
   * isAr  true-应收   false-应付
   */
  chargeRejectHandler(isAr) {
    const charges = this.getSelectedPendingRejectedCharges(isAr, ChargeConstants.STATE_COMMITED.code)
    if (!charges || charges.length === 0) {
      this.$message.info(this._view.$t('Message.NoChargesToReject'))
      return
    }
    const chargeIds = []
    for (const c of charges) {
      // c.chargeState = ChargeConstants.STATE_REJECT.code // 如果失败，则不能修改
      chargeIds.push(c.uuid)
    }
    rejectCharges(chargeIds, this._view.location).then(res => {
      this.$message.success(this._view.$t('Message.OperationSuccessfully'))
      // 同步修改状态
      for (const c of charges) {
        c.chargeState = ChargeConstants.STATE_REJECT.code
      }
      this.refDgChargeInfo()
      this.refreshAgGrid(isAr)
    }).catch(err => {
      this.failureHandler(err)
    })
  }

  //
  //   /**
  //    * 编辑状态下不要触发排序功能
  //    */
  headerReleaseHandler(event) {
    //     if (editing) {
    //       event.preventDefault();
    //       event.stopPropagation();
    //     }
  }

  // 更新费用抬头【多票费用】
  async refreshCopyedChargeTitle(charges = null) {
    const copyedChargeList = charges || this._view.copyedChargeList
    if (copyedChargeList != null && copyedChargeList.length > 0) {
      await ChargeUtils.updateDefaultInvoiceTitle(copyedChargeList)
    }
  }

  // 获取开票抬头【单票费用】
  async getInvoiceTitle(copyedCharge) {
    if (!copyedCharge) return
    await ChargeUtils.updateDefaultInvoiceTitle([copyedCharge])
  }

  /**
   * 新增改单费用
   */
  async addCostChange(editMode, isAr, adjust, isOffsetState) {
    let obj = null
    if (isAr) {
      obj = this._view.tabCost.grid.selectedRow
    } else {
      obj = this._view.tabSelling.grid.selectedRow
    }
    if (editMode === 'add') {
      // 财务归档生效判断
      const warnflag = ArchiveEffectUtils.checkArchiveEffect(this._view.job)
      if (warnflag) {
        this.$message.warning(this._view.$t('CargoMsg.NOT_OPERATIONAL'))
        return
      }
      this._view.changeChargeWindow.defaultProperties.title = this._view.$t('CargoMsg.Cargo_AddCharges')
      obj = new Charge().fillDefaultValue().getData()
      const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(this.getBranchIdForCharge())
      obj.localCurrency = localCurrency
      obj.currency = localCurrency
      obj.branchId = this._view.currentSettleBranchId
      obj.unitPriceIncludeTax = this._view.config.inputIncludingTaxUnitPrice === 2
    } else if (editMode === 'edit') {
      // 财务归档生效判断
      const warnflag = ArchiveEffectUtils.checkArchiveEffect(this._view.job)
      if (warnflag) {
        this.$message.warning(this._view.$t('CargoMsg.NOT_OPERATIONAL'))
        return
      }
      if (!obj) {
        this.$message.warning(this._view.$t('Message.PleaseSelectCharges'))
        return
      }
      if (!adjust && !this.checkAdjust(obj)) {
        this.$message.warning(this._view.$t('Message.TheChargesHaveBeenSettledByFinancialAccountAndCannotBeAmended'))
        return
      }
      if (!isOffsetState) {
        if (obj.offsetState !== 0) {
          this.$message.warning(this._view.$t('Message.RedChargeOrRedChargedCannotBeEditAdjustAgainPleaseSelectNewAdjustment'))
          return
        }
      }
      if (!adjust && this.hasGenerateVoucher(obj)) {
        const editModeMsg = this._view.$t('FinanceManage.charge_editAdjustment')
        this.$message.warning(this._view.$t('Message.ApplyChangeChargeNotThrough', [this._view.$t('CargoMsg.Cargo_CreateVoucher'), editModeMsg]))
        return
      }
      const modifyFlag = await checkChargeByAdjust(obj.uuid).then(res => res.data).catch((err) => {
      })
      if (!modifyFlag) {
        this.$message.warning(this._view.$t('Message.PleaseRefresh'))
        return
      }
      this._view.changeChargeWindow.defaultProperties.title = this._view.$t('SeaExport.EditCharges')
    }
    this._view.changeChargeWindow.defaultProperties.editMode = editMode
    if (this._view.viewSource === 'salesDetail') {
      this._view.changeChargeWindow.defaultProperties.salesDetail = true
      this._view.changeChargeWindow.defaultProperties.title = isAr ? this._view.$t('Message.EditCostCharge') : this._view.$t('Message.EditPayCharge')
      // CARGO-51765，隐藏结算对象的应收费用 不允许销售修改结算对象
      this._view.changeChargeWindow.customerSalesDisplayStar = false
      if (isAr && editMode === 'edit' && this._view.customerSalesDisplay && this._view.customerSalesCmpList && this.checkCustomerSalesDisplayStar(obj.accountId)) {
        this._view.changeChargeWindow.customerSalesDisplayStar = true
      }
    }
    this._view.changeChargeWindow.defaultProperties.isAdjust = true
    this._view.changeChargeWindow.defaultProperties.isAr = isAr
    this._view.changeChargeWindow.defaultProperties.companyFactorySigns = []
    if (isAr && this._view.config.arSettlementUnitOptional) {
      this._view.changeChargeWindow.defaultProperties.companyFactorySigns = this._view.companyFactorySigns
    }
    this._view.changeChargeWindow.defaultProperties.job = this._view.job
    this._view.changeChargeWindow.defaultProperties.charge = obj
    this._view.changeChargeWindow.applyChangeCharge = false
    this._view.changeChargeWindow.visible = true
  }

  /**
   * 申请更改费用
   *
   */
  applyChangeCharge(editMode, isAr) {
    getApprovingChangeChargeUuid({ jobUuid: this._view.job.uuid }).then(res => {
      if (res.data) {
        this.onViewChargeRequest(res.data)
      } else {
        if (this._view.batchAmendmentFee) {
          const oldJob = lodash.cloneDeep(this._view.job)
          const params = {
            settleBranchId: this._view.settleBranchId
          }
          this._view.changeChargeWorkFlowDialog.job = oldJob
          this._view.changeChargeWorkFlowDialog.params = params
          this._view.changeChargeWorkFlowDialog.privilege = this._view.privilege
          this._view.changeChargeWorkFlowDialog.officeList = this._view.officeList
          const costCharges = []
          const sellingCharges = []
          if (oldJob.charges) {
            const oldCharges = [...oldJob.charges]
            for (const charge of oldCharges) {
              if (!this.isRowEdit(charge, true)) {
                continue
              }
              // CARGO-42847 只能操作当前分公司的费用，无法操作协作分公司的费用
              if (this._view.currentSettleBranchId !== charge.branchId) {
                continue
              }
              // 增加受控权限控制
              const controlled = charge.controlled && ((charge.receivable && !this._view.privilege.isCostControlled) || (!charge.receivable && !this._view.privilege.isControlled))
              if (controlled) {
                continue
              }
              // 去掉 红冲、被红冲
              if (OFFSET_STATE_HEDGE.code === charge.offsetState || OFFSET_STATE_BE_HEDGE.code === charge.offsetState) {
                continue
              }
              if (charge.receivable) {
                costCharges.push(charge)
              } else {
                sellingCharges.push(charge)
              }
            }
          }
          this._view.$refs.ccwDialog.onShow(oldJob, costCharges, sellingCharges)
          this._view.changeChargeWorkFlowDialog.visible = true
        } else {
          const rows = this.getAllSelectedRows(false)
          // 财务归档生效判断
          const warnflag = ArchiveEffectUtils.checkArchiveEffect(this._view.job)
          if (warnflag) {
            this.$message.warning(this._view.$t('CargoMsg.NOT_OPERATIONAL'))
            return
          }
          if (editMode !== 'add') {
            if (!rows || rows.length === 0) {
              this.$message.warning(this._view.$t('Message.PleaseSelectCharges'))
              return
            }
            const msg = {}
            for (const data of rows) {
              if (data.billingUuid) {
                msg[this._view.$t('CargoMsg.Cargo_CreateBill')] = true
              }
              if (data.verifiedAmount !== 0) {
                msg[this._view.$t('CargoMsg.Cargo_Verification')] = true
              }
              const changeChargeState = this._view.chargeChangeStateMap ? this._view.chargeChangeStateMap[data.uuid] : ''
              if (changeChargeState && !(changeChargeState === ChangeChargeConstant.CHANGE_CHARGE_APPROVED.code ||
                  changeChargeState === ChangeChargeConstant.CHANGE_CHARGE_REJECTED.code ||
                  changeChargeState === ChangeChargeConstant.CHANGE_CHARGE_REVOKED.code ||
                  changeChargeState === ChangeChargeConstant.CHANGE_CHARGE_UN_APPROVED.code ||
                  changeChargeState === ChangeChargeConstant.CHANGE_CHARGE_AWAIT_DONE.code ||
                  changeChargeState === ChangeChargeConstant.CHANGE_CHARGE_AWAIT_BACK_OUT.code)) { // 更改费用申请状态是否在审核中,不包括已生效、已拒绝、已撤销申请
                msg[this._view.$t('CargoMsg.Cargo_InChangeExpenseReview')] = true
              }
              /* if (data.adjustment) {
                msg[this._view.$t('CargoMsg.Cargo_Adjustment')] = true
              } */
              if (data.offsetState === 1) { // 红冲
                msg[this._view.$t('CargoMsg.Cargo_WriteBack')] = true
              }
              if (data.offsetState === 2) { // 被红冲
                msg[this._view.$t('CargoMsg.Cargo_BeWriteBack')] = true
              }
              if (data.invoiceUuid) {
                msg[this._view.$t('CargoMsg.Cargo_Invoicing')] = true
              }
              if (data.billingPaymentUuid) {
                msg[this._view.$t('CargoMsg.Cargo_PaymentRequest')] = true
              }
              if (data.confirmBillUuid) {
                msg[this._view.$t('CargoMsg.Cargo_ConfirmExpenses')] = true
              }
              if (this.hasGenerateVoucher(data)) {
                msg[this._view.$t('CargoMsg.Cargo_CreateVoucher')] = true
              }
            }
            if (JSON.stringify(msg) !== '{}') {
              const message = []
              for (const key in msg) {
                message.push(key)
              }
              const editModeMsg = editMode !== 'del' ? this._view.$t('ChangeCharge.applyChangeCharge') : this._view.$t('ChangeCharge.applyDeleteCharge')
              this.$message.warning(this._view.$t('Message.ApplyChangeChargeNotThrough', [message.join(','), editModeMsg]))
              return
            }
          }
          this._view.changeChargeDialog.defaultProperties.editMode = editMode
          this._view.changeChargeDialog.defaultProperties.isAdjust = true
          this._view.changeChargeDialog.defaultProperties.isAr = isAr
          this._view.changeChargeDialog.defaultProperties.job = this._view.job
          this._view.changeChargeDialog.defaultProperties.charge = rows
          this._view.changeChargeDialog.defaultProperties.companyFactorySigns = []
          if (isAr && this._view.config.arSettlementUnitOptional) {
            this._view.changeChargeDialog.defaultProperties.companyFactorySigns = this._view.companyFactorySigns
          }
          this._view.changeChargeDialog.applyChangeCharge = true
          this._view.changeChargeDialog.visible = true
        }
      }
    })
  }

  // 更改前后对比
  onViewChargeRequest(changeChargeUuid) {
    if (StrUtils.isEmpty(changeChargeUuid)) return
    const requestBody = { changeChargeKey: changeChargeUuid, branchId: this.$store.getters.currentOfficeId }
    this.loading = getLoading()
    getChangeChargeBpm(requestBody).then(res => {
      const changeCharge = res.data
      this._view.beforeAndAfterComparisonDialogBpm.arChargeBefore = []
      this._view.beforeAndAfterComparisonDialogBpm.apChargeBefore = []
      const originalChargeUuidArMap = new Map()
      const originalChargeUuidApMap = new Map()
      if (changeCharge.chargeOriginals) {
        for (const data of changeCharge.chargeOriginals) {
          if (data.receivable) {
            if (data.uuid && !originalChargeUuidArMap[data.uuid]) {
              originalChargeUuidArMap.set(data.uuid, originalChargeUuidArMap.size + 1)
              data.originalSerialNo = originalChargeUuidArMap.get(data.uuid)
            }
            this._view.beforeAndAfterComparisonDialogBpm.arChargeBefore.push(data)
          } else {
            if (data.uuid && !originalChargeUuidApMap[data.uuid]) {
              originalChargeUuidApMap.set(data.uuid, originalChargeUuidApMap.size + 1)
              data.originalSerialNo = originalChargeUuidApMap.get(data.uuid)
            }
            this._view.beforeAndAfterComparisonDialogBpm.apChargeBefore.push(data)
          }
        }
      }
      this._view.beforeAndAfterComparisonDialogBpm.arChargeAfter = []
      this._view.beforeAndAfterComparisonDialogBpm.apChargeAfter = []
      if (changeCharge.chargeChanges) {
        for (const data of changeCharge.chargeChanges) {
          if (data.receivable) {
            data.originalSerialNo = originalChargeUuidArMap.get(data.originalChargeUuid)
            this._view.beforeAndAfterComparisonDialogBpm.arChargeAfter.push(data)
          } else {
            data.originalSerialNo = originalChargeUuidApMap.get(data.originalChargeUuid)
            this._view.beforeAndAfterComparisonDialogBpm.apChargeAfter.push(data)
          }
        }
      }
      this._view.beforeAndAfterComparisonDialogBpm.changeReason = changeCharge.changeReason
      // 整票预估利润
      this._view.beforeAndAfterComparisonDialogBpm.chargeOriginalProfit = []
      this._view.beforeAndAfterComparisonDialogBpm.chargeOriginalProfit = changeCharge.chargeOriginalProfit
      this._view.beforeAndAfterComparisonDialogBpm.chargeChangeProfit = []
      this._view.beforeAndAfterComparisonDialogBpm.chargeChangeProfit = changeCharge.chargeChangeProfit
      this._view.beforeAndAfterComparisonDialogBpm.apTip = changeCharge.apTip
      this._view.beforeAndAfterComparisonDialogBpm.arTip = changeCharge.arTip
      this._view.beforeAndAfterComparisonDialogBpm.visible = true
    }).finally(() => {
      this.loading.close()
    })
  }

  /**
   * 申请删除费用
   *
   */
  applyDeleteCharge(isAr) {
    let charge
    if (isAr) {
      charge = this._view.tabCost.grid.selectedRow
    } else {
      charge = this._view.tabSelling.grid.selectedRow
    }
    if (!charge) return
    this._view.$prompt(this._view.$t('ChangeCharge.changeReason'), this._view.$t('ChangeCharge.confirmApplyDeleteCharge'), {
      confirmButtonText: this._view.$t('common.btn.ok'),
      cancelButtonText: this._view.$t('common.btn.cancel'),
      inputValidator: (value) => {
        if (!value) {
          return this._view.$t('ChangeCharge.changeReasonCannotBeNull')
        }
        if (value.length > 100) {
          return this._view.$t('ChangeCharge.changeReasonIsTooLong')
        }
      },
      inputErrorMessage: this._view.$t('ChangeCharge.changeReasonCannotBeNull')
    }).then(({ value }) => {
      charge.unitRate = -charge.unitRate
      charge.amount = -charge.amount
      charge.taxAmount = -charge.taxAmount
      charge.excludingTaxAmount = -charge.excludingTaxAmount
      const changeCharge = {}
      changeCharge.changeReason = value
      changeCharge.branchId = this._view.currentSettleBranchId
      changeCharge.actionType = 2
      changeCharge.chargeVO = charge
      this.toApplyDeleteCharge(changeCharge)
    }).catch(() => {
    })
  }

  async toApplyDeleteCharge(changeCharge) {
    await createChangeCharge(changeCharge).then(async res => {
      if (res.data) {
        this.$message.success(this._view.$t('CargoMsg.Cargo_OperationSuccessfully'))
        await this.clickHandler1Handler()
      }
    }).catch((err) => {
      this.$message.error(err)
    })
  }

  /**
   * 通过约号带入费用
   *
   */
  generateChargeByContractNo() {
    this.$confirm(this._view.$t('ChangeCharge.generateByContractConfirm'), this._view.$t('common.tips.prompt'), {
      confirmButtonText: this._view.$t('CargoMsg.Cargo_Confirm'),
      cancelButtonText: this._view.$t('CargoMsg.Cargo_Cancel'),
      type: 'warning'
    }).then(() => {
      this.toGenerateChargeByContractNo()
    }).catch(() => {
    })
  }

  async toGenerateChargeByContractNo() {
    const keys = []
    keys.push(this._view.job.uuid)
    const requestBody = { 'keys': keys, location: this._view.location }
    await generateChargeByContractNo(requestBody).then(async res => {
      if (res.data) {
        this.$message.success(this._view.$t('CargoMsg.Cargo_OperationSuccessfully'))
        await this.clickHandler1Handler()
      }
    }).catch((err) => {
      this.$message.error(err)
    })
  }

  /**
   * 新增特殊费用
   *
   */
  async addCostSpecial(editMode, isAr) {
    let obj = null
    if (isAr) {
      obj = this._view.tabCost.grid.selectedRow
    } else {
      obj = this._view.tabSelling.grid.selectedRow
    }
    if (editMode === 'add' || editMode === 'addSpecialUpdate') {
      // 财务归档生效判断
      const warnflag = ArchiveEffectUtils.checkArchiveEffect(this._view.job)
      if (warnflag) {
        this.$message.warning(this._view.$t('CargoMsg.NOT_OPERATIONAL'))
        return
      }
      obj = new Charge().fillDefaultValue().getData()
      obj.specialInputDate = DateUtils.formatStandardDateTime(new Date())
      // 录入日期
      obj.dateCreated = DateUtils.formatStandardDateTime(new Date())
      // BUG-0013 费用所属分公司：从订单上下文取（与普通新增费用一致），不再读跨会话 localStorage 记忆
      obj.branchId = resolveSpecialChargeBranchId(this._view, () => this.getBranchIdForCharge())
      const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(obj.branchId)
      obj.localCurrency = localCurrency
      obj.currency = localCurrency
      // 国内/国外
      if (LocalStorageUtils.hasConfiguration(this.cachePrefix + 'specialChangeoversea') && LocalStorageUtils.getConfiguration(this.cachePrefix + 'specialChangeoversea') !== null) {
        obj.oversea = Boolean(LocalStorageUtils.getConfiguration(this.cachePrefix + 'specialChangeoversea'))
      }
      obj.unitPriceIncludeTax = this._view.config.inputIncludingTaxUnitPrice === 2
    }
    this._view.specialChargeWindow.defaultProperties.editMode = editMode
    this._view.specialChargeWindow.defaultProperties.isAr = isAr
    this._view.specialChargeWindow.defaultProperties.job = this._view.job
    this._view.specialChargeWindow.defaultProperties.charge = obj
    this._view.specialChargeWindow.visible = true
  }

  /**
   * 编辑特殊费用
   *
   */
  editCostSpecial(isAr) {
    let obj = null
    if (isAr) {
      obj = this._view.tabCost.grid.selectedRow
    } else {
      obj = this._view.tabSelling.grid.selectedRow
    }
    if (obj === null) {
      this.$message.info(this._view.$t('Message.Pstsftba'))
      return
    }
    if (!obj.special) {
      this.$message.info(this._view.$t('Message.Nsecbe'))
      return
    }
    this._view.specialChargeWindow.defaultProperties.editMode = 'edit'
    this._view.specialChargeWindow.defaultProperties.isAr = isAr
    this._view.specialChargeWindow.defaultProperties.job = this._view.job
    this._view.specialChargeWindow.defaultProperties.charge = obj
    this._view.specialChargeWindow.visible = true
  }

  /**
   * 新增商务特殊费用（仅应付栏）
   */
  async addCostBusinessSpecial(editMode) {
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this._view.job)
    if (warnflag) {
      this.$message.warning(this._view.$t('CargoMsg.NOT_OPERATIONAL'))
      return
    }
    const obj = new Charge().fillDefaultValue().getData()
    obj.dateCreated = DateUtils.formatStandardDateTime(new Date())
    // 所属分公司：只读，默认订单所属分公司
    obj.branchId = resolveSpecialChargeBranchId(this._view, () => this.getBranchIdForCharge())
    const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(obj.branchId)
    obj.localCurrency = localCurrency
    obj.currency = localCurrency
    obj.receivable = false
    obj.quantity = 1.000
    obj.unitRate = 0.00
    this._view.businessSpecialChargeWindow.defaultProperties.editMode = editMode
    this._view.businessSpecialChargeWindow.defaultProperties.job = this._view.job
    this._view.businessSpecialChargeWindow.defaultProperties.charge = obj
    this._view.businessSpecialChargeWindow.visible = true
  }

  /**
   * 编辑商务特殊费用（仅应付栏，只对商务特殊费用行打开）
   */
  editCostBusinessSpecial() {
    const obj = this._view.tabSelling.grid.selectedRow
    if (obj === null) {
      this.$message.info(this._view.$t('Message.Pstsftba'))
      return
    }
    if (!obj.businessSpecial) {
      this.$message.info(this._view.$t('Message.Nsecbe'))
      return
    }
    this._view.businessSpecialChargeWindow.defaultProperties.editMode = 'edit'
    this._view.businessSpecialChargeWindow.defaultProperties.job = this._view.job
    this._view.businessSpecialChargeWindow.defaultProperties.charge = obj
    this._view.businessSpecialChargeWindow.visible = true
  }

  //
  //   /**
  //    * 应收
  //    */
  getCostIdentifier() {
    //     const str = "com.walltech.charge.ChargeInfo";
    //     if(!job) return str;
    //     if(UserRersonalizeConstants.BASIC.code === identifierType){
    //       if(job.lob === SystemConstants.SE.code)
    //         str = UserRersonalizeConstants.SE_FMBOOKINGNEWBASIC_CHARGEINFO.code;
    //       else if(job.lob === SystemConstants.SI.code)
    //         str = UserRersonalizeConstants.SI_SEAIMPORTMODULEBASIC_CHARGEINFO.code;
    //       else if(job.lob === SystemConstants.AE.code)
    //         str = UserRersonalizeConstants.AE_AEBOOKINGBASIC_CHARGEINFO.code;
    //       else if(job.lob === SystemConstants.AI.code)
    //         str = UserRersonalizeConstants.AI_AIRIMPORTBOOKINGBASICMODULE_CHARGEINFO.code;
    //     }
    //     return str
  }

  //
  //   /**
  //    * 应付
  //    */
  getSellingIdentifier() {
    //     const str = "ubi.charge.ChargeInfo2";
    //     if(!job) return str;
    //     if(UserRersonalizeConstants.BASIC.code === identifierType){
    //       if(job.lob === SystemConstants.SE.code)
    //         str = UserRersonalizeConstants.SE_FMBOOKINGNEWBASIC_CHARGEINFO2.code;
    //       else if(job.lob === SystemConstants.SI.code)
    //         str = UserRersonalizeConstants.SI_SEAIMPORTMODULEBASIC_CHARGEINFO2.code;
    //       else if(job.lob === SystemConstants.AE.code)
    //         str = UserRersonalizeConstants.AE_AEBOOKINGBASIC_CHARGEINFO2.code;
    //       else if(job.lob === SystemConstants.AI.code)
    //         str = UserRersonalizeConstants.AI_AIRIMPORTBOOKINGBASICMODULE_CHARGEINFO2.code;
    //     }
    //     return str
  }

  /**
   * 显示分摊费用
   *
   */
  chkShowSharedChargeHandler(event) {
    if (this._view.checkbox.chkShowSharedCharge.visible) {
      this._view.tabCost.grid.overseaCostDetails = []
      this._view.tabSelling.grid.overseaSellingDetails = []
      this._view.jobControlledCharges = []
      if (this._view.privilege.queryArAllRole || this._view.privilege.queryApAllRole) {
        this.extractCharges(this._view.job)
      } else if (this._view.privilege.queryArDeptChargeRole || this._view.privilege.queryApDeptChargeRole) {
        this.extractDepartmentTeamCharge()
      } else {
        this.extractCurrentUserCharge(this._view.job)
      }
    }
    LocalStorageUtils.setConfiguration(this.cachePrefix + 'showSharedCharges', !(this._view.checkbox.chkShowSharedCharge.selected))
    this.refDgChargeInfo()
  }

  // 保存校验
  validateForm(charges) {
    this.checkAccountId = false
    return this.checkModels(charges)
  }

  chargeCostAdjustEvent() {
    this.updateAccountingDateBtn()
  }

  /**
   * 控制修改财务日期按钮权限,先加载费用
   */
  updateAccountingDateBtn() {
    if (this._view.job != null) {
      if (this._view.job.needLoadForBooking()) {
        // this._view.job.loadForBooking2(this.loadForBookingResultHandler, failureHandler);
      } else {
        this.loadForBookingResultHandler()
      }
    }
  }
  // 同步委托费用
  async syncEntrustChargers(isAr) {
    this._view.loading = getLoading4Cxt(this._view)
    if (this._view.config.openMutualTrustConfig === 1) {
      const items = this._view.tabCost.grid.overseaCostDetails
      if (!items || items.length === 0) {
        this.$message.warning(this._view.$t('Message.PleaseSelectCharges'))
        return
      }
      syncJobCharge(items, this._view.job.jobNo, this._view.location).then(res => {
        if (res.data === 'success') {
          this.$message.warning(this._view.$t('Message.mutualChargeSynchronizationSuccess'))
        } else {
          this.$message.warning(this._view.$t('Message.mutualChargeSynchronizationFault'))
        }
      }).catch().finally(() => {
        this._view.loading.close()
      })
    } else {
      try {
        const res = await syncChargeConfirm({ jobKey: this._view.job.uuid })
        this.$message.success(this._view.$t('queryJob.GenerateXChargeSyncRecords', { num: res.data }))
      } finally {
        this._view.loading.close()
      }
    }
  }
  // 同步费用（出口同步到进口）
  async syncChargesToImportJob(isAr) {
    const job = this._view.job
    if (!job.relatedJob) {
      this.$message.warning(this._view.$t('Message.NotExportToImportBusiness'))
      return
    }
    if (this._view.config.chargeSyncCheckJobState) {
      if (!this._view.config.chargeSyncCheckJobState.includes(job.jobState)) {
        this.$message.warning(this._view.$t('Message.ChargeSyncJobStateCheckFail'))
        return
      }
    } else {
      if (job.jobState !== 0) {
        this.$message.warning(this._view.$t('Message.JobNotOperateStatus'))
        return
      }
      if (job.shutOut) {
        this.$message.warning(this._view.$t('Message.JobShutOut'))
        return
      }
    }
    const loading = getLoading4Cxt(this._view)
    try {
      const res = await syncChargeToImportConfirm({ jobKey: job.uuid, receivable: isAr })
      this.$message.success(this._view.$t('queryJob.GenerateXChargeSyncRecords', { num: res.data }))
    } finally {
      loading.close()
    }
  }
  // 同步费用（进口同步到出口）
  async syncChargesToExportJob(isAr) {
    const job = this._view.job
    if (!job.trustFromJob) {
      this.$message.warning(this._view.$t('Message.NotExportToImportBusiness'))
      return
    }
    if (this._view.config.chargeSyncNeedConfirm) {
      if (this._view.config.chargeSyncCheckJobState) {
        if (!this._view.config.chargeSyncCheckJobState.includes(job.jobState)) {
          this.$message.warning(this._view.$t('Message.ChargeSyncJobStateCheckFail'))
          return
        }
      } else {
        if (job.jobState !== 0) {
          this.$message.warning(this._view.$t('Message.JobNotOperateStatus'))
          return
        }
        if (job.shutOut) {
          this.$message.warning(this._view.$t('Message.JobShutOut'))
          return
        }
      }
    } else {
      if (job.jobState !== 0 && !(job.lob === 'SI' && job.jobState === 2) && !(job.lob === 'AI' && job.jobState === 2)) {
        this.$message.warning(this._view.$t('Message.JobNotOperateStatus'))
        return
      }
      if (job.shutOut) {
        this.$message.warning(this._view.$t('Message.JobShutOut'))
        return
      }
    }
    const loading = getLoading4Cxt(this._view)
    try {
      if (this._view.config.chargeSyncNeedConfirm) {
        const res = await syncChargeToExportConfirm({ jobKey: job.uuid, receivable: isAr })
        this.$message.success(this._view.$t('queryJob.GenerateXChargeSyncRecords', { num: res.data }))
      } else {
        if (job.masterFlag) {
          if (job.lob === 'SI') {
            if (job.containerLoadType === ImportConstants.CON.code) {
              const charges = isAr ? this._view.tabCost.grid.overseaCostDetails : this._view.tabSelling.grid.overseaSellingDetails
              let masterShareTipFlag = false
              for (const charge of charges) {
                if (!charge.apportioned) {
                  masterShareTipFlag = true
                  break
                }
              }
              if (masterShareTipFlag) {
                const isContinue = await this.$confirm(this._view.$t('Message.HaveChargeNotAllocatedAndtoContinue'), this.$t('Message.Prompt'), {
                  confirmButtonText: this.$t('Message.Yes'),
                  cancelButtonText: this.$t('Message.No'),
                  closeOnClickModal: false,
                  type: 'info'
                }).then(() => true).catch(() => false)
                if (!isContinue) {
                  return
                }
              }
            }
          } else if (job.lob === 'AI') {
            if (job.operateType === ImportConstants.CONSOLE.code) {
              const charges = isAr ? this._view.tabCost.grid.overseaCostDetails : this._view.tabSelling.grid.overseaSellingDetails
              let masterShareTipFlag = false
              for (const charge of charges) {
                if (!charge.apportioned) {
                  masterShareTipFlag = true
                  break
                }
              }
              if (masterShareTipFlag) {
                const isContinue = await this.$confirm(this._view.$t('Message.HaveChargeNotAllocatedAndtoContinue'), this.$t('Message.Prompt'), {
                  confirmButtonText: this.$t('Message.Yes'),
                  cancelButtonText: this.$t('Message.No'),
                  closeOnClickModal: false,
                  type: 'info'
                }).then(() => true).catch(() => false)
                if (!isContinue) {
                  return
                }
              }
            }
          }
        }
        const res = await syncImportChargeToExport({ jobKey: job.uuid, receivable: isAr }, this._view.location)
        const total = res.data.total
        const successCount = res.data.successCount
        const failCount = res.data.failCount
        this._view.$alert(
          this._view.$t('queryJob.syncChargesToExportJobMessage', { total, successCount, failCount }),
          this._view.$t('FinanceManage.charge_asyncCharges')
        )
      }
    } finally {
      loading.close()
    }
  }
  // 同步至进口业务
  asyncChargesToImportJob(receivable = true) {
    const message = receivable ? this._view.$t('Message.AsyncReceivableChargesToImportJob') : this._view.$t('Message.AsyncPayableChargesToImportJob')
    this.$confirm(message, this._view.$t('common.tips.prompt'), {
      confirmButtonText: this._view.$t('common.btn.ok'),
      cancelButtonText: this._view.$t('common.btn.cancel'),
      type: 'info'
    }).then(() => {
      asyncChargesToImportJob({ 'jobKey': this._view.job.uuid, 'receivable': receivable, 'location': this._view.location }).then(res => {
        if (res.data) {
          this.$message.warning(this._view.$t('Message.mutualChargeSynchronizationSuccess'))
        } else {
          this.$message.warning(this._view.$t('Message.mutualChargeSynchronizationFault'))
        }
      }).catch()
    }).catch(() => {
    })
  }
  showChargeSyncRecord() {
    if (this._view.editing) {
      this.$message.warning(this._view.$t('FinanceManage.pleaseSaveTheCurrentPageFirst'))
      return
    }
    this._view.chargeSyncRecordDialog.job = this._view.job
    this._view.chargeSyncRecordDialog.visible = true
  }
  showChargeOutSyncRecord() {
    if (this._view.editing) {
      this.$message.warning(this._view.$t('FinanceManage.pleaseSaveTheCurrentPageFirst'))
      return
    }
    this._view.chargeOutSyncRecordDialog.job = this._view.job
    this._view.chargeOutSyncRecordDialog.visible = true
  }
  // 同步云星空
  syncCloudStarrySky(isAr) {
    const rows = this.readSelectedRows(isAr)
    if (rows.length === 0) {
      return
    }
    const chargeKeys = []
    for (const row of rows) {
      if (row.chargeState === ChargeConstants.EAS_STATE_APPROVED.code && (row.jdyxkSyncStatus === ChargeConstants.JDYXK_NOT_SYNC.code || row.jdyxkSyncStatus === ChargeConstants.JDYXK_SYNC_FAIL.code)) {
        chargeKeys.push(row.uuid)
      }
    }
    if (chargeKeys.length === 0) {
      this.$message.warning(this._view.$t('FinanceManage.SyncFeeCannotSyncAgain'))
      return
    }
    const loading = getLoading4Cxt(this)
    jobChargeVerifySyncYXK(this._view.job.uuid, chargeKeys).then(res => {
      this.$message.success(this._view.$t('FinanceManage.SyncCloudSucceededXFailedX', [res.data.successCount, res.data.failCount]))
      this._view.onShow(this._view.job, true)
    }).finally(() => {
      loading.close()
    })
  }
  // 修改费用锁定状态
  modifyChargeLockStatus(receivable = false, lockStatus = 0) {
    modifyChargeLockStatus({ 'jobKey': this._view.job.uuid, 'receivable': receivable, 'lockStatus': lockStatus }).then(res => {
      if (res.data) {
        this._view.job.receivableChargeLockedStatus = res.data.receivableChargeLockedStatus
        this._view.job.payableChargeLockedStatus = res.data.payableChargeLockedStatus
        this._view.job.receivableChargeLockedDate = res.data.receivableChargeLockedDate
        this._view.job.payableChargeLockedDate = res.data.payableChargeLockedDate
        this._view.job.version = res.data.version
        this._view.$emit('ChargeLockStatusChange', res.data)
        if (receivable) {
          this._view.tabCost.grid.gridApi.refreshCells({ force: true }) // 刷新
        } else {
          this._view.tabSelling.grid.gridApi.refreshCells({ force: true }) // 刷新
        }
      }
      this.$message.success(this._view.$t('Message.OperationSuccessfully'))
    }).catch()
  }
  // 初始化结算代理s
  async initSettlementAgentsMap(charges, settlementAgentMap) {
    const accountIds = Array.from(new Set(Array.from(charges, p => p.accountId))).filter(id => !this._view.currentViewCacheData.customerSettlementAgentMap.has(id))
    if (!accountIds || accountIds.length <= 0) return
    if (!settlementAgentMap) {
      const settlementAgentMap = await getSettlementAgentsByCmpIdxList(accountIds).then((res) => { return res.data })
      if (!settlementAgentMap) return
    }
    accountIds.forEach(id => {
      if (!this._view.currentViewCacheData.customerSettlementAgentMap.has(id)) {
        if (settlementAgentMap[id]) this._view.currentViewCacheData.customerSettlementAgentMap.set(id, settlementAgentMap[id])
      }
    })
  }
  // 根据结算对象，获取结算代理
  async getSettlementByCompanyId(charge) {
    const accountId = charge.accountId
    if (!accountId || accountId <= 0) return
    const chargeAccount = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
    if (!chargeAccount) {
      return
    }
    if (this._view.currentViewCacheData.customerSettlementAgentMap.has(accountId)) {
      const staticOptions = this._view.currentViewCacheData.customerSettlementAgentMap.get(accountId)
      const index = staticOptions.findIndex(p => p.uuid === chargeAccount.uuid)
      if (index < 0) {
        if (chargeAccount) {
          staticOptions.push(chargeAccount)
        }
        this._view.currentViewCacheData.customerSettlementAgentMap.set(accountId, staticOptions)
      }
      charge.settlementAgentId = staticOptions[0].cmpIdx
    } else {
      const res = await getSettlementAgentsByCmpIdx(charge.accountId)
      let dbSettlementAgents = res.data
      if (!dbSettlementAgents) dbSettlementAgents = []
      if (chargeAccount) {
        const index = dbSettlementAgents.findIndex(p => p.uuid === chargeAccount.uuid)
        if (index < 0) {
          dbSettlementAgents.push(chargeAccount)
        }
      }
      charge.settlementAgentId = dbSettlementAgents[0].cmpIdx
      this._view.currentViewCacheData.customerSettlementAgentMap.set(accountId, dbSettlementAgents)
    }
  }
  // 修改费用同步确认状态
  updateChargeSyncConfirmStatus(syncConfirmStatus) {
    const items = []
    const rows = this.getAllSelectedRows(false)
    if (rows && rows.length > 0) {
      for (const charge of rows) {
        if (charge.syncConfirmStatus !== syncConfirmStatus && this._view.job.destinationAgent === charge.accountId) {
          items.push(charge.uuid)
        }
      }
    }
    if (!items || items.length === 0) {
      this.$message.warning(this._view.$t('Message.ThereAreCurrentlyNoCancellableCharges'))
      return
    }
    this._view.loading = getLoading4Cxt(this._view)
    updateChargeSyncConfirmStatus(items, syncConfirmStatus, this._view.job.uuid).then(res => {
      this.$message.success(this._view.$t('Message.OperationSuccessfully'))
      this.refreshSyncStatus(items, 'syncConfirmStatus', syncConfirmStatus)
      this.refreshAgGrid(false)
      this.refreshAgGrid(true)
    }).catch().finally(() => {
      this._view.loading.close()
    })
  }
  // 跨租户出转进-费用同步
  crossTenantSEToSICharge(syncStatus) {
    const items = []
    const rows = this.getAllSelectedRows(false)
    if (rows && rows.length > 0) {
      for (const charge of rows) {
        if (((syncStatus === 0 && charge.syncStatus !== syncStatus) || syncStatus === 1) && this._view.job.destinationAgent === charge.accountId && charge.syncConfirmStatus !== 1) {
          if (this._view.job.masterFlag) { // 主票可以查看小票的费用，此时会把小票的费用同步到主票上
            if (charge.jobUuid === this._view.job.uuid) {
              items.push(charge.uuid)
            }
          } else {
            items.push(charge.uuid)
          }
        }
      }
    }
    if (!items || items.length === 0) {
      const msg = syncStatus === 1 ? this._view.$t('Message.CurrentlyThereIsNoSynchronizationCosts') : this._view.$t('Message.NoCurrentChargesCanBeCancelled')
      this.$message.warning(msg)
      return
    }
    this._view.loading = getLoading4Cxt(this._view)
    if (syncStatus === 1) {
      // 同步费用
      syncCrossTenantCharge(items, this._view.job.uuid, this._view.location).then(res => {
        if (!res.data || res.data.length === 0) {
          this.$message.warning(this._view.$t('Message.CurrentlyThereIsNoSynchronizationCosts'))
          return
        }
        this.$message.success(this._view.$t('Message.OperationSuccessfully'))
        this.refreshSyncStatus(res.data, 'syncStatus', syncStatus)
        this.refreshAgGrid(false)
        this.refreshAgGrid(true)
      }).catch().finally(() => {
        this._view.loading.close()
      })
    } else {
      // 取消同步费用
      cancelSyncCrossTenantCharge(items, this._view.job.uuid, this._view.location).then(res => {
        if (!res.data || res.data.length === 0) {
          this.$message.warning(this._view.$t('Message.NoCurrentChargesCanBeCancelled'))
          return
        }
        this.$message.success(this._view.$t('Message.OperationSuccessfully'))
        this.refreshSyncStatus(res.data, 'syncStatus', syncStatus)
        this.refreshAgGrid(false)
        this.refreshAgGrid(true)
      }).catch().finally(() => {
        this._view.loading.close()
      })
    }
  }

  // 应付费用同步
  syncPayableCharge() {
    const rows = this.getAllSelectedRows(false)
    let chargeKeys = []

    if (rows && rows.length > 0) {
      // 有选中的费用，检查是否已同步
      const syncedRows = rows.filter(row => row.isSync === '1')
      if (syncedRows && syncedRows.length > 0) {
        this.$message.warning(this._view.$t('Message.ChargeAlreadySynced'))
        return
      }
      // 同步选中的费用
      chargeKeys = rows.map(row => row.uuid)
    }
    // 没有选中的费用，chargeKeys 为空数组，后端自行查询全部应付费用

    // 二次确认弹窗
    this.$confirm(this._view.$t('Message.ChargeSyncConfirmTip'), this._view.$t('common.tips.prompt'), {
      confirmButtonText: this._view.$t('common.btn.ok'),
      cancelButtonText: this._view.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      this._view.loading = getLoading4Cxt(this._view)
      syncPayableCharge(chargeKeys, this._view.job.uuid, this._view.location).then(res => {
        if (!res.data || res.data.length === 0) {
          this.$message.warning(this._view.$t('Message.CurrentlyThereIsNoSynchronizationCosts'))
          return
        }
        this.$message.success(this._view.$t('Message.OperationSuccessfully'))
        // 重新加载费用页签数据
        this._view.onShow(this._view.job, true)
      }).catch().finally(() => {
        this._view.loading.close()
      })
    }).catch(() => {
      // 点击取消，不做任何操作
    })
  }

  refreshIsSyncStatus(datas) {
    if (datas && datas.length > 0) {
      const rows = this.getAllSelectedRows(false)
      for (const charge of rows) {
        for (const data of datas) {
          if (charge.uuid === data) {
            charge.isSync = '1'
          }
        }
      }
    }
  }

  refreshSyncStatus(datas, field, status) {
    if (datas && datas.length > 0) {
      const rows = this.getAllSelectedRows(false)
      for (const charge of rows) {
        for (const data of datas) {
          if (charge.uuid === data) {
            charge[field] = status
          }
        }
      }
    }
  }
  // EAS费用同步【应收应付通用】
  syncChargeToEas(receivable = false) {
    const allCharges = receivable ? this._view.tabCost.grid.overseaCostDetails : this._view.tabSelling.grid.overseaSellingDetails
    if (!allCharges || allCharges.length <= 0) {
      this._view.$message.warning(this._view.$t('SeaExport.NoEasCharge'))
      return
    }
    // 校验EAS费用状态【已审核的是不需要再同步】
    const charges = allCharges.filter(p => p.externalChargeState !== ChargeConstants.EAS_STATE_APPROVED.code)
    if (!charges || charges.length <= 0) {
      this._view.$message.warning(this._view.$t('SeaExport.CheckEasChargeState'))
      return
    }
    this._view.settlementSelectDialog.type = 'eas'
    this._view.settlementSelectDialog.receivable = receivable
    this._view.tempCharges = charges
    if (charges.length === 1) {
      // 这里直接调用接口
      this.confirmSyncChargeToEas(charges[0].accountId)
    } else {
      const accountMap = new Map()
      const accounts = []
      for (const charge of charges) {
        if (!charge.accountId || accountMap.has(charge.accountId)) continue
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', charge.accountId)
        if (company) {
          accounts.push(company)
          accountMap.set(charge.accountId, company)
        }
      }
      if (!accounts || accounts.length === 0) {
        this.$message.warning(this._view.$t('SeaExport.NotData'))
        return
      }
      if (accounts.length === 1) {
        this.confirmSyncChargeToEas(accounts[0].cmpIdx)
        return
      }
      if (accounts.length > 1) {
        this._view.settlementSelectDialog.title = this._view.$t('Message.SelectTheBillingObject')
        this._view.settlementSelectDialog.accounts = accounts
        this._view.settlementSelectDialog.type = 'eas'
        this._view.settlementSelectDialog.receivable = receivable
        this._view.settlementSelectDialog.visible = true
      }
    }
  }
  // EAS费用同步【应收应付通用】
  confirmSyncChargeToEas(accountId) {
    if (!accountId || parseInt(accountId) <= 0 || !this._view.tempCharges || this._view.tempCharges.length <= 0) return
    // 校验EAS费用状态【已审核的是不需要再同步】
    const charges = this._view.tempCharges.filter(p => p.accountId === accountId)
    if (!charges || charges.length <= 0) {
      this._view.$message.warning(this._view.$t('SeaExport.CheckEasChargeState'))
      return
    }

    // 数据为空验证以及发送放在一个接口，避免重复组装数据
    const params = {}
    params.anyBool = this._view.settlementSelectDialog.receivable // 应收应付
    params.anyInteger = accountId // 结算对象
    params.anyStr = this._view.job.uuid // 业务UUID
    params.keys = Array.from(charges, p => p.uuid) || [] // 费用UUID
    this._view.loading = getLoading4Cxt(this._view)
    syncChargeToEas(params).then(res => {
      const result = res.data
      if (result.success) { // 全部成功
        this._view.$message.success(this._view.$t('Message.SynchronizationSucceeded'))
        this._view.onShow(this._view.job, true)
      } else {
        if (result.checkInfo) { // 验证信息
          this._view.$message.error(result.checkInfo)
          return
        }
        if (result.msg && result.msg !== 'null') { // 调用接口之后返回的信息
          this._view.$message.error(result.msg)
          return
        }
        if (result.msgInfo) { // 调用接口之后返回的信息
          this._view.$message.error(result.msgInfo)
          return
        }
      }
    }).finally(() => {
      this._view.loading.close()
    })
  }

  /**
   * 费用更改申请状态列表转化
   * @param uuid
   * @returns {string|*}
   */
  changeChargeStateLabelFormatter(uuid) {
    if (!uuid || !this._view.chargeChangeStateMap || !this._view.chargeChangeStateMap.hasOwnProperty(uuid)) {
      return ''
    }
    return ColumnUtils.changeChargeStateLabFun(this._view.chargeChangeStateMap[uuid])
  }

  // 隆和金蝶EAS费用推送
  // CARGO-23374 隆和CW系统和金蝶对接
  sendLhJdEas(items, receivable) {
    const charges = []
    for (const item of items) {
      // 已经同步过的，就不能再同步
      if (item.externalChargeState && Number(item.externalChargeState) === Number(ChargeConstants.EAS_STATE_SYNC.code)) {
        continue
      }
      charges.push(item)
    }
    if (charges.length <= 0) {
      this._view.$message.warning(this._view.$t('SeaExport.CheckEasChargeState'))
      return
    }
    const params = {}
    params.anyBool = receivable // 应收应付
    params.anyStr = this._view.job.uuid // 业务UUID
    params.keys = Array.from(charges, p => p.uuid) || [] // 费用UUID
    this._view.loading = getLoading4Cxt(this._view)
    syncChargeToLhEas(params).then(res => {
      const result = res.data
      if (result.success) { // 全部成功
        if (result.successInfo) {
          const content = result.successInfo.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>')
          this._view.$alert(content, this._view.$t('CargoMsg.Cargo_Prompt'), {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this._view.$t('CargoMsg.Cargo_Confirm')
          })
        } else {
          this._view.$message.success(this._view.$t('Message.SynchronizationSucceeded'))
        }
        const chargeIds = result.successChargeIds
        if (chargeIds && chargeIds.length > 0) {
          for (const charge of charges) {
            if (!chargeIds.includes(charge.chargeId)) continue
            charge.externalChargeState = ChargeConstants.EAS_STATE_SYNC.code
            charge.version += 1
          }
        }
        this.refreshAgGrid(receivable)
      } else {
        if (result.checkInfo) { // 验证信息
          const content = result.checkInfo.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>')
          this._view.$alert(content, this._view.$t('CargoMsg.Cargo_Prompt'), {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this._view.$t('CargoMsg.Cargo_Confirm')
          })
          return
        }
        this._view.$message.error(this._view.$t('SeaExport.Synchronization') + this._view.$t('Message.Failure'))
      }
    }).catch((err) => {
      this._view.$message.error(this._view.$t('SeaExport.Synchronization') + this._view.$t('Message.Failure') + ':' + err)
    }).finally(() => {
      this._view.loading.close()
    })
  }

  /**
   * 业务编号显示列
   * @param data
   */
  jobNoLabelFunction(data) {
    let jobNo = this._view.job.jobNo || ''
    if (data && data.jobUuid && this._view.job.uuid && data.jobUuid !== this._view.job.uuid) { // 主票下显示小票的费用
      jobNo = data.jobNo
    }
    return jobNo
  }

  /**
   * 获取应收/应付费用最大序号
   * @param isAr
   * @returns {number}
   */
  getMaxSerialNumber(isAr = true) {
    let max = 0
    const job = this._view.job
    if (job.charges && job.charges.length > 0) {
      for (const c of job.charges) {
        if (RateUtil.useOrderCenterMode() && c.branchId !== this._view.currentSettleBranchId) {
          continue
        }
        if (isAr === c.receivable) {
          if (c.serialNumber > max) {
            max = c.serialNumber
          }
        }
      }
    }
    return max
  }
  /**
   * 显示内结费用
   */
  chkInternalChargeHandler(event = null) {
    const { overseaCostDetails } = this._view.tabCost.grid
    const { overseaSellingDetails } = this._view.tabSelling.grid
    const { jobControlledCharges } = this._view
    for (const charge of this._view.job.charges) {
      if (RateUtil.useOrderCenterMode() && charge.branchId !== this._view.currentSettleBranchId && this._view.settleBranchId > 0) {
        continue
      }
      if (charge.internal) {
        if (this._view.checkbox.chkInternal.selected) {
          if (charge.receivable) {
            const index = overseaCostDetails.indexOf(charge)
            if (index === -1) {
              overseaCostDetails.push(charge)
            }
          } else {
            const index = overseaSellingDetails.indexOf(charge)
            if (index === -1) {
              overseaSellingDetails.push(charge)
            }
          }
          if (jobControlledCharges) {
            const index = jobControlledCharges.indexOf(charge)
            if (index === -1) {
              jobControlledCharges.push(charge)
            }
          }
        } else {
          if (charge.receivable) {
            const index = overseaCostDetails.indexOf(charge)
            if (index > -1) {
              overseaCostDetails.splice(index, 1)
            }
          } else {
            const index = overseaSellingDetails.indexOf(charge)
            if (index > -1) {
              overseaSellingDetails.splice(index, 1)
            }
          }
          if (jobControlledCharges) {
            const index = jobControlledCharges.indexOf(charge)
            if (index > -1) {
              jobControlledCharges.splice(index, 1)
            }
          }
        }
      }
    }
    this.refDgChargeInfo()
  }
  /**
   * 显示结算公司费用
   */
  onSettleBranchIdHandler(value) {
    // if (!value) return
    this._view.settleBranchId = value
    if (this._view.settleBranchId >= 0) {
      sessionStorage.setItem(this._view.cachePrefix + 'settleBranchId.' + this._view.job.uuid, String(this._view.settleBranchId))
      this.queryActualAmountHandler()
    }
  }

  /**
   * 获取费用结算公司
   */
  getBranchIdForCharge() {
    return (this._view.config.currentOfficeCharge && this._view.job.salesOffice) ? this._view.job.salesOffice : this._view.job.opOffice
  }

  /**
   * 新增改单费用
   *
   */
  async addChargeForSales(editMode, isAr) {
    let rows = []
    if (editMode === 'add') {
      this._view.addChargeDialog.defaultProperties.branchId = this._view.privilege.showOtherBranchCharge ? this._view.currentSettleBranchId : this.getBranchIdForCharge()
      this._view.addChargeDialog.defaultProperties.unitPriceIncludeTax = this._view.config.inputIncludingTaxUnitPrice === 2
    } else {
      rows = this.getAllSelectedRows(false)
      if (!rows || rows.length === 0) {
        this.$message.warning(this._view.$t('Message.PleaseSelectCharges'))
        return
      }
      const msg = {}
      for (const data of rows) {
        if (data.billingUuid) {
          msg[this._view.$t('CargoMsg.Cargo_CreateBill')] = true
        }
        if (data.verifiedAmount !== 0) {
          msg[this._view.$t('CargoMsg.Cargo_Verification')] = true
        }
        if (data.offsetState === 1) { // 红冲
          msg[this._view.$t('CargoMsg.Cargo_WriteBack')] = true
        }
        if (data.offsetState === 2) { // 被红冲
          msg[this._view.$t('CargoMsg.Cargo_BeWriteBack')] = true
        }
        if (data.invoiceUuid) {
          msg[this._view.$t('CargoMsg.Cargo_Invoicing')] = true
        }
        if (data.billingPaymentUuid) {
          msg[this._view.$t('CargoMsg.Cargo_PaymentRequest')] = true
        }
        if (data.confirmBillUuid) {
          msg[this._view.$t('CargoMsg.Cargo_ConfirmExpenses')] = true
        }
        if (this.hasGenerateVoucher(data)) {
          msg[this._view.$t('CargoMsg.Cargo_CreateVoucher')] = true
        }
      }
      if (JSON.stringify(msg) !== '{}') {
        const message = []
        for (const key in msg) {
          message.push(key)
        }
        const editModeMsg = editMode !== 'del' ? this._view.$t('SeaExport.EditCharges') : this._view.$t('CargoMsg.Cargo_DeleteFee')
        this.$message.warning(this._view.$t('Message.ApplyChangeChargeNotThrough', [message.join(','), editModeMsg]))
        return
      }
    }
    this._view.addChargeDialog.defaultProperties.editMode = editMode
    this._view.addChargeDialog.defaultProperties.isAdjust = true
    this._view.addChargeDialog.defaultProperties.isAr = isAr
    this._view.addChargeDialog.defaultProperties.companyFactorySigns = []
    if (isAr && this._view.config.arSettlementUnitOptional) {
      this._view.addChargeDialog.defaultProperties.companyFactorySigns = this._view.companyFactorySigns
    }
    this._view.addChargeDialog.defaultProperties.job = this._view.job
    this._view.addChargeDialog.defaultProperties.charge = rows
    this._view.addChargeDialog.visible = true
  }

  /**
   * 展示申请更改中的费用
   */
  showApplyChangingCharge() {
    this._view.changingChargeDetailDialog.visible = true
  }

  /**
   * 移除上下文中的的费用
   * @param removedCharge
   */
  removeChargeForModifiedData(removedCharge) {
    if (!this._view.context || !this._view.context.modifiedData || !this._view.context.modifiedData.charges) return
    let charges = this._view.context.modifiedData.charges
    // 1.先把标记为删除的费用给移除掉
    for (let i = charges.length - 1; i >= 0; --i) {
      const item = charges[i]
      if (item.deleted) {
        charges.splice(i, 1)
      }
    }
    // 2.根据删除费用去缓存中的找，找到以后移除
    if (removedCharge && charges && charges.length > 0) {
      if (removedCharge.uuid) {
        const index = charges.findIndex(p => p.uuid === removedCharge.uuid)
        if (index >= 0) {
          charges.splice(index, 1)
        }
      } else {
        const index = charges.findIndex(p => p === removedCharge)
        if (index >= 0) {
          charges.splice(index, 1)
        }
      }
    }
    if (!charges) charges = []
    this._view.context.modifiedData.charges = charges
    return this._view.context.modifiedData.charges
  }
  // 分摊类型转换
  shareSchemeConvert(row) {
    if (row && (row.apportioned || row.shared)) {
      if (this._view.job) {
        if (this._view.job.masterFlag) {
          return ColumnUtils.shareSchemeFunc(row.shareScheme)
        } else { // 小票的分摊类型，取主票的
          return ColumnUtils.shareSchemeFunc(row.masterShareScheme)
        }
      } else {
        return ColumnUtils.shareSchemeFunc(row.shareScheme)
      }
    }
    return ''
  }
  // 修改费用到期日
  updateDueDate(receivable = false) {
    const items = this.readSelectedRows(receivable, false)
    if (!items || items.length === 0) {
      this.$message.warning(this._view.$t('Message.PleaseSelectCharges'))
      return
    }
    // 判断到期日计算状态，已计算不让再调整
    for (const charge of items) {
      if (charge.dueDirtyDate && charge.dueDirtyDate >= moment().format('YYYY-MM-DD')) {
        continue
      }
      if (charge.dueDate) {
        this.$message.warning(this._view.$t('FinanceManage.RemoveCountFee'))
        return
      }
    }
    this._view.updateDueDateDialogDialog.receivable = receivable
    this._view.updateDueDateDialogDialog.visible = true
  }
  updateRemark(receivable = false) {
    const items = this.readSelectedRows(receivable, false)
    if (!items || items.length === 0) {
      this.$message.warning(this._view.$t('Message.PleaseSelectCharges'))
      return
    }
    this._view.updateRemarkDialog.receivable = receivable
    this._view.updateRemarkDialog.visible = true
  }
  confirmUpdateDueDate(dueDate = null) {
    if (!dueDate) return
    const loading = getLoading4Cxt(this._view)
    const receivable = this._view.updateDueDateDialogDialog.receivable
    // 提交或者取消提交费用
    const items = this.readSelectedRows(receivable, true)
    const chargeKeys = Array.from(items, p => p.uuid)
    const dueDirtyDate = DateUtils.formatStandardDateTime(new Date())
    updateDueDate(chargeKeys, dueDate, dueDirtyDate).then(res => {
      loading.close()
      if (res.data) {
        this.$message.success(this._view.$t('Message.OperationSuccessfully'))
        // 提交成功后刷新数据
        this._view.onShow(this._view.job, true)
      }
    }).catch((err) => {
      loading.close()
      this.failureHandler(err)
    })
  }

  confirmUpdateRemark(remark = null) {
    if (!remark) return
    const loading = getLoading4Cxt(this._view)
    const receivable = this._view.updateRemarkDialog.receivable
    const items = this.readSelectedRows(receivable, true)
    const params = {}
    params.remark = remark // 备注
    params.chargeKeys = Array.from(items, p => p.uuid) // 费用UUID
    updateAppendRemark(params).then(res => {
      loading.close()
      if (res.data) {
        this.$message.success(this._view.$t('Message.OperationSuccessfully'))
        // 提交成功后刷新数据
        this._view.onShow(this._view.job, true)
      }
    }).catch((err) => {
      loading.close()
      this.failureHandler(err)
    })
  }
  async changeAccountCallBack(data) {
    let rows = []
    if (data.isAr) {
      // 应收费用
      rows = this._view.tabCost.grid.gridApi.getSelectedRows()
      for (const d of rows) {
        let rowIndex = 0
        this._view.tabCost.grid.gridApi.forEachNode((node, index) => {
          if (node.data.uuid === d.uuid) {
            rowIndex = node.rowIndex
          }
        })
        let firstAccountId = false
        if (!d.accountId) {
          firstAccountId = true
        }
        const newParams = {
          rowIndex: rowIndex,
          colId: 'accountId',
          data: d,
          field: 'accountId',
          value: data.accountId,
          firstAccountId: firstAccountId,
          originalValue: d.accountId
        }
        d.accountId = data.accountId
        await this.chargeGridItemEditEndHandler(newParams)
      }
    } else {
      // 应付费用
      rows = this._view.tabSelling.grid.gridApi.getSelectedRows()
      for (const d of rows) {
        let rowIndex = 0
        this._view.tabSelling.grid.gridApi.forEachNode((node, index) => {
          if (node.data.uuid === d.uuid) {
            rowIndex = node.rowIndex
          }
        })
        let firstAccountId = false
        if (!d.accountId) {
          firstAccountId = true
        }
        const newParams = {
          rowIndex: rowIndex,
          colId: 'accountId',
          data: d,
          field: 'accountId',
          value: data.accountId,
          firstAccountId: firstAccountId,
          originalValue: d.accountId
        }
        d.accountId = data.accountId
        await this.chargeGridItemEditEndHandler(newParams)
      }
    }
  }

  changeAccountHandler(isAr) {
    let rows = []
    if (isAr) {
      // 应收费用
      rows = this._view.tabCost.grid.gridApi.getSelectedRows()
    } else {
      // 应付费用
      rows = this._view.tabSelling.grid.gridApi.getSelectedRows()
    }
    // 存在勾选项
    if (rows.length === 0) {
      this.$message.warning(this._view.$t('CargoMsg.Cargo_PleaseSelectExpense'))
      return
    }
    for (const row of rows) {
      if (!this.isRowEdit(row)) {
        this.$message.warning(this._view.$t('CargoMsg.Cargo_CanNotEditTips'))
        return
      }
    }
    this._view.changeAccountIdDialog.isAr = isAr
    this._view.changeAccountIdDialog.companyFactorySigns = this._view.companyFactorySigns
    this._view.changeAccountIdDialog.visible = true
  }

  /**
   * 复制费用
   */
  async copyCharge(isAr) {
    let rows = []
    if (isAr) {
      // 应收费用
      rows = this._view.tabCost.grid.gridApi.getSelectedRows()
    } else {
      // 应付费用
      rows = this._view.tabSelling.grid.gridApi.getSelectedRows()
    }
    // 存在勾选项
    if (rows.length > 0) {
      for (const row of rows) {
        if (isAr) {
          await this.copyCost(row)
        } else {
          await this.copySelling(row)
        }
      }
    } else {
      // 不存在勾选项取列表序号最大一条
      if (isAr) {
        // 应收费用
        rows = this._view.tabCost.grid.overseaCostDetails
      } else {
        // 应付费用
        rows = this._view.tabSelling.grid.overseaSellingDetails
      }
      if (rows.length === 0) {
        this.$message.warning(this._view.$t('Message.PleaseSelectTheFeeYouNeedToCopy'))
        return
      }
      let maxRow = rows[0]
      for (const row of rows) {
        if (maxRow.serialNumber < row.serialNumber) {
          maxRow = row
        }
      }
      if (isAr) {
        await this.copyCost(maxRow)
      } else {
        await this.copySelling(maxRow)
      }
    }
  }

  /**
   * 复制应收
   */
  async copyCost(row) {
    const obj = new Charge().fillDefaultValue().getData() // new Charge();
    /* 先将费用加入到列表，在列表中显示出来 */
    this._view.tabCost.grid.overseaCostDetails.push(obj)
    this.addChargeForJob(obj)
    await this.copyBaseCharge(obj, row)
    obj.uuid = this._view.tabCost.grid.uuidPrefixRule + getUuid()
    this._view.jobControlledCharges.push(obj)
    this.$nextTick(() => {
      if (this._view.tabCost.grid.gridApi) {
        const len = this._view.tabCost.grid.overseaCostDetails.length
        this._view.tabCost.grid.gridApi.forEachNode((node, index) => {
          if (len - 1 === index) {
            this._view.tabCost.grid.selectedRow = node.data
            this._view.tabCost.grid.gridApi.setFocusedCell(node.rowIndex, 'serialNumber')
          }
        })
      }
    })
    this.refreshProfitTotalComponent()
    if (this._view.tabCost.grid.gridApi) {
      this._view.tabCost.grid.gridApi.refreshCells({ force: true })
      this.refDgChargeInfo()
    }
  }

  /**
   * 应付费用
   */
  async copySelling(row) {
    const obj = new Charge().fillDefaultValue().getData()
    /* 先将费用加入到列表，在列表中显示出来 */
    this._view.tabSelling.grid.overseaSellingDetails.push(obj)
    this.addChargeForJob(obj)
    await this.copyBaseCharge(obj, row)
    obj.uuid = this._view.tabSelling.grid.uuidPrefixRule + getUuid()
    this._view.jobControlledCharges.push(obj)
    this.$nextTick(() => {
      if (this._view.tabSelling.grid.gridApi) {
        const len = this._view.tabSelling.grid.overseaSellingDetails.length
        this._view.tabSelling.grid.gridApi.forEachNode((node, index) => {
          if (len - 1 === index) {
            this._view.tabSelling.grid.selectedRow = node.data
            this._view.tabSelling.grid.gridApi.setFocusedCell(node.rowIndex, 'serialNumber')
          }
        })
      }
    })
    this.refreshProfitTotalComponent()
    if (this._view.tabSelling.grid.gridApi) {
      this._view.tabSelling.grid.gridApi.refreshCells({ force: true })
      this.refDgChargeInfo()
    }
  }

  /**
   * 复制费用相关信息
   * @param obj
   * @param row
   */
  async copyBaseCharge(obj, row) {
    const job = this._view.job
    obj.receivable = row.receivable
    obj.branchId = this._view.currentSettleBranchId
    obj.serialNumber = this.getMaxSerialNumber(row.receivable) + 1
    obj.ppcc = row.ppcc
    obj.accountId = row.accountId
    obj.invoiceTitle = row.invoiceTitle
    obj.currency = row.currency
    obj.chargeItemId = row.chargeItemId
    if (this._view.config.isSpecialExpenseEntryFunction) {
      const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', row.chargeItemId)
      if (chargeItem && chargeItem.specialExpenseMarker) {
        obj.chargeItemId = 0
      }
    }
    obj.unitRate = row.unitRate
    obj.quantity = row.quantity
    obj.measure = row.measure
    obj.amount = row.amount
    obj.settlementType = row.settlementType
    obj.taxRate = row.taxRate
    obj.taxAmount = row.taxAmount
    obj.excludingTaxAmount = row.excludingTaxAmount
    obj.unitPriceIncludeTax = row.unitPriceIncludeTax
    obj.exchangeRate = row.exchangeRate
    obj.remarks = row.remarks
    obj.settleDepartmentPrefix = row.settleDepartmentPrefix
    obj.oversea = row.oversea
    obj.jobUuid = job.uuid
    obj.inputBy = this.$store.getters.userId
    obj.inputDate = DateUtils.formatStandardDateTime(new Date())
    obj.verifiedAmount = 0
    obj.accountingDate = null
    obj.counterPartyBillingNo = null
    obj.chargeSource = this._view.chargeSource
    obj.chargeState = 0
    if (this._view.config.openHecConfig) {
      obj.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
    }
    const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(this._view.privilege.showOtherBranchCharge ? this._view.currentSettleBranchId : this.getBranchIdForCharge())
    obj.localCurrency = localCurrency
    // HQ币种/汇率
    obj.hqCurrency = RateUtil.getHqCurrency(obj.branchId)
    obj.hqRate = await RateUtil.getForeignExchangeRateByJob(obj.hqCurrency, localCurrency, job, obj.branchId)
    if (obj.accountId && obj.accountId > 0) {
      // 加载结算代理
      await this.getSettlementByCompanyId(obj)
    }
    if (obj.accountId && obj.accountId > 0) {
      // 加载联系人
      await ChargeColumnUtil.getContactsByCompanyId(obj.accountId, this._view.currentViewCacheData)
      // 加载开票抬头
      await this.getTitlesByCompanyId(obj)
    }
  }
  // 刷新利润合计组件
  refreshProfitTotalComponent() {
    // 刷新利润合计
    let profitDataProvider = []
    if (this._view.privilege.showControlledProfit) {
      profitDataProvider = deepClone(this._view.jobControlledCharges)
    } else {
      profitDataProvider = deepClone(this.getTotalCharges())
    }
    this._view.revenueTotalGroup.dataProvider = profitDataProvider
  }
  getCurrencyTotalMap(charges) {
    const map = new Map()
    if (charges && charges.length > 0) {
      for (const charge of charges) {
        const key = charge.currency + '_' + charge.exchangeRate
        if (key) {
          const sourceAmount = this._view.config._isCalculateExcludingAmount ? charge.amount : charge.excludingTaxAmount
          if (sourceAmount && charge.exchangeRate) {
            if (!map.has(key)) {
              map.set(key, { 'sourceTotalAmount': sourceAmount, 'rate': charge.exchangeRate })
            } else {
              const currencyMap = map.get(key)
              const sourceTotalAmount = NumberUtils.ToFixed2(currencyMap.sourceTotalAmount + sourceAmount, 2)
              map.set(key, { 'sourceTotalAmount': sourceTotalAmount, 'rate': charge.exchangeRate })
            }
          }
        }
      }
    }
    return map
  }

  /**
   * 对应付费用进行合并展示
   */
  mergeSellingCharge() {
    if (!this._view.showMergeChargeItemSalesView || this._view.editing) {
      return
    }
    const allSellingCharge = deepClone(this._view.tabSelling.grid.overseaSellingDetails)
    // 获取配置好合并指定费用的收费项目
    const chargeItems = getCacheListByKey(TYPE_NAMES.basic_data_ChargeItem)
    let mergeItem = null
    if (chargeItems && chargeItems.length > 0) {
      for (const chargeItem of chargeItems) {
        if (mergeItem) {
          break
        }
        const targetItemId = chargeItem.targetItemId
        if (!targetItemId || Number(targetItemId) === 0) {
          continue
        }
        mergeItem = chargeItem
      }
    }
    if (!mergeItem) {
      this._view.tabSellingMerge.grid.overseaSellingDetails = allSellingCharge
      return
    }
    // 渠道服务费
    const originalCharges = []
    // 海运费
    const targetCharges = []
    // 除去【渠道服务费】【海运费】之外的费用
    const otherCharges = []
    let count = 0
    for (const selling of allSellingCharge) {
      const itemId = selling.chargeItemId
      if (!itemId || Number(itemId) === 0) {
        continue
      }
      if (itemId === mergeItem.itemId) { // 获取渠道服务费
        originalCharges.push(selling)
      } else if (itemId === mergeItem.targetItemId) { // 获取海运费
        targetCharges.push(selling)
      } else { // 其它费用
        count++
        selling.serialNumber = count
        otherCharges.push(selling)
      }
    }
    // 1、仅录入海运费，没有录入渠道服务费时，不拦截
    if (originalCharges.length === 0 && targetCharges.length > 0) {
      this._view.tabSellingMerge.grid.overseaSellingDetails = allSellingCharge
      return
    }

    // 2、录入了渠道服务费时，需要校验“（1）海运费需要存在，（2）海运费与渠道服务币种相同，（3）海运费与渠道服务费数量相同“
    if (originalCharges.length > 0) {
      // （1）海运费需要存在
      if (targetCharges.length === 0) {
        this._view.tabSellingMerge.grid.overseaSellingDetails = otherCharges
        return
      }
      // 渠道服务费 数量
      let originalQuantity = 0.0
      // 渠道服务费 总金额
      let originalAmount = 0.0
      for (const originalCharge of originalCharges) {
        for (const targetCharge of targetCharges) {
          // （2）海运费与渠道服务币种相同
          if (originalCharge.currency !== targetCharge.currency) {
            this._view.tabSellingMerge.grid.overseaSellingDetails = otherCharges
            return
          }
        }
        originalQuantity += originalCharge.quantity
        originalAmount += originalCharge.amount
      }
      // 海运费 数量
      let targetQuantity = 0.0
      for (const target of targetCharges) {
        targetQuantity += target.quantity
      }
      // （3）海运费与渠道服务费数量相同
      if (NumberUtils.ToFixed2(originalQuantity, 3) !== NumberUtils.ToFixed2(targetQuantity, 3)) {
        this._view.tabSellingMerge.grid.overseaSellingDetails = otherCharges
        return
      }
      // 通过上述校验后，对费用进行合并
      // 1、计算渠道服务费的总单价
      const originalUnitRate = NumberUtils.ToFixed2(originalAmount / originalQuantity, 3)
      for (const targetCharge of targetCharges) {
        // 先算海运费的单价，解决单价含税的问题
        targetCharge.unitRate = NumberUtils.ToFixed2(targetCharge.amount / targetCharge.quantity, 3)
        // 再将渠道服务费的单价进行累计
        targetCharge.unitRate = NumberUtils.ToFixed2(targetCharge.unitRate + originalUnitRate, 3)
        // 计算总金额
        targetCharge.amount = NumberUtils.ToFixed2(targetCharge.unitRate * targetCharge.quantity, 3)
        otherCharges.push(targetCharge)
      }
    }
    // 重新计算序号
    let serialNumber = 0
    for (const otherCharge of otherCharges) {
      serialNumber++
      otherCharge.serialNumber = serialNumber
    }
    this._view.tabSellingMerge.grid.overseaSellingDetails = otherCharges
    this._view.checkbox.chkLcLCharge.selected = false
    this._view.checkbox.chkOffset.selected = true
  }

  /**
   * 销售角色可选结算对象范围外的显示星号
   */
  checkCustomerSalesDisplayStar(accountId = 0) {
    let displayStar = false
    if (this._view.customerSalesDisplay && this._view.customerSalesCmpList && this._view.customerSalesCmpList.filter(item => item.cmpIdx === accountId).length === 0) {
      displayStar = true
    }
    return displayStar
  }
  /**
   * 对账差异处理
   */
  reconciliationDiff(receivable = false) {
    this._view.reconciliationDiffDialog.chargeKeys = []
    const items = this.readSelectedRows(receivable, false)
    if (!items || items.length === 0) {
      this.$message.warning(this._view.$t('Message.PleaseSelectCharges'))
      return
    }
    for (const row of items) {
      if (row.reconciliationState === ChargeConstants.RECONCILIATION_STATE_NOT_SAME.code) {
        this._view.reconciliationDiffDialog.chargeKeys.push(row.uuid)
      }
    }
    if (this._view.reconciliationDiffDialog.chargeKeys.length === 0) {
      this.$message.warning(this._view.$t('CargoMsg.Cargo_ReconciliationDiffConfirmTip'))
      return
    }
    this._view.reconciliationDiffDialog.receivable = receivable
    this._view.reconciliationDiffDialog.visible = true
  }
  confirmReconciliationDiff(reason = null) {
    if (!reason) return
    const loading = getLoading4Cxt(this._view)
    const params = {}
    params.remark = reason // 原因
    params.chargeKeys = this._view.reconciliationDiffDialog.chargeKeys // 费用UUID
    reconciliationDiffConfirm(params).then(res => {
      loading.close()
      if (res.data) {
        this.$message.success(this._view.$t('Message.OperationSuccessfully'))
        // 刷新数据
        this._view.onShow(this._view.job, true)
      }
    }).catch((err) => {
      loading.close()
      this.failureHandler(err)
    })
  }
  /**
   * 丰收客户销售模块个性化控制
   */
  fsSalesPersonalizedControl(charge) {
    if (this._view.customerSalesDisplay && this._view.customerSalesCmpList && this.checkCustomerSalesDisplayStar(charge.accountId)) {
      return true
    }
    return false
  }
  /**
   * 报价确认或取消操作
   */
  businessQuotationChange(state) {
    const items = this.readSelectedRows(false, false)
    if (!items || items.length === 0) {
      this.$message.warning(this._view.$t('Message.PleaseSelectCharges'))
      return
    }
    const chargeKeys = []
    for (const item of items) {
      if (state) {
        // 报价确认
        if (item.businessQuotationConfirmd) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OperationAllowedOnlyForUnconfirmedQuotation'))
          return
        }
      } else {
        // 取消报价确认
        if (item.businessQuotationAmount <= 0 || !item.businessQuotationConfirmd) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OperationAllowedOnlyForConfirmedNonZeroQuotation'))
          return
        }
      }
      chargeKeys.push(item.uuid)
    }
    const loading = getLoading4Cxt(this._view)
    businessQuotationFunc({ keys: chargeKeys, anyBool: state }).then(res => {
      if (res && res.ok) {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
      }
    }).finally(() => {
      loading.close()
    })
  }
}
